const zh = {
	storeManagement: {
		onvkg: '请选择盘点的卖家',
		hginvlg: '请选择',
		gnivn: '请选择卖家',
		ggru: '请选择仓库类型',
		yhgnmv: '剩余产品数量',
		okmv: '剩余总体积',
		hvkfb: '剩余总重量',
		rjbjh: '已审核(未出库)数量',
		trbv: '未发货数量',
		ggdfj: '立即转移',
		cancel: '取 消',
		yriunv: '确 认',
		ivnkf: '修改产品库存',
		ikgkvj: '请输入修改库存的理由（必填项）',
		plhjkv: '全 部 展 开',
		tjbvl: '全 部 收 起',
		uhjvhjf: '搜索仓库编码，sku，产品名称',
		oknvk: '整仓导出',
		ivlionr: '仓库盘点',
		uymbk: '仓 库 母 Sku：',
		oknhgh: '展 开/ 收 起',
		kfiuhkg: '仓库子sku数量：',
		rhukfh: '剩余在仓总库存：',
		yttnkv: '卖家名称：',
		ighkv: '体积：',
		ibvnkf: '仓位：',
		oplmg: '仓库子sku：',
		iomnlgn: '保 存',
		fiklnmv: '编 辑',
		ouhkngj: '查看库存日志',
		thbjv: '库存日志',
		kihk: '订单变化总数',
		ponkn: '库存变化',
		dfggjk: '变化原因',
		kgnmv: '变化时间',
		fihgk: '最新在仓库存',
		oooou: '关 闭',
		opmngh: '库 存 管 理',
		ijkj: '单品库',
		oikl: '组合库',
		ppki: '赠品库'




	},
	scanIntoStoreage: {
		ivnfiln: '入库单号：',
		vklnf: '卖家：',
		oeknv: '卖家采购总数：',
		oevlknv: '仓库核对总数：',
		obvpkf: '仓库额外附加费用：',
		mmnnkv: '重置入库单',
		wiubvm: '重新核对',
		ornkf: '确认入库',
		wecbdk: '仓库已确认',
		ovmoinv: '卖家提醒',
		ytbm: '数量异常',
		rebcd: '卖家留言',
		rebcj: '产品的长/宽/高，重量是必填',
		nnbhg: '卖家所填数 和 实际收货数 不一致，确认收货吗？',
		trbvcm: '是的',
		pomv: '取消',
		aswvcx: '确认收货吗？',
		dthj: '已成功提交给卖家确认！',
		efhn: '当前入库单没有采购此产品！',
		treybvc: '请扫描入库单号',
		qwefc: '请扫描产品条形码',

	},
	distrustOrder: {
		returnMangement: '退 换 货 管 理',
		scan: '订单号，运单号扫描区',
		status: '退货状态：',
		sellerConfirm: '待卖家核实退货',
		hasConfirm: '卖家已确认',
		aleadyAudit: '已处理',
		orderSearch: '订单号搜索',
		serach: '搜索',
		orderId: '订单号',
		orderStatus: '订单状态',
		createdTimed: '下单时间',
		tosellerconfirm: '待卖家确认',
		delete: '删除',
		position: '仓位：',
		cuscode: '仓库编码',
		originsku: '所属单品',
		purchaseNum: '购买数量',
		jvknf: '配置数量',
		inlnv: '卖家要求处理方式：',
		konmkf: '上架数量：',
		lkndv: '仓库实际处理方式：',
		oknlv: '配置数量：',
		knvtr: '收到包裹',
		knvfvtr: '待卖家确认',
		pkjnmg: '待仓库确认',
		bbnkf: '仓库备注:',
		pombkg: '卖家备注:',
		bbvmkmg: '填写收到退货信息',
		okjnmv: '给卖家留言',
		momf: '点击上传',
		gytnv: '只能上传jpg/png文件，且不超过8M',
		cancel: '取 消',
		confirmBtn: '确 认',
		okgnv: '退货包裹',
		loknv: '提 交',
		kvnkf: '给卖家留言(非必填)',
		ovbhkng: '暂无订单,请扫描录入！',

	},
	processed: {
		cargoflow: '自建单发货物流',
		Thesellernote: '卖家备注',
		Chooselogistics: '选择物流',
		bulk: '体积/cm',
		length: '长/cm',
		width: '宽/cm',
		height: '高/cm',
		weight: '重量/kg',
		actualfreight: '实际运费',
		waybillnumber: '运单号',
		cancel: '取消',
		confirm: '确认',
		Scanningoutbound: '扫描出库',
		Orderarea: '订单号或运单号 扫描区',
		Dateofpackaging: '打包日期',
		outboundorders: '出库订单总数',
		Themodified: '用户修改过的订单',
		enterheight: '请输入高度',
		enterlength: '请输入长度',
		enterwidth: '请输入宽度',
		selectlogistics: '请选择物流',
		enterweight: '请输入重量',
		Logisticsdelivery: '已提交自建单的物流发货信息！',
		redasterisk: '红色星号为必填项，请填入！',
		remarkspresent: "暂无卖家备注",
		details: '，请核实订单详细信息！',
		hint: '提示',
		Isee: '我知道了',
		Processedorder: '已处理订单',
		optiondate: '选择日期',
		startdate: '开始日期',
		dateclosed: '结束日期',
		ordernumber: '订单编号',
		Findnumber: '查找订单号',
		find: '查找',
		Warehouse: '仓库扫描出库(海外仓使用)',
		Quantity: '出库订单数量',
		Numberof: '出库后取消数',
		Expresscollection: '快递揽收数',
		money: '金额',
		deliveryfee: '出库费',
		operation: '操作',
		ViewOrder: '查看订单',
		Exportorders: '导出订单',
		Print: '打印快递签单',
		all: '全部',
		Platformtype: '平台类型:',
		single: '自建单',
		Select: '选择仓库:',
		Typofseller: '卖家类型:',
		Logisticstype: '物流类型:',
		Thegetsall: '卖家获取所有已处理的订单',
		RecordDetails: '打包纪录详情',
		Couriername: '快递名称',
		firstheavy: '首重kg',
		heavycost: '首重费用rmb/kg',
		Continuedheavy: '续重rmb/kg',
		chargemode: '计费方式',
		volumeweight: '体积重',
		Takeofboth: '两者取最大',
		actualweight: '实际重量',
		actualvolume: '实际体积',
		actualcharges: '实际扣费',
		integral: '积分',
		Actualexpressfee: '实际快递费',
		currency: '货币',
		Totalorders: '订单总数',
		Reprintthesheet: '重新打印面单',
		once: '次',
		Unscannedoutgoing: '未扫描出库',
		LanShoutime: '揽收时间',
		NotLanShou: '未揽收',
		Printcode: '打印产品SKU条形码',
		Printentry: '打印入库单条形码',
		Barcodeprinting: '条形码打印',
		printingquantity: '打印数量',
		Scanincoming: '扫描入库',
		Thesellerside: '卖家方',
		Estimatedvolume: '预计总体积',
		viewdetails: '查看详情',
		Guidethe: '导 出',
		Checkcurrency: '查看设置汇率',
		summary: '概要',
		local: '已减去平台费及派送费用，包括平台活动额外佣金费等（即店铺钱包实际收入，且为人民币，具体汇率可用户自己设置）',
		localt: '采购成本，头程运费，按先进先出核算毛利润（即不同批次 空运海运费占用不同成本，且为人民币，具体汇率可用户自己设置）',
		localth: '按会计价值，区分了实际采购价与路途运输成本（货物运输到不同国家将因为运输而增值，且为人民币，具体汇率可用户自己设置）',
		shopId: '商店ID',

		shopName: '商店名称',
		country: '国家',
		platform: '平台',
		turnover: '已付款订单金额',
		advCost: 'Shoppe广告费',
		returnAmount: '退货订单应退款金额',
		orderCount: '所有订单(含待付款)',
		orderItemCount: '已付款订单商品销量',
		outboundCount: '出库订单总数',
		outboundItemCount: '出库商品总数',
		shipCost: '出库商品所占头程费',
		costCount: '出库产品所占采购成本',
		Warehousestatus: '仓库-库存状况',
		storeid: '仓库ID',
		storeName: '仓库名称',
		volume: '体积(m³)',
		cost: '货物成本',
		unshipped: '未处理产品数',
		skunum: 'sku数量',
		storenum: '在仓库存总数量',
		weight: '在仓总重量(kg)',
		auditedstock: '已审核数量',
		expenditurecc: '积分收入支出概况',
		payType: '付款类型',
		changeIntegral: '金额',
		operation: '操作',
		chart: '趋势图',
		exchangerate: '汇率',
		Modifyrate: '修改汇率',
		latestcurrency: '最新汇率',
		newexchange: '请输入新的汇率',
		wechat: '微信充值支出',
		Wechatincome: '微信充值收入',
		Spendingorder: '订单支出',
		Orderincome: '订单收入',
		expenditure: '入库单支出',
		alipay: '支付宝充值支出',
		Alipayincome: '支付宝充值收入',
		Receiptentry: '入库单收入',
		rentalexpenses: '仓租费支出',
		SMSscore: '短信积分支出',
		Smart: '智能客服支出',
		Spendingtranslation: '翻译支出',
		handlingexpenses: '退货处理支出',
		Returnincome: '退货处理收入',
		rentalincome: '仓租费收入',
		freightexpenses: '头程运费支出',
		revenue: '头程运费收入',
		Preferentia: '优惠支出',
		Preferentialincome: '优惠收入',
		SMSrevenue: '短信积分收入',
		Inventory: '库存产品费用支出',
		productincome: '库存产品费用收入',
		Customerexpenses: '客户投诉费用支出',
		complaintrevenue: '客户投诉费用收入',
		Revenueservice: '智能客服收入',
		Translationincome: '翻译收入',
		Logisticsexpenses: '自建单物流费支出',
		Logisticsfee: '自建单物流费收入',
		Cashspending: '返现支出',
		Cashbackincome: '返现收入',
		Cashspendings: '提现支出',
		Cashincome: '提现收入',
		temporalinterval: '日期区间',

	},

	stockProduct: {
		singlePro: '仓库单品',
		combo: '仓库套餐',
		gift: '仓库赠品',
	},
	chat: {
		Allthequery: '查询全部',
		Querymessage: '查询消息',
		QueryingCustomername: '查询客户名',
		Authorizedshops: '授权店铺',
		Allunreadmessages: '全部未读消息',
		Topnews: '置顶消息',
		Thailand: '泰国',
		thePhilippines: '菲律宾',
		Malaysia: '马来',
		Indonesia: '印尼',
		Singapore: '新加坡',
		Taiwan: '中国台湾',
		Vietnam: '越南',
		Pleasefirst: '请先授权店铺',
		Managementgroup: '管理分组',
		Synchronizesessions: '同步shopee会话',
		Clickon: '点击消息可以进行翻译',
		Chinese: '中文',
		English: '英文',
		intoEnglish: '翻译为英语',
		intoVietnamese: '翻译为越南语',
		intoChinese: '翻译为中文',
		intoIndonesian: '翻译为印尼语',
		intoSpanish: '翻译为西班牙语',
		intoPortuguese: '翻译为葡萄牙语',
		original: '显示原文',
		commodity: '商品',
		order: '订单',
		product: '产品',
		Ordercreationtime: '订单创建时间',
		DatetoPull: '发货日期',
		why: '为何使用官方授权的Shopee多店聊?',
		reply: '开启自动回复',
		response: '自动回复',
		Automaticsetting: '自动回复日期设置',
		Modifyreply: '修改自动回复内容',
		Addcontent: '添加自动回复内容',
		Pleasereply: '请输入自动回复内容',
		cancel: '取消',
		confirm: '确定',
		Recommended: '推荐回复',
		Fastreply: '快捷回复',
		Machineresponse: '机器学习回复',
		beenmatched: '暂未匹配到回复',
		searchresult: '搜索结果',
		copy: '复制',
		back: '返回',
		Monday: '星期一',
		Tuesday: '星期二',
		Wednesday: '星期三',
		Thursday: '星期四',
		Friday: '星期五',
		Saturday: '星期六',
		Sunday: '星期日',
		CreateReply: '新建快捷回复',
		issueofstandards: '标准问题',
		messagetranslation: '开启消息自动翻译',
		language: '语言',
		send: '发送',
		translate: '翻译',
		original: '原文',
		Orderdata: '订单数据',
		completed: '完成',
		canceled: '已取消',
		transport: '运送中',
		uNPAID: '未付款',
		rEADY_TO_SHIP: '待出货',
		tO_CONFIRM_RECEIVE: '待签收',
		pROCESSED: '已处理',
		pending: '正在取消',
		stepone: '步骤1',
		modification: '修改',
		entercontent: '请输入内容',
		cancellationorder: '取消订单',
		cause: '请选择取消订单原因',
		Nouser: '暂无用户订单数据',
		Nouserportrai: '暂无用户画像数据',
		category: '类别',
		powerofconsumption: '消费能力',
		Totalconsumption: '总消费金额',
		common: '普通',
		Priceinsensitive: '价格不敏感',
		pricesensitive: '价格敏感',
		Highspendingpower: '高消费力',
		lowconsumption: '低消费力',
		Loyalty: '忠诚度',
		Numbeconsumption: '订单数（消费次数）',
		rejectedorders: '订单拒收数',
		consumptioninterval: '平均消费时间间隔',
		Consumptioratio: '相对类目均价平均消费溢价比',
		Lastdate: '最近一次消费至今间隔',
		day: '天',
		Qamanagement: '问答管理',
		Selectgroup: '选择分组',
		questions: '问答',
		searchquestion: '请输入搜索的问题',
		operationexecutive: '操作',
		search: '搜索',
		groupingmanagement: '分组管理',
		Thenewgrouping: '新增分组',
		grouping: '分组',
		compile: '编辑',
		delete: '删除',
		Addanswer: '添加问答',
		groupname: '请输入分组名称',
		Pleaseentername: '请输入新的分组名称',
		Thenewanswers: '新建问答',
		enterthekeyword: '请输入关键字查找问题',
		Thai: '泰文',
		Malay: '马来文',
		Similarproblems: '相似问题',
		add: '增加',
		answer: '答案',
		revert: '回复',
		thecurrentgroup: '为当前分组添加问答',
		Modifytheq: '修改问答',
		issue: '问题',
		Addanewcustomgroup: '添加新的自定义分组',
		Groupdescription: '分组描述',
		Addtogroup: '添加到分组',
		Pleaseselectgroup: '请选择分组(必填)',
		Addgroup: '添加分组',
		AddingaNewGroup: '添加新的分组',
		Userstories: '用户描述',
		hint: '提示',
		Vietnamese: '越南语',
		Indonesian: '印尼语',
		spanish: '西班牙语',
		Portuguese: '葡萄牙语',
		image: "[图片]",
		order: "[订单]",
		item: "[商品]",
		sticker: "[贴图]",
		successfullyadded: '添加成功',
		successfullyset: '设置成功',
		tips: '已开启自动回复，将自动匹配问答管理，无法匹配则回复“自动回复内容”',
		hasbeendisabled: '已关闭自动回复',
		Sessionsucceeded: '会话同步成功',
		additionfailed: '添加失败',
		Noisavailable: '暂无匹配结果',
		modifysuccessfully: '修改成功',
		changefailed: '修改失败',
		cancelledsuccessfully: '取消订单成功',
		Copysuccess: '复制成功',
		successfullydelete: '删除成功',
		failtodelete: '删除失败',
		beempty: '问题和答案不能为空',
		Confirmtoclose: '确认关闭？',
		Pleaseenterandmodify: '请输入再修改',
		succeed: '成功',
		sentsuccessfully: '发送商品信息成功',
		Failepicture: '上传图片失败',
		Cancelledsend: '已取消发送',
		stick: '置顶',
		Setasunread: '设为未读',
		Deletethesession: '删除会话',
		cancelauthorization: '取消授权',
		Suretomodify: '确定修改',
		AddquickReplies: '添加快捷回复',
	},//多店聊模块
	allorders: {
		verification: "亲，您还没有绑定shopee的商店哦！",
		notbound: "亲，您还没有绑定shopee的商店哦！",
		shopx: '前往绑定shopee商店！',
		allorder: '全部订单',
		rengtime: '订单时间范围：',
		regions: '国家地区',
		Platform: '平台类型',
		Sestore: '选择店铺',
		Ordertype: '订单类型',
		orderscheduling: '订单排序',
		Orderfind: '订单查找',
		SHOPEE: 'SHOPEE',
		LAZADA: 'LAZADA',
		manualorder: '自建手工单',
		all: '全部',
		nopayment: '未付款',
		audit: '待审核',
		insanity: '已审核',
		collected: '快递已揽收',
		until: '到',
		starttime: '开始日期',
		endtime: '结束日期',
		find: '查找',
		lookup: '输入订单号查找',
		Batcorders: '订单批量导出',
		modified: '用户修改过的订单',
		item: '单品',
		setmeal: '套餐',
		theitem: '所属单品',
		quantity: '购买数量',
		description: '暂无',
		Morehere: '向下展开更多',
		Hideup: '向上隐藏',
		latestweek: '最近一周',
		Lastmonth: '最近一个月',
		Lastthreemonths: '最近三个月',
		phonenumber: '电话号码',
		detailedaddress: '详细地址',
		SkuNumbers: 'Sku数量',
		officialreceipts: '实收',
		timepayment: '付款时间',
		feature: '点击关闭 tooltip 功能',
		Steamquantity: '待发数量',
		Onlineinventory: '线上库存',
		understock: '库存不足',
		Shopchoose: '店铺选择',
		Theshipment: '剩余发货',
		Thecontaining: '订单包含',
		pleasechoose: '请选择',
		show: '显示',
		hide: '隐藏',
		Themarks: '订单标记',
		nomarks: '无标记',
		Themultiple: '开启多选模式',
		Isee: '我知道了',
		Therepository: '当前选中的审核仓库',
		typegoods: '货物类型',
		warehouse: '审核类型为测品仓时，必填',
		pastesheet: '是否代贴单',
		Batchopen: '批量开启',
		cause: '开启',
		Synchronizingorder: '同步单个订单号',
		can: '可设置按店铺自动审核订单到指定仓库',
		Unboundproduct: '未绑定仓库产品',
		relationship: '变更绑定关系',
		Tobind: '去绑定',
		emptyproducts: '空包产品',
		Deleteorder: '删除自建订单',
		Hiddenorder: '隐藏订单',
		Accordingorder: '显示订单',
		Restoreorder: '还原订单',
	},

	homeTwo: {

		title: '商店/仓库-概况',
		width: '宽',
		Wholewarehousetransferinventoryandcorrespondingrelationship: '整仓转移库存及对应关系',
		whitelist: '白名单',
		weight: '重量',
		Waybillnumber: '运单号',
		Warehousetype: '仓库类型',
		Warehousescanout: '仓库扫描出库（海外仓使用）',
		Warehousemothersku: '仓库母sku',
		Warehousemother: '仓库母',
		Warehousemessage: '仓库留言',
		Warehousecode: '仓库编码',
		Warehouse: '入库仓库',
		volume: '体积',
		vkf: '操作帮助',
		Viewselleroffers: '查看卖家优惠',
		Viewpreaccountedpointsdetails: '查看预占积分明细',
		Viewpointsdetails: '查看积分明细',
		Viewinventorydiary: '查看库存日记',
		View: '查看/修改',
		Userportrait: '用户画像',
		Unpaid: '未付款',
		Unmarked: '无标记',
		Unfold: '展开/收起',
		Turnonautomaticmessagetranslation: '开启消息自动翻译',
		Turnon: '开启',
		Transportationcosts: '运输费用',
		translation: '翻译',
		Totalsales: '总销量',
		Totalremaininginventory: '剩余在仓总库存',
		totalpoints: '总积分',
		Totalpayment: '总付款',
		Totalinventory: '总库存',
		Totalcurrentpurchases: '当前采购总数',
		Totalconsumptionamount: '总消费金额',
		ToProcess: '泰国仓库',
		ToCheck: '待审核订单',
		Tobeconfirmedbytheseller: '待卖家确认',
		Thesellerhasbeendetermined: '卖家已确定',
		Theintervalbetweenthelastconsumptionandthepresent: '最近一次消费至今间隔',
		Thaiselleruser: '泰国卖家用户',
		Thailandwarehouse: '泰国仓库',
		Thailandtestwarehouse: '泰国测品仓',
		Thailanddistributionwarehouse: '泰国分销仓(测试)',
		Thailand: '泰国',
		Thail: '泰国',
		Testingwarehouse: '测品仓',
		TechnicalSupport: '技术支持',
		Synchronizeshopeeconversation: '同步shopee对话',
		Successfullyreceived: '成功接收',
		Successfullypaidtheorder: '成功支付订单',
		Successfullyclaimedorder: '已索赔成功-订单',
		Successful: '已索赔成功订单',
		Subwarehouse: '当前仓库帐号下的子仓',
		SubInspection: '订单号',
		StoreName: '店铺名称',
		Stockreceipt: '入库单管理',
		Stockmanage: '库存管理',
		Spotinventory: '现货库存量',
		Spendingpower: '消费能力',
		Specificationname: '规格名',
		SmartChat: '管理分组',
		Singleproductlibrary: '单品库',
		Singleproduct: '单品或套餐',
		signout: '退出登录',
		Signforreminder: '签收催评',
		Showresults: '效果展示',
		Shopfilter: '商店筛选',
		Shop: '店铺',
		Shippingwarehouse: '发货仓库',
		Shipmentreminder: '发货提醒',
		Setupselleroffers: '设置卖家优惠',
		Setupanemptypackage: '设置空包',
		Setmeal: '套餐',
		Senttogether: '共发送',
		Sensitivegoodsbyland: '陆运敏感货',
		send: '发送',
		Sellingprice: '售价',
		Sellerusercurrentlybound: '当前绑定的卖家用户',
		Sellertype: '卖家类型',
		Sellerside: '卖家方',
		Sellerpurchasequantity: '卖家采购数量',
		Sellernotes: '卖家备注',
		SellerMessage: '卖家留言',
		Seller: '卖家',
		Selfbuiltorder: '自建单',
		Selfbuiltmanualorder: '自建手工单',
		Selectstorage: '选中入库',
		Selectdate: '选择日期',
		selectall: '全选/反选',
		seedetails: '查看详情',
		Search: '搜索仓库编码，sku，产品名称',
		Scanarea: '扫描区',
		Returnstatus: '退货状态',
		ReturnsManagement: '退换货管理',
		return: '返回',
		Resetthepickedquantity: '重置拣货数量',
		Resetorder: '重置订单',
		Required: '必填',
		Remindertype: '提醒类型',
		Reminder: '催付提醒',
		Remarks: '备注',
		Remainingdeliverytimefrommoretoless: '剩余发货时间由多到少',
		Remainingdeliverytimefromlesstomore: '剩余发货时间由少到多',
		Remainingdeliverytime: '剩余发货时间',
		Relative: '相对类目均价平均消费溢价比',
		Rechargenow: '立即充值',
		Receivefailed: '接收失败',
		reasonsforreturn: '退货原因',
		Questionandanswermanagement: '问答管理',
		Quantitypicked: '拣货数量',
		Quantity: '数量',
		Pushtime: '推送时间',
		Purchasequantityinteger: '采购数量（整数）',
		Purchasequantity: '购买数量',
		productstatus: '产品状态',
		productname: '产品名称',
		Productcollection: '产品采集',
		Processed: '已处理',
		Processed: '已处理订单',
		Privatewarehouse: '私有仓',
		Printthecouriersign: '打印快递签单',
		printingtime: '打印时间',
		Printbarcode: '打印条形码',
		Pricesensitivity: '价格敏感度',
		Pricesensitive: '价格敏感',
		Priceinsensitive: '价格不敏感',
		Presale: '是否预售',
		Preemptivepoints: '预占积分',
		Position: '仓位',
		PointsAvailable: '可用积分',
		Platformtype: '平台类型',
		Personalcenter: '个人中心',
		Pendingthesellertoverifythreturn: '待卖家核实退货',
		Pendingreview: '待审核',
		Paymenttime: '付款时间',
		paymentsuccessful: '成功支付',
		Packingdate: '打包日期',
		OverseasWarehouseComplaintCenter: '海外仓投诉中心',
		Outboundfee: '出库费',
		ordinary: '普通',
		OrderType: '订单类型',
		OrderTracking: '订单查询',
		Ordertimerange: '订单时间范围',
		Ordertimefrommorningtonight: '下单时间由早到晚',
		Ordertimefromlatetoearly: '下单时间由晚到早',
		Ordernumberorwaybillnumber: '订单号或运单号',
		ordernumber: '订单号',
		Orderlookup: '订单查找',
		Orderdata: '订单数据',
		Orderactuallypaid: '订单实付',
		order: '待确认索赔-订单',
		operating: '操作',
		Oneclickgenerationprice: '一键代发价',
		Oneclickcollection: '一键采集',
		Offshelfdistribution: '下架分销',
		Numberofwarehousesku: '仓库子sku数量',
		Numberofoutboundorders: '出库订单数量',
		Numberofordersrejected: '订单拒收数',
		Numberofordersconsumptionnumber: '订单数（消费数)',
		Numberofcancellationsafterdelivery: '出库后取消数',
		Notprinted: '未打印',
		Notoutofstock: '未出库',
		Notgenerated: '未生成',
		Nomessage: '暂无留言',
		Nodata: '暂无数据',
		No: '暂无',
		Newlyaddedproducts: '新增入库产品',
		Negotiate: '协商',
		Nationalcurrency: '国家货币',
		Multiplechoice: '开启多选模式',
		MonitoringPrice: '线上产品',
		Monitoredproducts: '已监控产品',
		Modifyorderinformation: '修改订单信息',
		Middlevalue: '中价值',
		Memberrechargeinstructions: '会员充值说明：1元1积分，充值越多，赠送积分会越多',
		Mediumloyaltyandhighprice: '中忠诚高价格',
		mark: '标记',
		Malaysia: '马来',
		Machinelearningautomaticclassification: '机器学习自动分类',
		loyalty: '忠诚度',
		lowvalue: '低价格',
		Lowconsumption: '低消费',
		long: '长',
		Logisticstype: '物流类型',
		Logisticsinformation: '物流信息',
		Logistics: '物流',
		Linkcollection: '链接采集',
		Limitationofclaims: '索赔时效：一般为30天内，超过30天还未向平台客服索赔 那么将视为放弃索赔资格，最终卖家白白损失一笔赔偿款(如泰国最高2000泰铢)！如果能及时向平台索赔，将马上帮您挽回损失，立即提升您净利润！',
		kjbgf: '本土店铺COD货到付款订单 一旦买家拒收，丢包概率提升，系统自动监控丢包包裹、派送失败包裹。',
		Iwanttodistribute: '我要分销',
		Islosinghighprices: '正在流失高价格',
		Islosing: '正在流失',
		Includequery: '包含查询',
		InClaimOrder: '索赔中-订单',
		Inboundstatus: '入库状态',
		Inboundproductdetails: '入库产品详情',
		Inboundordernumber: '入库单号',
		Inboundordercreationtime: '入库单创建时间',
		Importproducts: '导入产品',
		Ihaveacted: '我已代理',
		Icansupply: '我可供货',
		Highvaluelost: '已流失高价值',
		highvalue: '高价值',
		Highloyaltyandhighprice: '高忠诚高价格',
		high: '高',
		Hideorder: '隐藏订单',
		GroupName: '分组名称',
		Groupdescription: '分组描述',
		Giveaway: '赠品',
		Giftlibrary: '赠品库',
		Generatewarehousinglist: '生成入库单',
		Generalcargo: '陆运普货',
		Find: '查找',
		Filtertoshoworhideorders: '筛选显示或隐藏订单',
		Exportorder: '导出订单',
		Exportall: '全部导出',
		Export: '导出',
		Export: '导出Excel',
		Expiredate: '到期时间',
		Expand: '展开/收起',
		Estimatedtotalvolume: '预计总体积',
		EstimatedCompensationPoints: '预计赔付积分',
		Edittemplate: '编辑模板',
		Editname: '修改名称',
		edit: '编辑',
		Distributionwarehousemerchandise: '分销仓商品',
		Distributionwarehouse: '分销仓',
		Distributionselectionlibrary: '分销选品库',
		Distributionplatform: '分销平台',
		description: '描述',
		Deliverytime: '出库时间',
		Deliveryplace: '发货地',
		DeliveryMethod: '配送方式',
		Deleteselectedproductsinbulk: '批量删除选中产品',
		delete: '删除',
		CustomerProfile: '类目',
		Custombuyergrouping: '自定义买家分组',
		Currentlyselected: '当前选中',
		Currentlyonly: '当前仅支持shopee平台的商品进行采集，请输入商品详情页面的链接！',
		CreatList: '8个记录',
		Creationtime: '创建时间',
		Courierhasbeendelivered: '快递已送达',
		Courierhasbeencollected: '快递已揽收',
		Couriercollection: '出库揽收数',
		countryregion: '国家地区',
		container: '集装箱',
		contactseller: '联系卖家',
		Confirmthechanges: '确认修改',
		Confirmreceipt: '确认收货',
		Completetime: '完成时间',
		completed: '已完成',
		complete: '完成',
		Complaints: '投诉索赔',
		Complaintorderstobeprocessedbythewarehouse: '待仓库处理的投诉订单',
		Compensation: '赔偿到账：提交平台客服索赔的表格后，店小生将自动判断您所索赔的订单是否成功获得赔偿，节省您去查看的时间，一目了然。点击下方对应菜单栏《待确认索赔-订单》《索赔中-订单》《已索赔成功-订单》',
		Commoditystatus: '商品状态',
		Commoditycollection: '商品采集',
		Combinatoriallibrary: '组合库',
		Cloudblacklist: '云黑名单',
		Claimsuccessfultime: '索赔成功时间',
		ClaimAssistant: '索赔助手',
		claim: '索赔助手：是店小生专为东南亚本土卖家设计的特色功能，能帮助卖家及时发现因COD拒收或快递派送丢包的订单，方便卖家导出表格，可用于向平台索赔的功能',
		Churn: '已流失',
		Chooseawarehouse: '选择仓库',
		Chooseastore: '选择店铺',
		checkorder: '查看订单',
		Checkcompleted: '核对完成',
		Changethetime: '修改时间',
		CaringSMS: '关闭',
		Cancelorder: '取消单',
		Canceldetails: '取消详细信息',
		Buyersname: '买家姓名',
		Buyerpurchasequantity: '买家购买数量',
		Buyermessage: '买家留言',
		Buyerhasconfirmed: '买家已确认',
		box: '箱',
		blacklist: '黑名单',
		Bindingtime: '绑定时间',
		Batchsettingofflags: '批量设置标记',
		Batchoperation: '批量操作',
		Batchexportorders: '批量导出订单',
		Batchexportoforders: '订单批量导出',
		Barcode: '条形码',
		Averageconsumptiontimeinterval: '平均消费时间间隔',
		AuthorizeShop: '查看积分减扣明细',
		Audited: '已审核',
		Applicationforcancellation: '申请取消单',
		Amount: '金额',
		Allsubskusinstorage: '入库所有子sku',
		Allsites: '全部站点',
		Allsellers: '全部卖家',
		Allorders: '全部订单',
		AllLists: '头程费用',
		Allcountries: '全部国家',
		All: '全部',
		agree: '同意',
		Afterrecharging: '充值后，可立即使用海外云仓、测品仓、私有仓等功能',
		Addnotes: '添加备注',
		Additnow: '立即添加',
		Addcustomgroup: '添加自定义分组',
		Actualquantity: '实际到货数量',
		Actualpickingquantity: '实际拣货数量',
		Actualarrivalquantityinwarehouse: '仓库实际到货数量',
		Activityprice: '活动价',
		Activityid: '活动id',
		invitecashback: '邀 请 有 奖',

		pointdetails: '查看积分扣减明细',
		Sellersname: '卖家名称',
		SellersAccount: '卖家帐号',
		boundtime: '绑定时间',
		Sellersname: '卖家名称',
		orderSearch: '订单号/运单号查找',
		orthersSearch: '搜索商品名称，商品sku，仓位',
		syncSingleOrder: '同步单个订单号',
		urgent: '用户催单',
		checkTime: '核对时间',
		orderPrinted: '面 单 打 印',
		hasPrint: '已打印,重新加载当前页',
		returnReason: '填写退回审核的理由',
		jkf: '立即退回',
		scanArea: '订单号或运单号 扫描区',
		scanProduct: '产品条形码 扫描区',
		returnReview: '退回审核',
		resetorder: '重置订单',
		resetPickingNum: '重置拣货数量',
		checkDone: '核对完成',
		purcahseNum: '购买数量',
		singleOrSetmeal: '单品或套餐',
		cusCode: 'CUSCODE/条形码',
		sku: 'SKU',
		pickingNum: '拣货数量',
		retrunDesc: '退回审核理由为必填项！',
		nodata: '没有订单数据！',
		descPicktip: '请确认是否已完成数量打包的核对？',
		outProduct: '出库提示',
		yes: '是的',
		cancel: '取消',
		noorderdata: '没有订单数据！',
		comfirmCheck: '请确认是否已完成数量打包的核对？',
		fkuvkf: '出库提示',
		kvjjkf: '已完成',
		kvjfk: '的核对',
		vkjfhbvm: '请先扫描订单号！',
		fikvnf: '拣货数量与买家购买的数量一致！',
		vkhlf: '核对完成',
		systemNoorder: '系统当前没有该订单的信息，请扫描正确的订单号！',



	},


	home: {
		title: '商店/仓库-概况',
		allproduct: '全部商品',
		inproduct: '在仓商品',
		allshop: '所有商店-订单',
		sale: '卖家收入',
		quantity: '销售量',
		grossprofit: '毛利',
		grossmargin: '毛利率',
		allstorehuozhi: '所有仓库-现货货值',
		houzhi: '货值',
		shipingcost: '运输费用',
		allshopsales: '商店/shops-销售状况',
		allstoresales: '仓库/warehouse-销售状况',
		shopname: '商店名称',
		shopsales: '销售额',
		shopquantity: '销售量',
		cost: '预计成本',
		avg: '销售额/天（AVG）',
		operate: '操作',
		linepic: '拆线图示',
		tipdialog: '店铺销售拆线图',
		close: '关闭',
		storename: '仓库名称',
		tip1: '(已扣减：实际派送费，预计派送费，平台交易费)',
		tip2: '已扣减：采购成本，头程运费',
		tip3: '仅含仓库现货采购费',
		tip4: '预计成本=采购成本+头程运费+平台交易费',
		secondPwsTip: '涉及财务隐私，请输入二次密码',
		secondPws_Two: '刚注册默认',
		secondChange: '点击修改二次密码',
		secondPwsInput: '请填入密码',
		confirm: '确定'


	},
	header: {
		title: '店小生跨境管理系统',
		huanyinru: '欢迎您'
	},
	login: {
		system: '登录中心',
		tip: '一个能提高您净利润的东南亚货代',
		account: '输入邮箱帐号',
		passsword: '输入密码',
		remember_password: '记住密码',
		login: '登录',
		desc: '店小生-专注服务Shopee/Lazada本土卖家',
		desc1: '专注东南亚虚拟服务/云仓一件代发',
		desc2: '自研ERP对接Shopee/Lazada一健管理精确库存',
		desc3: '提供本土客服纠纷处理,差评跟进',
		desc4: '大数据智能采购预测',
		desc5: '退货一个都不少,提高您的净利润',
		th: '泰国',
		my: '马来',
		ph: '菲律宾',
		tw: '台湾',
		sg: '新加坡',
		vn: '越南',
		id: '印尼',
		forget: '忘记密码',
		registor: '点击注册'
	},
	registor: {
		center: '注册中心（卖家）',
		mail: '填入邮箱',
		nickname: '卖家昵称',
		passsword: '卖家密码至少6位以上，字母,数字,字符组合',
		confirm_pws: '确认密码',
		phone: '用于重要通知或紧急联系',
		verification: '邮箱验证码',
		getCode: '获取邮箱验证码',
		register: '注册',
		log: '点此跳转登录页',
		invitationCode: '如无邀请码，可不填'
	},
	aside: {
		home: '首页',
		invitecashback: '邀 请 有 奖',
		mysharePage: '邀请分享页',
		myshareLink: '专属邀请链接',
		dianpusouquan: ' 店 铺 授 权',
		wodedingdang: ' 我 的 订 单',
		allOrder: '全部订单',
		sellerManagement: ' 卖 家 管 理',
		zhuanchuandan: ' 转 仓 单',
		shenghedang: '待审核订单',
		chulidang: '待处理订单',
		yifahuodingdang: '已揽收订单',
		wentidang: '问题单',
		zhenzifuwu: '增 值 服 务',
		xiangshangchanpin: '  仓 库 管 理',
		shengchengchangkuchanpin: '导入产品',
		changkunchanpin: '仓库产品',
		quanbuzhachanshanpin: '全部在仓商品',
		rukuguangli: ' 采   购   入   库',
		kuchuguanli: ' 库 存 管 理',
		distribution: '分 销 平 台',
		localGoods: '本 土 货 源',
		mygoods: '我 的 供 货',
		hasAgent: '我 已 代 理',
		prductDev: '产 品 开 发',
		collectGoods: '产品采集',
		ProductPending: '产品待审',
		productMGM: '产品管理',
		godownentry: ' 入 库 管 理',
		processed: '已处理订单',
		recharge: '立 即 充 值',
		yunweiguanli: '运 营 管 理',
		discountProducts: '折扣商品',
		claimAssistant: ' 索 赔 助 手',
		Management: ' 运 营 管 理',
		purchaseMGM: '采购管理',
		transformStore: '仓 库 转 移',
		rollover: '转 仓 单',
		Performance_ranking: '小组绩效排名',
		Monitoring_Price: '智能监控出价',
		Customer_Service: '虾皮多店聊',
		Customer_Profile: '买家画像',
		SmartChat: '虾皮多店聊',
		CaringSMS: '关怀短信',
		Returned: '退货管理',
		CreatList: '创建入库',
		AllLists: '入库在途',
		fenjianhedui: '分拣验货 ',
		daibaochuku: '打包出库',
		tuhuanguanli: '退换货管理',
		Relevantquotation: '相关报价',
		ScanPrint:'扫描打印',

	},

	shopaccess: {
		diangpusouquan: '店铺授权',
		bindshop: '授权shopee店铺',
		bindshop_LAZADA: '授权LAZADA店铺',
		shopify: '授权shopify店铺',
		bindstore: '绑定仓库',
		shopId: '店铺ID',
		shopName: '店铺名',
		shopSite: '店铺站点',
		shopStatus: '状态',
		accessTime: '授权时间',
		Expiredate: '到期时间',
		operate: '操作',
		storeID: '仓库ID',
		userId: '用户ID',
		userName: '用户名称',
		storeName: '仓库名称',
		createTime: '创建时间',
		storeAdresse: '仓库所在地',
		Untie: '解绑店铺',
		UniteStore: '解绑仓库',
		UniteStoreSuccess: '解绑仓库成功！',
		UniteShopSuccess: '解绑店铺成功！',
		selectStore: '请选择需要绑定的仓库',
		cancel: '取消',
		comfirm: '确定',
		bangdinSuccess: '成功绑定仓库！',
		enterStoreinfo: '请输入新建仓库信息',
		enterUserName: '请输入用户名称',
		enterStoreName: '请输入仓库名称',
		selected: '请选择国家',
		xinjian: '新建子仓库',
		lazada_shortCode: '卖家编号',
		lazada_account: '用户帐号',
		lazada_name: '店铺名',
		lazada_location: '所在地',

	},
	pendingorder: {
		title: '待审核订单',
		search: '搜索',
		allcurrentpage: '全选当前页',
		Mass_review_orders: '批量审核订单',
		synchronize: '同步订单状态',
		last_3_days: '最近3天',
		last_7_days: '最近7天',
		last_1_month: '最近1月',
		last_3_month: '最近3月',
		orderSn: '订单号',
		status: '订单状态',
		paytime: '付款时间',
		delivery_time: '超时发货剩余时间',
		sku: 'SKU',
		quantity: '数量',
		shopName: '店铺名称',
		shopid: '店铺Id',
		recipient: '收件人',
		phone: '电话',
		methods: '配送方式',
		actually_paid: '实付',
		waybill_number: '运单号',
		review: '审核订单',
		search_tip: '请输入订单号',
		nodata: '暂无订单',
		orderstotal: '个订单',
		select: "请选择发货仓",
		cancel: "取消",
		confirm: '确认',
		UNAUDIT: "待审核",
		cash_on_delivery: '货到付款',
		pending_upgrade: '待更新',
		notgenerated: "未生成",
		synchronized: "订单已同步到最新状态，请一段时间后刷新页面！",
		Successful_review: "审核成功！",
		day: '天',
		hours: '小时',
		min: '分',
		time_order: '订单时间排序',
		Positive: '订单付款时间-由早到晚',
		Reverse: '订单付款时间-由晚到早',
		Positive01: "剩余发货时间-由多到少",
		Reverse01: '剩余发货时间-由少到多',
		auto_distribute: '自动审核订单',
		Inventory: '库存数',
		In_warehouse: '在仓',
		committed: '待发',
		on_line: '线上',
		Turn_on: '开启/关闭订单自动审核功能',
		Store_Name: '店铺名称',
		warehouse: '仓库',
		un_include: '是否排除缺货订单',
		yes: '是',
		no: '否',
		auto_distribute: '自动审核订单',
		open: '开启',
		Turned_on: '已开启',
		shut_down: '关闭',
		confirm: '确认',
		oop: '您所选中的订单中，根据仓库实际库存数量和截至发货日期紧急程度筛选后:',
		llo: '可审核通过的现货订单',
		ggo: '订单号',
		prick: '金额',
		hho: '截止发货日期',
		pkl: '建议不通过的缺货订单',
		cancel: '取消',
		uuo: '仅通过现货订单',
		iio: '继续全部通过',
		addpackingfee: '是否代贴单',
		cancelTime: '取消时间',
		paydelivery: '货到付款',



	},

	storePending: {
		Form: '平台类型',
		UserName: '卖家选择',
		shoptype: '店铺选择',
		Warehouse_type: '仓库类型',
		Loading_status: '加载状态',
		Printstatus: '打印状态',
		LogisticsType: '物流类型',
		orderMakr: '订单标记',
		lastDeliveryTime: '最后发货',
		orderStatus: '订单状态',
		exwarehouse: '是否出库',
		orderInclude: '订单包含',
		all: '全部',
		singlesku: '单sku',
		multiplesku: '多sku',
		shipped: '已发货',
		tobeshipped: '待发货',
		yes: '已出库',
		notYet: '未出库',
		printed: '已打印',
		notprinted: '未打印',
		notgenerated: "未生成",
		Generated: '已生成',
		loading: '正在生成',
		massArrangeShipment: '生成运单号',
		drop_off: 'drop off 生成',
		pick_up: 'pick up 生成',
		massprint: '批量打印配货单',
		PrintPacklist: '默认打印拣货单',
		PrintPicklist: '快速打印批次配货单',
		MassPrintShipingLabel: '批量打印快递面单',
		PrintShipingLabel: '默认打印面单',
		ShipingLabel_Packlist: '快速打印面单&拣货单',
		ReturnBacktoUser: '退回审核',
		SynchronizeOrder: '同步订单',
		desc: '先配货，后分拣，可降低出错率(播种式WMS)',
		fisrtStep: '第1步:生成运单号',
		secondStep: '第2步:快速打印配货单',
		threeStep: '第3步:快速打印面单+拣货单',
		fourStep: '第4步: 验货&出库',
		firstDesc: '快递上门揽收选Pick Up,送货到网点选Drop OFF',
		secondDesc: '打印此批次的配货单,先从仓库拣出总数 ',
		threeDesc: '采用快速打印面单+拣货单,提高打印速度 ',
		fourDesc: '采用分拣验货和打包出库,可分解流程,提高效率 ',
		Inventory: '是否缺货',
		Enough: '库存充足',
		noEnough: '库存不足',
		pushTime: '推送时间',
		tenBefore: '当天10点前',
		tenAfter: '当天10点后',
		specialOrder: '是否空包',
		norMall: '非空包',
		enptry: '空包'

	},

	unprocessedorder: {
		title: '待处理订单',
		search: '搜索',
		allcurrentpage: '全选当前页',
		Mass_review_orders: '批量审核订单',
		synchronize: '同步订单状态',
		last_3_days: '最近3天',
		last_7_days: '最近7天',
		last_1_month: '最近1月',
		orderSn: '订单号',
		status: '订单状态',
		paytime: '付款时间',
		delivery_time: '超时发货剩余时间',
		sku: 'SKU',
		quantity: '数量',
		shopName: '店铺名称',
		shopid: '店铺Id',
		recipient: '收件人',
		phone: '电话',
		methods: '配送方式',
		actually_paid: '实付',
		waybill_number: '运单号',
		review: '审核订单',
		search_tip: '请输入订单号',
		nodata: '暂无订单',
		orderstotal: '个订单',
		select: "请选择发货仓",
		cancel: "取消",
		confirm: '确认',
		UNAUDIT: "待审核",
		cash_on_delivery: '货到付款',
		pending_upgrade: '待更新',
		notgenerated: "未生成",
		Mass_generate_waybill_number: "批量生成运单号",
		Mass_print_orders: "批量打印订单",
		Mass_print_picking_list: "批量打印拣货单",
		pick_off: "Pick up 生成",
		drop_off: "Drop off 生成",
		allshops: '全部店铺',
		allorders: '全部订单',
		tobegenerated: '待生成',
		tobeprinted: '待打印',
		Defaultprint: '默认打印',
		fastprint: '快速打印',
		viewhistory: '查看历史打印纪录',
		logistic: '全部物流',
		printed: "已打印",
		printed_time: '打印时间',
		print_order: '打印订单',
		print_picking_list: '打印拣货单',
		delivery_store: '发货仓',
		todelivered: '待发货',
		all_store: '全部仓库',
		pingliancancelreview: '批量退回审核 ',
		cancelreivew: '订单已成功重置为待审核状态！',
		initTrickingNo: {
			createNO: '生成运单号中',
			main: '主图',
			ordersn: '订单号',
			trickingNo: '运单号',
			ttp01: '已完成',
			ttp02: '张订单',
			ttp03: '打印订单'

		},
		pingliandayin: '请选择订单！',
		pingliandayin01: '请选择同一店铺下的订单打印！',
		haimeishenchendingdang: '请生成运单号，再打印！',
		searchContent: '请输入搜索内容',
		Export: '导出xlsx',
		fenle: '按产品查找订单'

	},
	shippedorder: {
		title: '已发货订单',
		search: '搜索',
		allcurrentpage: '全选当前页',
		Mass_review_orders: '批量审核订单',
		synchronize: '同步订单状态',
		last_3_days: '最近3天',
		last_7_days: '最近7天',
		last_1_month: '最近1月',
		orderSn: '订单号',
		status: '订单状态',
		paytime: '付款时间',
		delivery_time: '剩余发货时间',
		sku: 'SKU',
		all_store: '全部仓库',
		quantity: '数量',
		shopName: '店铺名称',
		shopid: '店铺Id',
		recipient: '收件人',
		phone: '电话',
		methods: '配送方式',
		actually_paid: '实付',
		waybill_number: '运单号',
		review: '审核订单',
		search_tip: '请输入订单号',
		nodata: '暂无订单',
		orderstotal: '个订单',
		select: "请选择发货仓",
		cancel: "取消",
		confirm: '确认',
		UNAUDIT: "待审核",
		cash_on_delivery: '货到付款',
		pending_upgrade: '待更新',
		notgenerated: "未生成",
		Mass_generate_waybill_number: "批量生成运单号",
		Mass_print_orders: "批量打印订单",
		Mass_print_picking_list: "批量打印拣货单",
		pick_off: "Pick off 生成",
		drop_off: "Drop off 生成",
		allshops: '全部店铺',
		allorders: '全部订单',
		shipped: '已发货',
		pending_receipt: '抵达待确认',
		confirm_receipt: "已确认完成",
		printed_time: '打印时间',
		print_order: '打印订单',
		print_picking_list: '打印拣货单',
		delivery_store: '发货仓',
		todelivered: '待发货',
		view_logistics: "查看物流"




	},
	problemorder: {
		title: '问题订单',
		tap_tuhuoguanli: '退货管理',
		tap_tuhuobaoguo: '仓库退货包裹',
		tap_maijiaqueren: '卖家已确认',
		tap_audited: '已处理',
		tap_canceled: '已取消订单',
		tap_return: '退货订单',
		tap_in_cancel: '申请取消订单',
		tap_in_cancel01: '申请中',
		tap_alerdy_return: '已接受退货',
		tap_cancel_return: '取消退货',
		tap_in_return: '退货中',
		tap_dispute: '卖家争议',
		tap_ruling: '裁决中',
		tap_returned_money: '已退款',
		tap_close: '已关闭',
		tap_return_bysellser: '卖家核实退货',
		tap_seller_comfirm: '卖家已确认',
		tap_processed: '已处理',
		tap_delivery_failed: '派送失败',
		tap_courier_loss: '快递丢包',
		tap_delivery_timeout: '发货超时',
		tap_pay_timeout: '付款超时',
		tap_seller_cancel: '买家取消',
		tap_others: '其它',
		tap_ordered: '仓库已打单（不可取消）',
		tap_nerver_order: '仓库未打单（可取消）',
		nodata: '暂无订单',
		return_trickNO: '退货运单号',
		original_order: '原始订单号',
		return_order: '退货单号',
		order_status: '订单状态',
		cancel_time: '取消时间',
		print_time: '打印时间',
		quantity: '数量',
		return_quantity: '退货数量',
		cancel_reason: '取消原因',
		shop: '店铺',
		receipent: '收件人',
		phone: '电话',
		return_reason: '退货原因',
		seller_name: '买家昵称',
		seller_Email: '买家Eamil',
		deliver_store: '发货仓',
		delivery_method: '配送方式',
		actuall_pay: '实付',
		trickNO: '运单号',
		return_count: '退货金额',
		origin_prick: '折扣前订购价格',
		buyer_delivery_deadline: '买家发货截止日期',
		seller_processing_return_due: '卖家处理退货到期',
		view_logistics: "查看物流",
		return_package: '退件照片',
		confirmed_by_seller: '二次上架或销毁',
		be_processed_by_store: '待仓库处理',
		search_tip: '查询订单号',
		search: '搜索',
		no: '暂无',
		price: '价格'

	},
	mygoods: {
		allShop: '全部商店',
		ppo: '条纪录',
		search: '搜索',
		search_tip: '可搜索商品名称，sku',
		synchronize: '同步shopee产品',
		Generate_warehouse_items: '导入仓库商品',
		itemID: '商品ID',
		shop: '店铺',
		price: '价格',
		stock: '库存',
		cusCode: '仓库编码',
		sales: '总销量',
		status: '状态',
		update: '更新时间',
		sku: 'sku',
		Whether_to_booking: '是否预售',
		yes: '是',
		no: '否',
		more: '更多',
		viewOrder: '查看商品订单',
		viewSales: '查看销售情况',
		generated: '已导入仓库商品',
		isTarget: '该商品已选中',
		vieworder: '查看商品订单',
		viewsales: '查看销售情况',

		qingdang: {
			title: "商品清单",
			Img: '图片',
			name: '商品名',
			cost: '成本价',
			operate: '操作',
			dele: '删除',
			store: '收货仓库',
			qingkong: '清空',
			submit: '提交',
			choose: '选择仓库...'
		},
		details: {
			title: "仓库清单详情",
			Img: '图片',
			name: '商品名',
			SKU: 'SKU',
			cusCode: 'cusCode',
			ok: '确定',
			success: '成功录入仓库',
			fail: '录入失败（已在仓库）',
		}
	},

	binditems: {
		allShop: '全部商店',
		ppo: '条纪录',
		search: '搜索',
		search_tip: '输入商品名称搜索',
		Generate_warehouse_items: '多商品绑定',
		itemID: '商品ID',
		shop: '店铺',
		price: '价格',
		stock: '库存',
		cusCode: '仓库编码',
		sales: '总销量',
		satus: '状态',
		update: '更新时间',
		sku: 'sku',
		generated: '已绑定',
		bind: '绑定',
		jieban: '解绑',
		isTarget: '已选',
		bindDetexl: {
			title: "多商品绑定",
			tip: '请输入商品编码',
			search: '搜索',
			Img: '图片',
			shopId: '商店Id',
			name: '商品名',
			SKU: 'sku',
			dele: '删除',
			operate: '操作',
			qingkong: '清空',
			submit: '提交',
			cusCode: '仓库编码',
			store: '仓库'
		},
		details: {
			title: "绑定情况",
			Img: '图片',
			name: '商品名',
			SKU: 'SKU',
			cusCode: '仓库编码',
			ok: '确定',
			success: '绑定成功',
			fail: '绑定失败（商品已被绑定）',
		}
	},
	userStoreItems: {
		ok: '我知道了',
		Prompt: '提示',
		ppo: '条纪录',
		search: '搜索',
		search_tip: '可搜索仓库编码，sku,商品名称，产品条形码',
		synchronize: '同步待发货数量',
		Generate_warehouse_items: '生成入库单',
		stock_suggestion: '采购建议',
		allcurrentpage: '全选当前页',
		mass_open_updata_stock: '批量开启自动更新在仓库存',
		mass_close_updata_stock: '批量关闭自动更新在仓库存',
		kki: '绑定的产品的在线库存将始终更新为在仓库的实际库存（预售产品除外)。',
		shop: '店铺',
		userName: '用户名',
		warehouse: '仓库',
		cost: '成本价',
		cusCode: '仓库编码',
		online_stock: '线上库存',
		shipping_stock: '全部待发货数量',
		total_stock: '在仓库存',
		auto_update: '自动更新在仓库存',
		create_ruku: '创建入库',
		selected: '已选',
		edit: '编辑',
		nodata: '暂无商品',
		all: '全部仓库',
		confirmBtn: '确认',
		binditems: '绑定该子SKU',
		caigoudangtip: '创建采购单成功，采购单号为',
		delet: '删除',
		on: '开',
		off: '关',
		caigou: {
			title: "采购单",
			Img: '图片',
			name: '商品名',
			caigouqunatity: '采购数量',
			anthreName: '商品别名',
			operate: '操作',
			dele: '删除',
			tip: '请输入给仓库的备注',
			qingkong: '清空',
			submit: '提交',
		},
		bindItem: {
			title: '绑定商品信息',
			xinzhen: '新增绑定商品',
			anthreName: '商品名',
			operate: '操作',
			shopName: '店铺名',
			jieban: '解绑',
			tip: '仓库产品至少需要绑定1个线上产品，如不需该产品可直接删除该在仓产品',
			jiebansuccess: '解绑成功'
		},
		update: {
			tip: '在仓库存更新提示',
			open: '算了吧，还是开启',
			close: '关闭',
			close01: '算了吧，不开启',
			open01: '知道了，仍然开启',
			text01: '开启自动更新在仓库存时，会将该仓库产品所绑定的所有产品的shopee库存，自动同步为该仓库产品的仓实际剩余库存，请确认是否要开启？',
			text02: '请选择需要关闭自动更新库存的商品！',
			text03: '关闭自动更新在仓库存时，该仓库产品的库存将不会影响所绑定的所有产品的shopee库存，请确认是否要开启？',
			text04: '请选择需要开启自动更新库存的商品！',
			text05: '开启自动更新在仓库存时，会将该仓库产品所绑定的所有产品的shopee库存，自动同步为该仓库产品的仓实际剩余库存：',
			text06: '，请确认是否要开启？',
			text07: '关闭自动更新在仓库存时，该仓库产品的库存将不会影响所绑定的所有产品的shopee库存，请确认是否要开启？'
		},
		Quantitytobeshipped: '已审核待发货',
		long: '长',
		width: '宽',
		height: '高',
		weight: '重量',
		more: '更多操作',
		vieworder: '查看商品订单',
		viewsales: '查看销售情况',
		viewstockstore: '查看库存日志',
		del: '删除',
		quehuo: '缺货提醒'


	},

	complaint: {
		complaintReasonTip1: "请填写申诉理由",
		complaintReasonTip2: "请填写卖家申诉理由(必填)",
		cancel: "取消",
		determine: "确定",
		close: "",
		complaintDetailTip: "申诉详情",
		sellerLeaveMessage: "卖家留言",
		sellerLeaveMessageTip: "请填写卖家的留言(必填)",
		WarehouseLeaveMessage: "仓库留言",
		WarehouseLeaveMessageTip: "请填写仓库的留言(必填)",
		PlatformLeaveMessage: "平台留言",
		PlatformLeaveMessageTip: "请填写平台的留言(必填)",
		overseasWarehouseComplaints: "海外仓投诉中心",
		orderQuery: "订单查找",
		orderQueryTip: "输入订单号查找",
		query: "查找",

		wareHouseHaveEx: "仓库全部已出库订单",
		sellerComplaint: "卖家投诉中订单",

		haveFinish: "已完成",
		orderId: "订单号",
		orderStatus: "订单状态",
		orderPaid: "订单实付",
		warehouseHaveCompensation: "仓库已赔付",
		specificationName: "规格名",
		number: "数量",
		orderTime: "下单时间",
		payTime: "付款时间",
		printTime: "打印时间",
		warehouseExTime: "出库时间",
		deliveryTime: "发货时间",
		storeName: "店铺名称",
		deliveryMethod: "配送方式",
		WaybillNum: "运单号码",
		PlatformType: "平台类型",
		sellerLeaveMessage: "卖家留言",
		complaintCompensate: "投诉索赔",
		waitWarehouseConfirm: "待仓库确认",
		waitPlatformType: "待平台处理",
		haveCompensation: "已赔付",
		integral: "积分",
		viewDetail: "查 看 详 情",
		confirmTip: "订单已向仓库发起投诉索赔，等待仓库处理！",

	},
	sellerpurchase: {
		All_warehouses: '所有仓库',
		All_inbound_orders: '所有入库单',
		Warehousing: '查找入库单号',
		Find: '查找',
		Create_warehouse_receipt: '创建入库单',
		order_number: '入库单号',
		infact_time: '实际到货时间',
		status: '入库单状态',
		Creation_time: '时间类型',
		Warehouse: '入仓仓库',
		country: '购买总数',
		message: '留言',
		operating: '操作',
		ship: '运输总成本',
		View_items: '查看物品',
		delet: '删除',
		wait_store_check: '待仓库核对',
		wait_check_in: '待卖家确认入库',
		aleady_check_in: '已确认入库',
		comfirm: '审核入库',
		cusCode: '仓库编码',
		name: '商品名',
		Purchase_quantity: '采购数量',
		Purchase_information: '采购物品信息',
		rukudanghao: '入库单号',
		create_time: '采购单创建时间',
		rukustore: '入库仓库',
		sellerMessage: '卖家留言',
		rukushuliangcomfirm: '采购单入库数量确认',
		confirm_time: '采购单确认时间',
		rukustore: '入库仓库',
		storeMessage: '仓库留言',
		rukuNo: '入库数量',
		actualNo: '实际到货数量',
		ok: '已确认，商品已增加库存',
		I_know: '我知道了',
		warn: '提示',
		sub: '提交给卖家确认',
		tosellermsg: "输入给卖家的留言",
		anthoeName: '商品别名',
		check: '核对',
		payondelivery: '货到付款(COD)',
	},
	lazada: {
		time: '下单时间',
		total: '总金额',
		paytotal: '付款金额',
		shippingfee: '快递费用',
		fahuoleixi: '发货类型',
		zuihoufahuo: '剩余发货时间',
		shop: '店铺',
		shopid: '店铺ID',
		paymenthod: '付款方式',
		receipt: '收货人',
		phone: '电话',
		trickno: '运单号',
		printTime: '打印时间',
		choose: '选择物流方式',
		generate: '生成',
		pendinggenerate: '未生成'
	},
	orderPrint: {
		WarehouseType: '仓库类型：',
		LoadingStatus: '加载状态：',
		PrintStatus: '打印状态：',
		LogisticsType: '物流类型：',
		FinalDelivery: '最后发货：',
		OrderStatus: '订单状态：',
		OrderContains: '订单包含：',
		Searchquery: '搜索查询：',
		Includequery: '包含查询：',
		exclude: '排除',
		Precise: '精准',
		generatingWaybillNo: '开始生成运单号',
		Default_printing: '默认打印',
		Ordertimeorder01: '下单时间排序（由早到晚）',
		Ordertimeorder02: '下单时间排序（由晚到早）',
		Sortbyquantity01: '数量排序（由多到少）',
		Sortbyquantity02: '数量排序（由少到多）',
		Sort_by_number_ofsku01: 'sku数量排序（由多到少）',
		Sort_by_number_ofsku02: 'sku数量排序（由少到多）',
		Sort_by_pushtime_early: '推送时间排序（由晚到早）',
		Sort_by_pushtime_late: '推送时间排序（由早到晚）',
		MassSetPickupTime: '批量设置取件方式（Pick up或Drop off）：',
		Unselect_current_page: '反选当前页',
		Select_current_page: '全选当前页',
		Order_is_scheduled: '当前订单已安排',
		all: '全部',
		Loaded: '已加载',
		not_loaded: '未加载',
		Generated: '已生成',
		Not_generated: '未生成',
		Printed: '已打印',
		To_print: '未打印',
		To_delivered: '待发货',
		Pickup_failed: '取件失败',
		Multiple_SKU: '多SKU',
		Single_SKU: '单SKU',
		select_Order: '请选择订单！',
		waybill_No: '系统正在生成运单号，请一段时间后再刷新当前页面！',
		Copy: '成功复制',
		Order_sorting: '订单排序',
		Pickup_time: '取件时间',
		Order_scheduled: '当前订单已安排',
		Print_status: '打印状态',
		Packaged: '已出库',
		Unpackaged: '未出库',
		Combine_print_orders: '合并打印订单',
		Combined_print_picklist: '合并打印拣货单',
		Regenerate_order: '重新生成面单',
		tip: '订单出现丢失或系统报错,请重新生成订单再打印!',
		Print_name: '打印名称',
		shop: '商店',
		latest_time: '打印时间-(最新时间)',
		operare: '操作',
		print_order: '打印订单',
		Printed_order: '已打印(订单)',
		Print_picklist: '批量打印拣货单',
		Printed_picklist: '已打印(拣货单)',
		close: '关闭',
		Order_acquisition_status: '订单获取状态：',
		completed: '已完成',
		order: '张',
		total: '共',
		tip02: '个订单不支持安排到该时间',
		search_tip: '请输入订单号',
		search_tip02: "请输入商品名称,商品Id,SKU",
		open01: '开启多选模式',
		open02: '全选',
		open03: '反选',
		already: '已生成运单号',
		default_second: '不设置默认隔天',
		store: '店铺选择：',
		stock: '仓库类型：'



	},

	distribution: {
		//erp系统中的分销平台三个页面
		// Community
		shipmentPlace: "发货地",
		generateH5: "生成 “分销专属页”",
		searchStore: "搜索仓库编码，sku，产品名称",
		mSKU: "母SKU",
		price: "价格",
		oneOffer: "一件代发价",
		stockNum: "现货库存量",
		haveDistribution: "我已分销",
		havenDistribution: "我要分销",
		//Tab
		distributionProduct: "分 销 仓 产 品",
		distributionLibrary_tab: "分销选品库",
		distributionHaveSupply_tab: "我可供货",
		distributionHaveAgent: "我已代理",
		//hasAgent
		stockType: "仓库类型",
		selectAll: "全选当前页",
		operationBatch: "批 量 操 作",
		operationBatchDelete: "批量删除选中产品",
		sSKUNum: "子sku数量",
		totalStock: "总库存",
		releaseProduct: "发布产品",
		updateItemTip1: "当前分销仓的产品尚未绑定模版信息，请绑定一个商品绑定再发布！",
		updateItemTip3: "前往模版管理绑定",
		cancel: "取消",
		tip: "提示",
		determine: "确定",
		confirmDelete: "请确认要删除选中的产品？",
		deleteSuccess: "删除成功",
		//myselfproduct
		distributionH5Link: "分销产品h5邀请页链接",
		copy: "复 制",
		deleteFileTip: "删除失败提示！",
		failReason: "失败原因",
		nowSelect: "当前选中",
		importProducts: "导 入 产 品",
		havenProduct: "当前暂无产品",
		offshelfdistribution: "下架分销",
		Onshelfdistribution: "上架分销",
		confirmOffshelf: "确认下架该产品吗？",
		confirmOnshelf: "确认上架该产品到分销选品库吗？",
		successOnshelf: "上架分销成功！",
		successOffShelf: "下架分销成功！",
		successCopy: "成功复制"
	},
	remind: {
		header: '提醒功能',
		remind_message: '开启智能提醒功能将会按自动发送的短信量进行扣费，短信价格根据不同国家进行计费。',
		charge: '(国际短信报价：马来西亚0.25积分/条，泰国0.15积分/条)',
		seller_back: '的提醒设置',
		shopee: 'shopee商店',
		orderCare: '订单关怀',
		record: "使用记录",
		paymentRemind: "催付提醒",
		open: "开启",
		close: "关闭",
		displayEchart: "效果展示",
		totalSend: "发送条数",
		successRecive: "成功接收条数",
		edit: "编辑模板",
		remindType: "提醒类型",
		orderId: "订单号",
		orderIdPlaceholder: "请输入订单号",
		buyerName: "买家姓名",
		buyerPlaceholder: "查找买家姓名",
		tableTypt: "所属类型",
		tableChargeNum: "计费条数",
		integralCost: "消耗积分",
		status: "送达结果",
		arriveTime: "送达时间",
		shipReminder: "发货提醒",
		signRemind: "签收催评",
		displayEffect: "效果展示",
		succseePayOrdersNum: "内成功支付的订单数",
		successSendMessage: "内发送短信后",
		pleaseSelect: "请选择",
		lately: "最近",
		totalSend: "共发送",
		strip: "条",
		successRecive_: "成功接收",
		successPayOrder: "成功支付订单",
		successPay: "成功支付",
		sendAndSuccessSendCount: "内发送短信数与成功发送数",
		ifOnlyRemindCod: "是否只提醒COD订单",
		orderId: "订单号",
		buyerName: "买家姓名",
		Type: "所属类型",
		CountNum: "计费条数",
		CountIntegral: "消耗积分",
		deliveryResult: "送达结果",
		arriveTime: "送达时间",
		acceptFail: "接受成功",
		acceptSuccess: "接受成功",
		sending: "正在发送",
		acceptOutTime: "接受超时",
		latelySendAndSuccessCount: "最近短信发送数量与发送成功数",
		sendMessageTotal: "发送短信总数",
		sendSuccessCount: "发送成功数",
		successPayCount: "成功支付数",
		toData: "距今",
		setCountOption_tip1: "前",
		setCountOption_tip2: "内共发送",
		setCountOption_tip3: "条短信，成功发送",
		In: '在',
		seccessPay: '内共成功支付',
		order: "单",
		queryTime: "",
		//remind_Template
		back: "返回",
		currentTemplate: "当前短信模板",
		Bracket_tip: "(中括号内为订单变量，系统将自动获取)",
		currentSelectTemplate: "当前选择模板",
		testTemplate: "测试短信模板",
		sentTestMessage: "发送测试短信",
		systemTemplate: "系统模板",
		customTemplate: "自定义模板",
		defaultLanguage_tip: "初始默认选择语言为英语",
		customTemplateLanguage_tip: "自定义模板不支持多国语言适配",
		saveSetting: "保存设置",
		insertLabel: "插入标签",
		what_label: "什么是标签",
		label_tip: "插入标签后，向榕科技将在短信发送时自动填入标签中所对应的订单数据或名称，可免去手动编辑各项内容。",
		haveInput: "已经输入",
		character: "字符",
		countCharacterTip: "买家ID过长可能会导致多条计费",
		limitLengthTip: "限制短信长度为536个字符",
		messageChargeTip: "国际短信报价：马来西亚0.25积分/条，泰国0.15积分/条",
		messageCount: "短信条数",
		paymentRemind_tip1: "买家拍下30分钟后还未付款自动发短信（订单金额大于 0 美元才提醒 ）。",
		paymentRemind_tip2: "同一买家当天最多发1次催付。",
		paymentRemind_tip3: "买家当天在本店已付款订单≥1，催付将自动取消。",
		shipRemind_tip1: "卖家发货后，自动发送短信通知买家(订单金额大于 0 美元才提醒 ）。",
		shipRemind_tip2: "若快递已签收或已到达买家城市则不发",
		signRemind_tip1: "买家签收宝贝的72小时小时内，自动发送短信通知关怀（若买家已确认收货则不发送）,订单金额大于 0 美元才提醒 。",
		sendCondition: "发送条件",
		chargeStandard: "收费标准",
		addTemplate: "添加模板",
		messageType: "短信类型",
		chargeCountStandard: "计费条数标准",
		messageType_tip1: "不包含特殊字符",
		messageType_tip2: "个字符/条",
		templateChoose: "模板选择",
		testPhoneNum_tip: "请输入测试手机号码",
		English: "英语",
		Chinese: "中文",
		My: "马来西亚语",
		Th: "泰语",
		recipientName: "收件人姓名",
		OrderId: "订单编号",
		shopName: "店铺名称",
		purchaseDate: "购买日期",
		selectTemplate: "请选择模板",
		failSaveTemplate: "保存模板失败",
		confirmButtonText: "确定",
		inputeContent: "请输入内容",
		addCustomFail: "添加自定义模板失败",
		outLimit: "自定义短信字符长度超出限制",
		confirmDeleteCustom: "此操作将删除该自定义模板, 是否继Page续?",
		tip: "提示",
		cancel: "取消",
		successDelete: "删除成功",
		haveCancelDelete: "已取消删除",
		haveSendTestMessage: "测试短信已发送",
		failSendTestMessage: "测试短信发送失败",
		phoneFormatErr: "手机号码格式错误或未选择测试模板"
	},

	h5: {
		verification: '短信验证码',
		phone: '手机号码',
		login: '立即登录',
		send: '发送验证码',
		phoneDesc: '输入手机号码',
		passWordeDesc: '输入验证码',
		DSX_index_note: '亲~你还没有登录哦！',
		DSX_index_log: "立即登录",
		DSX: '店小生',
		DSX_title: '店小生东南亚本土货源分销平台',
		DSX_qty: '现货数量',
		DSX_dropship: '立即分销',
		DSX_specification: '规格(1)',
		DSX_price: '1件代发价',
		DSX_qty1: '现货库存:',
		DSX_des: '商品描述',
		DSX_details: '商品详情',
		DSX_index_slogn: '东南亚现货货源 分销热榜',
		DSX_index_recommendation: '热荐榜单',
		DSX_index_th: '泰国',
		DSX_index_my: '马来西亚',
		DSX_index_ph: '菲律宾',
		DSX_index_tw: '台湾',
		DSX_index_id: '印尼',
		DSX_index_vn: '越南',
		DSX_index_bz: '巴西',
		DSX_index_cn: '中国测品仓',
		DSX_index_price: '1件代发价',
		DSX_index_profit: '毛利率',
		DSX_index_qty: '现货库存量',
		DSX_index_country: '马来市场分析',
		DSX_index_sample: '我要样品',
		DSX_index_dropship: '我要分销',
		DSX_index_welcome: '欢迎您',
		DSX_index_signout: '退出',
		DSX_index_back: '返回',
		DSX_index_Quote: '获得询盘',
		DSX_index_detail: '产品详情',
		DSX_index_distribute: '立即分销',
		DSX_index_tips: '该产品成功分销到您的店小生帐号上，后续要发布产品至shopee平台，请前往PC端的分销平台：我已代理，继续进行操作！',
		a1736: 'ssss'


	},

	other: {
		a1: '图片加载失败...',
		a2: '图片加载中...',
		a3: '联系客服',
		a4: '海外仓客服',
		a5: '关闭',
		a6: '点击下载插件CRX安装包',
		a7: '插件简介',
		a8: '贝分析，是专门针对Shopee卖家提供的运营工具，可以帮忙虾皮卖家高效选品和产品数据分析工作。适用于Shopee泰国、马来、印尼、越南等八个站点，可放心体验。它可以在任意Shopee商品详情页上显示以下相关数据',
		a9: '①产品上架日期；销量/销售额/访客量/转化指数；刷单嫌疑。',
		a10: '②能对Shopee上的商品进行实时监控、查找同款货源、同款竞品等',
		a11: '使用说明：',
		a12: '点击查看:行业推荐/搜索推荐/店铺推荐 三大使用场景',
		a13: '安装指引',
		a14: '方法1：下载的文件解压后放到建议电脑桌面上，方便操作。操作步骤如下：',
		a15: '打开谷歌浏览器-->找到右上角...>然后点击打开找到‘更多工具’-->然后找到‘扩展程序’-->开启开发者模式-->将桌面的.CRX文件直接拖运到开发者模式下的界面,即可完成安装！',
		a16: '方法2：科学上网后，',
		a17: '点击链接',
		a18: '前往google商城直接安装：',
		a19: '扫码下载安卓分销平台APP',
		a20: '卖家端App(安卓)',
		a21: '仓库端App(安卓)',
		a22: '温馨提醒',
		a23: '卖家端APP:可实现审核订单/退货管理以及Shopee多店聊，包括自动翻译、自动回复、多店切换等',
		a24: '仓库端APP:配合PDA或者蓝牙扫描枪,可以实现订单分拣验货,扫描出库,退换货扫描等',
		a25: '打印历史纪录',
		a26: '订单号搜索',
		a27: '搜索',
		a28: '合并打印',
		a29: '选择',
		a30: '名称',
		a31: '打印时间-(最新时间)',
		a32: '打印次数',
		a33: '操作',
		a34: '查看',
		a35: '新增运单号',
		a36: '请输入要新增的运单号：',
		a37: '请输入运单号',
		a38: '确认',
		a39: '验收代打包货物',
		a40: '请确认已收到货物的运单号：',
		a41: '请选择运单号',
		a42: '充值明细',
		a43: '按交易时间查找',
		a44: '按支付时间查找',
		a45: '开始日期',
		a46: '结束日期',
		a47: '至',
		a48: '支付方式：',
		a49: '支付状态：',
		a50: '请选择',
		a51: '排序：',
		a52: '订单',
		a53: '支付订单号',
		a54: '积分',
		a55: '状态',
		a56: '支付方式',
		a57: '创建时间',
		a58: '积分扣减明细',
		a59: '交易类型',
		a60: '订单号',
		a61: '交易时间',
		a62: '剩余积分',
		a63: '产品分类拣货',
		a64: '订单排序',
		a65: '搜索商品名称,SKU',
		a66: '图片',
		a67: '仓库编码',
		a68: '商品ID',
		a69: '商店ID',
		a70: '商店筛选：',
		a71: '退货原因筛选：',
		a72: '导出Excel',
		a73: '全部导出',
		a74: '全部索赔',
		a75: '导出Excel并提交平台客服后，就可点击开始索赔按钮，将此订单列为待索赔状态，避免与新丢包订单混淆',
		a76: '退货原因',
		a77: '金额',
		a78: '更新时间',
		a79: '索赔成功时间',
		a80: '剩余索赔有效时间',
		a81: '开始索赔',
		a82: '查看物流',
		a83: '待联系平台客服',
		a84: '索赔成功',
		a85: '物流信息',
		a86: '运单号：',
		a87: '订单号：',
		a88: '当前状态：',
		a89: '时间',
		a90: '物流详情',
		a91: '填写收货信息',
		a92: '货物类型：',
		a93: '修改',
		a94: '长：',
		a95: '填入物品的长度',
		a96: '宽：',
		a97: '填入物品的宽度',
		a98: '高：',
		a99: '填入物品的高度',
		a100: '重量：',
		a101: '填入物品的重量',
		a102: '点击上传图片',
		a103: '只能上传jpg/png文件，且不超过500kb',
		a104: '温馨提醒',
		a105: '建议进行全部索赔前，先将当前待索赔的订单先导出至excel表进行数据保存，确认后数据将进入索赔中订单列表！',
		a106: '取 消',
		a107: '确认开始索赔',
		a108: '重新加载订单',
		a109: '选择商店：',
		a110: '填入订单：',
		a111: '填入订单号',
		a112: '立即加载',
		a113: '全部',
		a114: '已丢失包裹',
		a115: '派送失败',
		a116: '微信支付',
		a117: '支付宝',
		a118: '未支付',
		a119: '已完成',
		a120: '已关闭',
		a121: '已使用',
		a122: '按积分-由多到少',
		a123: '按积分-由少到多',
		a124: '订单生成时间-由早到晚',
		a125: '订单生成时间-由晚到早',
		a126: '按购买数量-由多到少',
		a127: '按购买数量-由少到多',
		a128: '按SKU-由少到多',
		a129: '按购SKU-由多到少',
		a130: '最近一周',
		a131: '最近一个月',
		a132: '最近三个月',
		a133: '待确认索赔',
		a134: '待索赔',
		a135: '已索赔成功',
		a136: '分销平台客服',
		a137: '充值',
		a138: '消费',
		a139: '物流问题',
		a140: '无',
		a141: '执行该操作会放弃此订单的索赔，确认放弃索赔吗？',
		a142: '提示',
		a143: '请按要求填写收货的信息',
		a144: '执行该操作会放弃此订单的索赔，确认放弃索赔吗？',
		a145: '确定',
		a146: '取消',
		a147: '未付款',
		a148: '已付款',
		a149: '微信',
		a150: '请勾选商品',
		a151: '当前暂无可索赔的订单！',
		a152: '请选择订单',
		a153: '贝分析数据分板插件',
		a154: '选择支付方式',
		a155: '付款二维码加载失败',
		a156: '付款金额：',
		a157: '元',
		a158: '请使用支付宝-扫码支付',
		a159: '请使用微信-扫码支付',
		a160: '放弃支付',
		a161: '支付完成',
		a162: '销售情况',
		a163: '库存周转率：',
		a164: '补货周期：',
		a165: '输入补货周期(纯数字)',
		a166: '确认修改',
		a167: '扣减在途库存',
		a168: '建议采购数',
		a169: '现有数量',
		a170: '在途数量',
		a171: '平均销量/天',
		a172: '补货周期',
		a173: '7天预估销量',
		a174: '14天预估销量',
		a175: '30天预估销量',
		a176: '剩余可销售天数',
		a177: '天',
		a178: '创建采购单',
		a179: '商品名称',
		a180: '库存周转率',
		a181: '最近出库时间',
		a182: '商店销售近况',
		a183: '导出',
		a184: '订单归属',
		a185: '代理商订单',
		a186: '自建订单',
		a187: '卖家订单',
		a188: '商品绑定',
		a189: '添加商品绑定',
		a190: '预售产品',
		a191: '是',
		a192: '否',
		a193: '解 绑',
		a194: '全部订单归属',
		a195: '全部类型',
		a196: '系统初始化',
		a197: '订单出库扣减或重新上架',
		a198: '入库单增加',
		a199: '转仓单核对',
		a200: '库存调拨',
		a201: '仓库修改',
		a202: '缺货提醒',
		a203: '滞销提醒',
		a204: '销售数量',
		a205: '销售额',
		a206: '时间',
		a207: '销量',
		a208: '个缺货提醒--',
		a209: '确认解绑?',
		a210: '解绑成功！',
		a211: '请选择商品',
		a212: '一个月前',
		a213: '控价管理',
		a214: '设置控价',
		a215: '设置数量',
		a216: '保存',
		a217: '属性图',
		a218: 'sku名称',
		a219: '供货价',
		a220: '批发价',
		a221: '分销控价下限',
		a222: '设置代理商上架产品的销售价下限',
		a223: '代理商信息',
		a224: '代理商：',
		a225: '帐号：',
		a226: '仓库编码：',
		a227: '上架店铺数：',
		a228: '线上折后价',
		a229: '下架代理商产品',
		a230: '请输入代理数量(为-1时代表无限制)',
		a231: '成功！',
		a232: '成功提交！',
		a233: '确认要强制下架分销商：',
		a234: '的产品吗？',
		a235: '是的',
		a236: '下架成功！',
		a237: '代理商',
		a238: '编辑',
		a239: '保存更新',
		a240: '代理上架分销的线上售价下限',
		a241: '修改订单信息',
		a242: '是否单品：',
		a243: '仓库选择：',
		a244: '输入搜索的字符',
		a245: '查找',
		a246: '已选择：',
		a247: '暂无仓库产品',
		a248: '所在仓库：',
		a249: '母sku：',
		a250: '在仓库存：',
		a251: '单品',
		a252: '套餐',
		a253: '普通产品',
		a254: '分销产品',
		a255: '按商品名称查找',
		a256: '按仓库编码查找',
		a257: '按产品sku查找',
		a258: '系统检测到您还没启用的仓库，请前往店铺授权进行启用您所需要的仓库！',
		a259: '当前帐号还没有关联仓库的帐号！',
		a260: '暂无描述',
		a261: '设置零售价的计价公式',
		a262: '汇率：人民币兑换当地货币的汇率,如1rmb=5.19泰铢，即：0.192汇率',
		a263: '折扣：如为6折商品，即：40 off',
		a264: '出库费：不同国家价格不一样',
		a265: '新增计算公式',
		a266: '公式',
		a267: '出库费rmb',
		a268: '汇率',
		a269: '地区',
		a270: '利润率%',
		a271: '折扣',
		a272: '设置默认',
		a273: '删 除',
		a274: '确 认',
		a275: '从shopee链接中替换主图',
		a276: '请输入shopee的商品详情页链接的url',
		a277: '正在加载图片资源，请稍候。。。',
		a278: '加载完毕！',
		a279: '确 定',
		a280: '上传属性图片',
		a281: '只能上传jpg文件,且不超过10M',
		a282: '商品填写建议',
		a283: '1.商品标题字符数量大于20，小于120',
		a284: '2.sku长度不超过20字符',
		a285: '发布产品',
		a286: '修改类目',
		a287: '1 基本信息',
		a288: '发布店铺',
		a289: '商品主图',
		a290: '随机排序图片',
		a291: '添加图片水印',
		a292: '从shopee链接替换图片',
		a293: '最多只能上传8个jpg/png文件，且不超过10M',
		a294: '上传图片',
		a295: '商品标题',
		a296: '标题字符数量应控制在20~120之间',
		a297: '商品属性',
		a298: '请输入',
		a299: '2 规格库存',
		a300: '零售价计算:(供货价',
		a301: '毛利率',
		a302: '折扣',
		a303: '自动计算零售价公式',
		a304: '批量助手',
		a305: '批量删除sku相同字符',
		a306: '价格库存',
		a307: '批量设置',
		a308: '字符长度在5~20以内',
		a309: '零售价(当地货币)',
		a310: '库存',
		a311: '绑定的cusCode',
		a312: '删除',
		a313: '包装规格',
		a314: '重 量 (kg)：',
		a315: '体 积(cm)：',
		a316: '物流类型：',
		a317: '发货仓库：',
		a318: '商品描述',
		a319: '请输入内容',
		a320: '立 即 发 布 产 品',
		a321: '发布shopee产品',
		a322: '发布TikTok Shop产品',
		a323: '请补充商品属性图片后再发布',
		a324: '该产品代理异常，请重新代理，再发布上架',
		a325: '请去TIKTOK后台设置发货仓库，如不清楚发货仓地址，请联系店小生客服',
		a326: '产品成功上架至TikTok Shop 商品',
		a327: '请填写零售价!',
		a328: '产品异常，请重新代理或联系平台客服处理！',
		a329: '产品sku不能为空',
		a330: '重量，体积不能为空！',
		a331: '产品主图最多不能超过8张图',
		a332: '请上传2M以下的.xlsx文件',
		a333: '上传头像图片大小不能超过 10MB!',
		a334: '销售属性',
		a335: '规格',
		a336: '发布Lazada产品',
		a337: '请填写零售价',
		a338: '主图数量最多不能超过8张！',
		a339: '首页',
		a340: '我已代理',
		a341: '个人中心',
		a342: '打印',
		a343: '导出PDF',
		a344: '总共箱数:',
		a345: '箱',
		a346: '纸张规格:',
		a347: '纸张宽度:',
		a348: '纸张高度:',
		a349: '毫米',
		a350: '热敏纸',
		a351: '自定义',
		a352: '产品条形码',
		a353: '我的文件',
		a354: '暂无',
		a355: '仓库母sku：',
		a356: '仓库子sku：',
		a357: '仓位：',
		a358: '全部',
		a359: '选择店铺',
		a360: '商品状态',
		a361: '展开剩余店铺',
		a362: '当前与：',
		a363: '正在会话中',
		a364: '会话列表',
		a365: '已读',
		a366: '此消息为语音消息，请登录APP端查看',
		a367: '未读',
		a368: '点击上传',
		a369: '发送',
		a370: '发送的内容不能为空！',
		a371: 'websock链接成功',
		a372: 'websock链接失败',
		a373: '请选择商品规格',
		a374: '店小生分销商城',
		a375: '购物车',
		a376: '全部商品(0)',
		a377: '已选商品',
		a378: '全选',
		a379: '商品信息',
		a380: '单价',
		a381: '数量',
		a382: '授权成功！',
		a383: '错误提示',
		a384: '抱歉，您的访问的店小生页面不存在！',
		a385: '点此返回店小生首页！',
		a386: '店铺选择：',
		a387: '正加载订单',
		a388: '开启多选模式',
		a389: '重新加载当前页',
		a390: '批量设置标记',
		a391: '无',
		a392: '正在获取数据......',
		a393: '数据加载中...',
		a394: '注册中心',
		a395: '手机号码:',
		a396: '用户密码:',
		a397: '确认密码:',
		a398: '验证码:',
		a399: '手机号',
		a400: '用户密码',
		a401: '验证码',
		a402: '获取验证码',
		a403: '立即注册',
		a404: '已有帐号，请前往PC端登录！',
		a405: '立即抢购礼包',
		a406: '店小生',
		a407: '提供跨境出海本地化的海外仓及分销解决方案',
		a408: '专注于中小件美区/东南亚的本地化服务',
		a409: '①提供美区本地独家新奇特货源，可一件定制 柔性生产 ，一件起批。',
		a410: '②提供美区海外仓服务，专攻中小件（服装、家居、手机壳类等）。',
		a411: '③可支持卖家自建家庭仓/海外仓，提供ERP/WMS纯系统服务。',
		a412: '精确库存同步',
		a413: '99.99%库存准确率，绑定多店铺线上库存，杜绝超卖扣分',
		a414: '索赔助手',
		a415: '卖家及时发现因COD拒收或快递派送丢包的订单，方便卖家及时向平台索赔，挽回损失，提升您净利润！',
		a416: '分销平台',
		a417: '东南亚本土现货，一件分销上架，精准库存，关联绑定，防止超卖',
		a418: '虾皮多店聊聊',
		a419: '泰语、越南语、印尼语、马来语、英语 自动翻译，自动回复，多店切换，快捷回复',
		a420: '欢迎登录店小生',
		a421: '帐号登录',
		a422: '注册帐号',
		a423: '输入用户帐号',
		a424: '输入用户密码',
		a425: '登录帐号：',
		a426: '登录密码：',
		a427: '号码地区：',
		a428: '注册帐号：',
		a429: '输入手机号或邮箱',
		a430: '用户昵称',
		a431: '确认密码',
		a432: '请输入验证码',
		a433: '必填项，如无请联系客服',
		a434: '邀请码',
		a435: '马上注册',
		a436: '点击发送验证码',
		a437: '请输入帐号或密码！',
		a438: '请输入手机号码',
		a439: '账户余额不足',
		a440: '成功发送验证码，请留意查收！',
		a441: '请输入邮箱号码，再获取验证码！',
		a442: '请填写用户帐号！',
		a443: '请填写用户的密码！',
		a444: '请填写验证码！',
		a445: '两次输入的密码不一致，请重新确认密码！',
		a446: '注册成功',
		a447: '请填写用户的昵称！',
		a448: '请填入正确帐号密码！',
		a449: '登录成功，正跳转到首页',
		a450: '③ERP支持自动同步Shopee/Lazade不同平台 同款链接的库存，防止超卖！',
		a451: '登录中心',
		a452: '请输入手机号码，再获取验证码！',
		a453: '手机验证码登录',
		a454: '手机号不能为空！',
		a455: '验证码发送异常，请稍候再试！',
		a456: '请输入帐号或密码！',
		a457: '注册成功,正在跳转首页！',
		a458: '手机号为必填项！',
		a459: '注册类型',
		a460: '手机注册',
		a461: '邮箱注册',
		a462: '号码地区',
		a463: '邮箱号码',
		a464: '登录密码',
		a465: '卖家昵称',
		a466: '请输入邮箱号码',
		a467: '请输入密码(6位以上数字,字母组合)',
		a468: '请输入手机的验证码',
		a469: '请输入邮箱的验证码',
		a470: '请输入卖家昵称',
		a471: '邀请码(选填)',
		a472: '两次密码输入不一致，请重新确认密码',
		a473: '请入卖家昵称',
		a474: '注册成功，正在关联贝分析用户信息',
		a475: '关联成功！',
		a476: '关联失败，请联系店小生客服！',
		a477: '东南亚本土化专家',
		a478: '邮箱手机',
		a479: '请填入正确的手机号码！',
		a480: '登陆成功，正前往首页！',
		a481: '国家',
		a482: '一级类目',
		a483: '二级类目',
		a484: '三级类目',
		a485: '总页数',
		a486: '加载打印不出来？',
		a487: '当前打印页',
		a488: '页',
		a489: '每次打印页数',
		a490: '关闭分批打印',
		a491: '开启分批打印功能',
		a492: '面单加载进度',
		a493: 'A4纸',
		a494: 'A5纸',
		a495: '热敏纸（自定义）',
		a496: '面单加载异常',
		a497: '赠品',
		a498: '买家留言',
		a499: '卖家留言',
		a500: '正在获取面单数据，请稍等。。。',
		a501: `<div class="Section0" style="layout-grid:15.6000pt;"><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:center;line-height:12.0000pt;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:21.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="黑体">ShopsBu Privacy Policy</font></span></b><b><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:11.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><o:p></o:p></span></b></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Release date: October 15, 2025 &nbsp;&nbsp;；Effective Date: October 15, 2025</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Thank you for visiting the e-commerce business management platform of Guangzhou Xiangrong Information Technology Co., Ltd. (hereinafter referred to as "us" or "ShopsBU"). This policy applies to Guangzhou Xiangrong Information Technology Co., Ltd., which provides products and services for ShopsBU. We attach great importance to the privacy and personal information security protection of our users (hereinafter referred to as "you"). We will strictly comply with legal and regulatory requirements, take corresponding security measures, and do our best to protect your personal information and privacy security. In view of this, we have formulated this "ShopsBU Privacy Policy" (hereinafter referred to as "this policy") and draw your attention to:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">This policy applies to all functions and services provided by our store's e-commerce business management platform. Please carefully read and thoroughly understand this policy before using the various functions or services we provide. Only after confirming full understanding and agreement can you start using them.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">To protect your relevant rights, this policy will explain to you how Dianxiaosheng's products and services will collect, use, and store your personal information, and what rights you have. Please read, understand, and agree to this policy before using Dianxiaosheng's products and services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Before using our products and services, please carefully read and thoroughly understand this privacy policy. Only after confirming that you fully understand and agree can you start using it. We will check and update our policies from time to time. Please visit this page regularly to ensure that you are aware of the latest version of our privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">By using or continuing to use products and services related to Dianxiaosheng, you agree to our collection, use, storage, and sharing of your information in accordance with this privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">This privacy policy will help you understand the following:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1、 How do we collect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2、 How we use your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3、 How do we share and disclose your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4、 How do we store your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5、 How do we protect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6、 Your rights</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7、 How do we handle the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">8、 How can your personal information be transferred globally</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">9、 How do we use cookies and similar technologies</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">10、 Changes to this policy</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">11、 Contact Us</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1、 How do we collect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">In order to provide services to you and enterprise users, optimize our services, and ensure account security, Dianxiaosheng will collect information that you voluntarily provide, authorize, or generate due to the use of the service when registering or using it in the following ways:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you register an account on the platform or log in to an existing account: We will collect your email address, phone number, login password, name, and country;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you use the waybill query function on the platform, we will collect your waybill number and logistics tracking information;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you use this platform for product order distribution and shipping, we will collect your store name, product information, and shipping address. After obtaining your permission, we will collect the names, phone numbers, addresses, and order information of buyers on your platform from third-party e-commerce platforms such as TEMU and Tiktok Shop (including package information, order items, prices, ordering time, shipping time, etc.);</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Please understand that the functions and services we provide to you are constantly updated and developed. If a certain function or service is not mentioned in the above description and has collected your information, we will separately explain the content, scope, and purpose of the information collection to you through page prompts, interaction processes, website announcements, etc., in order to obtain your consent.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2、 How we use your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">The data we collect during the provision of services to you may be used in the following ways:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Provide services to you. We will collect and store certain types of information about your use of this website. Our purpose of collecting this information is to improve the operation of the website, enable us to provide services, and accurately evaluate the website's performance;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Use your personal information to communicate with you. You may receive notifications from us via email or mobile push notifications you submit, such as when the status of your package changes or when we launch new services, promotions, etc. You can unsubscribe at any time;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Assist us in designing new services and improving our existing services;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Allow you to participate in surveys related to our products and services, conduct market activities related to our services, and push you the latest market activity information and discount plans;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Assist national judicial, administrative, security and other authorities in conducting investigations, and comply with applicable laws, regulations and other obligations promised to the authorities.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3、 How do we share and disclose your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will not sell, rent, trade or otherwise disclose your personal information to anyone under any circumstances, except in the following special circumstances:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Service providers and suppliers: In order to manage, supply, and improve the services of our store staff, as well as for marketing purposes, we may disclose personal information, including transaction information, to service providers and suppliers. Such as logistics companies, suppliers, and payment service providers, data storage and management suppliers, marketing and promotion suppliers, and suppliers that send email and SMS notifications. Used to help us improve our services and products.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Protecting legitimate rights and other legal purposes: We may be required to disclose information, such as being summoned, appearing in court, or being asked by law enforcement officers to conduct investigations, or any other legal requirement for us to disclose such information. We will also disclose personal information when necessary to protect our legal rights or to enforce our terms of use and other agreements. ShopsBUs may provide your personal information based on search warrants, subpoenas, or other lawful and effective inquiries or orders, or other requirements of applicable laws.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Merger and/or sale of assets: We usually do not sell, trade, or rent your personal information to any third-party company in the normal course of business. However, we may acquire, merge, or be acquired by another company, or we may dispose of some or all of our assets, in which case your personal information may be disclosed to another company, subject to compliance with privacy policies.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4、 How do we store your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Your personal information will be transferred and stored in Amazon Cloud, while other personal information will be transferred and stored on Tencent Cloud servers in the United States. Unless required or permitted by law for a longer retention period, we will retain the information collected from or about you for the shortest period of time necessary to achieve the purposes described in this privacy policy. When the information is no longer needed for these purposes, we will delete it or save it in a form that does not identify you. When determining this retention period, we will consider various criteria, including the type of service you request or provide, the nature of our relationship with you, the impact on the services we provide to you if we delete certain information about you, and the retention period required by law. Please note that once you successfully apply to cancel your ShopsBU account, we will complete the review of your account cancellation as soon as possible. After the application is approved, we will completely delete your personal data. If we cease to operate our products or services, we will notify you in the form of individual deliveries or announcements, and delete your personal data after ceasing to operate our products and services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5、 How do we protect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We have implemented industry standard security measures to protect the personal data you provide from unauthorized access, public disclosure, use, modification, damage, or data loss. We will take the following reasonable and feasible measures to protect your personal data:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use encryption technology to ensure the confidentiality of data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use trusted protection mechanisms to prevent malicious attacks on data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We have deployed access control mechanisms to ensure that only authorized personnel can access personal data, and we have organized security and privacy training courses to raise employees' awareness of the importance of protecting personal data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will use secure encryption technology to protect your personal data during transmission. Take all appropriate organizational, managerial, and technical measures to protect the security of the personal data you provide within our internal organization.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our physical, technical, or management safeguards are violated, resulting in unauthorized access, public disclosure, alteration, or destruction of data that damages your legal rights, we will be held responsible. After the unfortunate occurrence of a personal data security incident, we will promptly inform you of the requirements of laws and regulations: the basic situation and possible impact of the security incident, the disposal measures we have taken or will take, as well as suggestions for you to independently prevent and reduce risks, remedial measures taken for you, etc. We will promptly notify you of the situation related to the event through email, letter, phone, push notifications, and other means.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Although our business aims to protect your personal information, please understand that there is currently no 100% security anywhere, whether online or offline. The ShopsBU account requires a username and password to log in. Please protect your username and password and never disclose them to third parties.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6、 Your rights</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">According to the relevant laws, regulations, and standards in your local area, as well as the prevailing practices in other countries and regions, we guarantee that you exercise the following rights over your personal data. You have the right to demand that we:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1. Accessing your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You have the right to access your personal information, except for exceptions provided by laws and regulations. If you want to exercise your data access rights, you can access them yourself through the following methods:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Account information: If you wish to access or edit personal profile information in your account.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can log in to your store's Xiaosheng platform account through: personal homepage → click on the avatar in the upper right corner → click on "personal information" → browse your nickname, phone number, country, and email;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2. Correct your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you discover errors in the personal information we process about you, you have the right to request us to make corrections. You can submit a correction request through the methods listed in "1. Accessing Your Personal Information".</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are unable to correct these personal information through the above link, you can contact us using the contact information listed in Chapter 11 of this Privacy Policy. We will reply to your correction request within 5-7 working days.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3. Delete your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">In the following situations, you can request the deletion of personal information by sending us an email:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our handling of personal information violates laws and regulations;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we collect and use your personal information without your consent;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our handling of personal information violates our agreement with you;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you no longer use our products or services, or if you cancel your account;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we no longer provide you with products or services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we decide to respond to your deletion request, we will also notify the entities that have obtained your personal information from us to delete it in a timely manner, unless otherwise provided by laws and regulations, or if these entities have obtained your independent authorization.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4. Cancel your account</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can cancel the previously registered account at any time. You can send us an account cancellation application email using the contact information listed in Chapter 11 of this privacy policy. We will reply and take relevant actions within 5-7 working days after verifying your identity. After canceling your account, we will cease providing you with products or services and immediately delete your personal information.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5. Obtain a copy of your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You have the right to obtain a copy of your personal information. If you need to obtain a copy of the personal information we have collected from you, you can contact us using the contact information listed in Chapter 11 of this privacy policy. We will reply and take relevant actions within 5-7 working days after verifying your identity. We will submit a copy of your personal information to you via email. Subject to compliance with relevant legal regulations and technical feasibility, we will provide you with a copy of your personal information upon your request.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6. Consumer Rights of California Residents</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">According to the California Consumer Privacy Act, California residents have the right to know, access, and delete their personal data. California residents also have the right to choose not to allow businesses to sell their personal data, as well as the right not to be discriminated against for exercising California's privacy rights. We will not sell your personal data to anyone for any purpose, nor will we discriminate in responding to privacy requests.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are a resident of California, please be sure to review this privacy policy for important information regarding your rights under California privacy laws and how to submit requests to us based on these rights.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7. Responding to your above request</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will respond to the above request within 5-7 working days. Please refer to Chapter 11 of this Privacy Policy for contact information.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will not be able to respond to your request in the following situations:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests related to the fulfillment of legal and regulatory obligations by personal information controllers;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to national security and defense security;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to public safety, public health, and major public interests;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to criminal investigation, prosecution, trial, and execution of judgments;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">The personal information controller has sufficient evidence to indicate that the personal information subject has subjective malice or requests for abuse of rights;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests made to safeguard the significant legitimate rights and interests of personal information subjects or other individuals, such as life and property, but with difficulty in obtaining their consent;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Responding to a request from a personal information subject would result in serious harm to the legitimate rights and interests of the personal information subject or other individuals or organizations;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests involving trade secrets.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7、 How do we handle the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We expect parents or guardians to guide minors in using our services</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are a minor under the age of 14, you should read and agree to this policy under the supervision and guidance of your parents or other guardians before using our products.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2. We attach great importance to protecting the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We protect the personal information of minors in accordance with relevant laws and regulations. In the case of collecting personal information of minors with the consent of parents, we will only use, share or publicly disclose this information when permitted by law, with the explicit consent of parents or guardians, or when necessary to protect minors.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3. Self inspection and receiving feedback</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we find that we have collected personal information of minors without obtaining verifiable parental consent in advance, we will try to delete the relevant data as soon as possible. At the same time, we have established strict rules for the collection and use of underage information to protect the personal information security of children and adolescents. If you are the guardian of a minor and have any questions about the personal information of the minor under your guardianship, please contact us through the contact information disclosed in this policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">8、 How can your personal information be transferred globally</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We are committed to adhering to the highest privacy protection standards in the processing and transfer of personal information worldwide. When you use our services, your personal information may be transferred to servers located on Tencent Cloud. This type of international transfer will follow strict data protection and privacy security measures to ensure the same level of privacy protection as we provide locally to you.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">For personal information transferred to Tencent Cloud servers located in Guangzhou, China, we comply with relevant privacy and data protection laws in China and the United States, including but not limited to ensuring that there are corresponding security measures in place, such as encryption and access control, to safeguard data security and privacy. In addition, we will monitor relevant legal changes to ensure that our practices can adapt to these changes in a timely manner and safeguard users' privacy rights.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will transfer personal information of EU users in accordance with the requirements of the EU General Data Protection Regulation (GDPR). This means that when personal information leaves the European Union and economic regions, we will transfer it by adopting standard contractual terms recognized by the European Commission or when there is sufficient data protection in the receiving country. We promise to regularly evaluate the data protection level of the receiving country and ensure the effective implementation of protection measures.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you have any questions or need assistance regarding the cross-border transfer of your personal information, please contact us.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">9、 How do we use cookies and similar technologies</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use cookies and other similar technologies to enhance your experience using this service. When you use this service, we may use relevant technologies to send one or more cookies or anonymous identifiers to your device to collect and store information about your access and use of this service. We promise not to use cookies for any purposes other than those described in this privacy policy. We use cookies and similar technologies mainly to achieve the following functions or services:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Accelerate navigation</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Track website usage</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Identify user identity, access permissions, and preferences</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Conduct research and diagnosis to improve our content, products, and services</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can refuse or manage cookies or data analytics tools through your browser settings. However, please note that if cookies or data analytics tools are disabled, you may not be able to enjoy the best service experience, and some services may not function properly.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">10、 Changes to this policy</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">To ensure that you are always aware of how we collect, use, and disclose your information, we will post any changes or updates to this privacy policy on this website and encourage you to review this privacy policy from time to time. If we change this privacy policy, we will notify you by modifying the date at the top of this privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">11、 Contact Us</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Please protect your personal information properly and only provide it to others when necessary. If you discover that your personal information has been leaked, especially the username and password of this application, please contact the customer service of this application immediately so that this application can take corresponding measures.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you have any questions about this policy or other related matters, please contact us through https://erp.shopsbu.com// Contact us. You can also send your questions to https://erp.shopsbu.com/ Or send it to the following address:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Address: 1st Floor, Federal Building, No. 30 Caotang Road, Panyu District, Guangzhou City (Address)</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Postal code: 510520.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">隐私政策</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">发布日期：</font>202</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">5</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">年</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">10</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">月</font>15日</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">生效日期：</font>202</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">5</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">年</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">10</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">月</font>15日</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">感谢您访问</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">广州向榕信息科技有限公司</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">电商业务管理平台（以下称</font><font face="system">“我们”或“</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">”）。本政策适用于提供</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">产品和服务的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">广州向榕信息科技有限公司</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">。</font> <font face="system">我们非常重视用户（下称</font><font face="system">“您”）的隐私和个人信息安全保护，我们将严格按照法律法规要求，采取相应安全保护措施，尽力保护您的个人信息及隐私安全。鉴于此，我们制定本《</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">隐私政策》（下称</font><font face="system">“本政策”）并提请您注意：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">本政策适用于我们提供的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">电商业务管理平台所提供的所有的功能和服务。请您在使用我们提供的各项功能或服务前，务必仔细阅读并透彻理解本政策，在确认充分理解并同意后再开始使用。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为保障您的相关权利，本政策将向您说明</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务会如何收集、使用和存储您的个人信息及您享有何种权利，请您在使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务之前，阅读、了解并同意本政策。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">产品服务前，请您务必仔细阅读并透彻理解本隐私政策，在确认充分理解并同意后再开始使用。我们会不时地检查并更新我们的政策，请您定期光顾本页面，以确保对最新版本隐私政策的了解。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您使用或继续使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务，都表示您同意我们按照本隐私政策收集、使用、储存和分享您的信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">本隐私政策将帮助您了解以下内容：</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">一、</font> <font face="system">我们如何收集您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">二、</font> <font face="system">我们如何使用您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">三、</font> <font face="system">我们如何共享、披露您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">四、</font> <font face="system">我们如何存储您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">五、</font> <font face="system">我们如何保护您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">六、</font> <font face="system">您的权利</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">七、</font> <font face="system">我们如何处理未成年人的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">八、</font> <font face="system">您的个人信息如何在全球范围转移</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">九、我们如何使用</font>Cookie和同类技术</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">十、</font> <font face="system">本政策的变更</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">十一、联系我们</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">一、我们如何收集您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为了向您和企业用户提供服务、优化我们的服务以及保障帐号安全，</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">会按照如下方式收集您在注册、使用服务时主动提供、授权或因为使用服务而产生的信息：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您在平台注册账号或登录现有帐户：我们将收集您的电子邮箱地址、手机号码、登陆密码、姓名、国家；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您在平台使用运单查询功能时，我们将收集您的运单号与物流跟踪信息；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您使用本平台进行产品订单配货发货时我们将收集您的店铺名称、商品信息、发货地址。我们通过您的准许后会从</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">TEMU</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">，</font>Tiktok Shop等第三方电商凭他平台收集您所在平台买家的姓名、电话、地址与订单信息（包括：包裹信息、订单商品、价格、商品下单时间、发货时间等）；</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:18.0000pt;
		mso-para-margin-left:0.0000gd;mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
		mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p>&nbsp;</o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们通过页面提示，交互流程，网站公告等方式另行向你说明信息收集的内容、范围和目的，以征得您的同意。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">二、我们如何使用您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们在向您提供服务过程中收集的数据可能会以以下方式使用：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">向您提供服务。我们会收取并存储有关您使用本网站的某些类型的信息。我们收集这些信息的目的是为了让网站更好的运作、使我们能够提供服务、正确的评估网站的运行情况；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">使用您的个人信息与您沟通。您可能会收到我们通过您提交的电子邮件或者手机推送的通知，例如：当您的包裹状态发生改变或者我们有新服务上线、促销等。您可以随时取消订阅；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">帮助我们设计新服务，改善我们现有服务；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">让您参与有关我们产品和服务的调查，开展与服务相关的市场活动，向您推送最新的市场活动信息及优惠方案；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">协助国家司法、行政、安全机关等权利机构开展调查，并遵守适用法律法规及其他向有权机构承诺之义务。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">三、我们如何共享、披露您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们不会以任何情形出售、出租、交易或以其他方式向任何人披露您的个人信息，以下特殊情况下除外：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">服务提供商和供应商：为了管理、供应和改进</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">的服务以及出于市场营销目的，我们可能会向服务提供商和供应商披露包括交易信息在内的个人信息。如物流公司、供应商和支付服务提供商，数据存储和管理供应商、营销和促销供应商、发送电子邮件和</font>SMS通知的供应商。用于帮助我们改进服务、产品。</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">保护合法权利和其他法定目的：我们可能被要求披露信息，如被传唤、法院出庭或被执法机关人员要求进行调查，或者其它任何一切由法律要求我们披露这些信息。</font> <font face="system">我们还会在必要时披露个人信息，以保护我们的合法权利或执行我们的使用条款和其他协议。</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">可能会根据搜查令，传票或其他合法有效的查询或命令或适用法律的其他要求提供您的个人信息。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">合并和</font>/或出售资产：我们通常不会在正常经营过程中向任何第三方公司出售、交易、出租您的个人信息。但是，我们可能会收购、合并或被另一家公司收购，或者我们可能会处置部分或全部资产，在这种情况下，您的个人信息可能会被披露给另一家公司，但须遵守隐私政策 有效。</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">四、我们如何存储您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您的个人信息将被传输并存储</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">亚马逊云</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">中，其他个人信息将被传输并存储美国腾讯云服务器中。除非法律要求或允许更长的保留期，否则我们将在实现本隐私政策所述目的所需的最短时间内保留从您处收集的或关于您的信息。当信息不再需要用于这些目的时，我们会将其删除或以不识别您身份的形式保存。在确定此保留期时，我们会考虑各种标准，包括您请求或提供的服务类型、我们与您关系的性质、如果我们删除您的某些信息，对我们向您提供的服务的影响，以及法律要求的保留期。请注意，当您申请注销您的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">账户成功后，我们将尽快完成对您账户注销的审查。申请获得批准后，我们将完全删除的您的个人数据。如果我们停止经营产品或服务，我们将以逐一交付或公告的形式通知您，并在停止经营产品和服务后删除您的个人数据。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">五、我们如何保护您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们采取的安全措施我们使用了行业标准的安全措施来保护您提供的个人数据免受未经授权的访问、公开披露、使用、修改、损坏或数据丢失。我们将采取以下合理可行的措施来保护您的个人数据：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用加密技术来确保数据的机密性；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用可信的保护机制来防止对数据的恶意攻击；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们部署了访问控制机制，以确保只有授权人员才能访问个人数据，我们举办了安全和隐私培训课程，以提高员工对保护个人数据重要性的认识；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们将使用安全加密技术在传输过程中保护您的个人数据。采取一切适当的组织、管理和技术措施，保护您在我们内部组织中提供的个人数据的安全。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们的物理、技术或管理保障措施被违反，导致未经授权访问、公开披露、更改或破坏数据，从而损害您的合法权利，我们将承担责任。在个人数据安全事件不幸发生后，我们将及时告知您法律法规的要求：安全事件的基本情况和可能产生的影响，我们已经或将要采取的处置措施，以及您可以独立预防和降低风险的建议，为您采取的补救措施等。我们将通过电子邮件、信函、电话、推送通知等方式及时通知您与事件相关的情况。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">虽然我们的业务旨在保护您的个人信息，但请理解，目前在任何地方都不存在</font>100％的安全性，无论线上或线下。 </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">帐户需要用户名和密码才能登录。请保护好您的用户名和密码，绝不向第三方透露。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">六、您的权利</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">根据您当地的相关法律、法规和标准以及其他国家和地区的通行做法，我们保证您对您的个人数据行使以下权利。您有权要求我们</font>:</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">1.访问您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">账户信息</font>:如果您希望访问或编辑您的账户中的个人资料信息。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您可以登陆您的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">平台账号通过：个人主页</font><font face="system">→点击右上角头像→点击「个人资料」→浏览您的昵称、手机号码、国家、邮箱；</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">2.更正您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过</font><font face="system">“1.访问您的个人信息”中罗列的方式提出更正申请。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您无法通过上述链接更正这些个人信息，您可按照本《隐私政策》第十一章中列明的联系方式与我们联系。我们将在</font>5-7个工作日内回复您的更正请求。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">3.删除您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在以下情形中，您可以通过发送邮件向我们提出删除个人信息的请求：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们处理个人信息的行为违反法律法规；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们收集、使用您的个人信息，却未征得您的同意；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们处理个人信息的行为违反了与您的约定；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您不再使用我们的产品或服务，或您注销了账号；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们不再为您提供产品或服务。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">4.注销您的账户</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您随时可注销此前注册的账户。您可按照本隐私政策第十一章中列明的联系方式向我们发送账号注销申请邮件，我们将在验证您身份后的</font>5-7个工作日内回复并进行相关操作。在注销账户之后，我们将停止为您提供产品或服务，并立即删除您的个人信息。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">5. 获取您的个人信息副本</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您有权利获得您的个人信息副本。如您需要获取我们收集的您的个人信息副本您可按照本隐私政策第十一章中列明的联系方式与我们联系，我们将在验证您身份后的</font>5-7个工作日内回复并进行相关操作。我们会将个人信息副本通过邮件的形式提交给您。在符合相关法律规定且技术可行的前提下，我们将会根据您的要求向您提供您的个人信息副本。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">6. 加州居民消费者权益</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">根据《加州消费者隐私法》，加州居民有权了解、访问和删除他们的个人数据。加州居民也有权选择不让企业出售他们的个人数据，也有权不因行使加州隐私权而受到歧视。我们不会出于任何目的将您的个人数据出售给任何人，也不会在回应隐私权请求时进行歧视。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您是加州居民，请务必查看本隐私政策，了解有关您在加州隐私法下的权利以及如何根据这些权利向我们提交请求的重要信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">7. 响应您的上述请求</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">对于以上请求，我们将在</font>5-7个工作日内做出答复，联系方式请见本隐私政策第十一章节。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在以下情形中，我们将无法响应您的请求：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与个人信息控制者履行法律法规规定的义务相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与国家安全、国防安全直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与公共安全、公共卫生、重大公共利益直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与犯罪侦查、起诉、审判和执行判决等直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">涉及商业秘密的请求。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">七、我们如何处理未成年人的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">1. 我们期望父母或监护人指导未成年人使用我们的服务</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">若您是未满</font>14周岁的未成年人，在使用我们的产品前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">2.我们重视保护未成年人个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们根据相关法律法规的规定保护未成年人的个人信息，对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享或公开披露此信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">3. 自查与接收反馈</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。同时我们建立了严格的未成年人信息收集使用规则，以保护儿童和青少年个人信息安全。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策公示的联系方式与我们联系。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">八、您的个人信息如何在全球范围转移</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们在全球范围内对个人信息的处理与转移承诺遵守最高的隐私保护标准。当您使用我们的服务时，您的个人信息可能会被转移到位于腾讯云服务器上。此类国际转移将遵循严格的数据保护和隐私安全措施，确保与我们在您本地提供的隐私保护同等水平。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">对于转移到位于中国广州的腾讯云服务器上的个人信息，我们遵循中国与美国的相关隐私和数据保护法律，包括但不限于，确保有相应的安全措施存在，如加密和访问控制，以保障数据的安全与隐私。此外，我们还将监控相关的法律变动，确保我们的做法能够及时适应这些变化，维护用户的隐私权益。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">针对欧盟用户的个人信息，我们将依照欧盟通用数据保护条例（</font>GDPR）的要求进行数据转移。这意味着当个人信息离开欧盟及经济区域时，我们将通过采用欧盟委员会认可的标准合同条款或在接收国有足够的数据保护水平时进行转移。我们承诺会定期评估接收国的数据保护水平，并确保保护措施的有效执行。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您对于您的个人信息跨境转移有疑问或需要帮助，请与我们联系。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">九、我们如何使用</font>Cookie和同类技术</span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用</font>Cookie和其他类似技术，以提升您使用本服务的体验。当您使用本服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本服务时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">加速导航</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">追踪网站使用情况</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">辨别用户身份、访问权限及偏好</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">进行研究和诊断以改善我们的内容、产品和服务</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您可以通过的浏览器设置拒绝或管理</font>cookies或数据统计工具。但请注意，如果停用cookies或数据统计工具，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">十、本政策的变更</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为了确保您随时了解我们如何收集、使用和披露您的哪些信息，我们将在本网站上发布本隐私政策的任何更改或更新，并鼓励您不时查看本隐私政策。</font> <font face="system">如果我们更改本隐私政策，我们会通过修改本隐私政策顶部的日期来通知您。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">十一、联系我们</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">如您对本政策或其他相关事宜有疑问，请通过</font><font face="微软雅黑">&nbsp;</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">https://erp.shopsbu.com//</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">&nbsp;与我们联系。您也可将您的问题发送至</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">https://erp.shopsbu.com/</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">或寄到如下地址：</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">地址：</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">广州市</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">番禺区草堂路</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">30号</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">联邦大厦一楼</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">&nbsp;（收）</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">邮编：</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">510520</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p></div>`,
		a502: '识别支付码付款',
		a503: '充值金额',
		a504: '实付金额',
		a505: '返现',
		a506: '消费时间',
		a507: '继续登录',
		a508: '微信扫码付款',
		a509: '用户充值成功后,请自行联系平台客服提供开通本土店资料及相关事宜!',
		a510: '客服微信',
		a511: '入库单',
		a512: '立即打印',
		a513: '上传头程物流面单',
		a514: '只能上传jpg/png文件，且不超过8M',
		a515: '入库单号',
		a516: '箱号',
		a517: '详细地址',
		a518: '收货人',
		a519: '电话',
		a520: '登录邮箱',
		a521: '手机号码',
		a522: '密码须由6以上的位字符组合',
		a523: '请输入邮箱！',
		a524: '请输入正确邮箱！',
		a525: '请填入帐号信息！',
		a526: '两次输入密码不一致！',
		a527: '请输入手机号码！',
		a528: '请输入邮箱验证码！',
		a529: '请输入邮箱或卖家名称！',
		a530: '选择地区',
		a531: '(必填)',
		a532: '仓库帐号',
		a533: '仓库名称',
		a534: '仓库密码',
		a535: '邮箱验证码',
		a536: '填入仓库帐号',
		a537: '填入仓库名称',
		a538: '仓库密码至少6位以上，字母,数字,字符组合',
		a539: '复制分享您的专属注册链接，被邀请卖家一旦充值，其金额的1%将立即返现到您账户上，被邀请卖家还能立即收到10元赠送积分，所有积分可以用于分销采购、物流消费和海外仓等使用。赶快分享给您的卖家朋友们吧，共创跨境出海市场',
		a540: '邀请用户注册链接',
		a541: '复制链接',
		a542: '邀请用户链接',
		a543: '帐号异常，请联系客服处理！',
		a544: '成功复制',
		a545: '跨境管理系统',
		a546: '关联绑定',
		a547: '专注服务东南亚本土卖家',
		a548: '关联店小生帐号',
		a549: '请输入你的店小生帐号',
		a550: '立即关联',
		a551: '授权管理',
		a552: '官方合作伙伴',
		a553: '恭喜您，店铺授权成功，请选择你将要进行的操作!',
		a554: '前往首页',
		a555: '审核订单',
		a556: '导入产品',
		a557: '库存产品',
		a558: '注册成功，正在前往登录页！',
		a559: '水印管理',
		a560: '恢复原图',
		a561: '应用所有图片',
		a562: '仅用当前图片',
		a563: '确认返回',
		a564: '确认要继续删除水印吗？',
		a565: '成功删除！',
		a566: '所属仓库',
		a567: '赠送数量',
		a568: '未绑定产品',
		a569: '分',
		a570: '订单已向仓库发起投诉索赔，等待仓库处理！',
		a571: '请确认以下信息',
		a572: '输入备注给卖家(选填)',
		a573: '请填写仓库的留言(必填)',
		a574: '输入订单号查找',
		a575: '待仓库处理的投诉订单',
		a576: '同意本次卖家申诉将扣除积分数量',
		a577: '请填入仓库意愿赔付的积分',
		a578: '申诉详情',
		a579: '仓库留言',
		a580: '平台留言',
		a581: '海外仓投诉中心',
		a582: '订单查找',
		a583: '订单状态',
		a584: '订单实付',
		a585: '预计赔付积分',
		a586: '规格名',
		a587: '数量',
		a588: '下单时间',
		a589: '付款时间',
		a590: '打印时间',
		a591: '出库时间',
		a592: '店铺名称',
		a593: '配送方式',
		a594: '运单号码',
		a595: '平台类型',
		a596: '已赔付',
		a597: '同意',
		a598: '协商',
		a599: '等待平台处理',
		a600: '查看详情',
		a601: '请填写拒绝理由!',
		a602: '成功提交!',
		a603: '新增产品',
		a604: '重置订单',
		a605: '返 回',
		a606: '在仓库存数',
		a607: '更改',
		a608: '确认要删除吗？',
		a609: '订单商品修改成功！',
		a610: '已重置为原始的订单！',
		a611: '用户自建订单',
		a612: '创建订单',
		a613: '填写收货人信息',
		a614: '添加仓库产品',
		a615: '预计总体积重',
		a616: '预计总重量',
		a617: '当仓库类型',
		a618: '预计的快递费',
		a619: '选择物流：',
		a620: '首重',
		a621: '首重费用',
		a622: '续重费用',
		a623: '计费方式',
		a624: '订单备注',
		a625: '给仓库留言：',
		a626: '邮编',
		a627: '请选择国家',
		a628: '省份',
		a629: '城市',
		a630: '地址',
		a631: '体积(长*宽*高/cm)',
		a632: '重量/KG',
		a633: '购买数量',
		a634: '请选择物流',
		a635: '按重量',
		a636: '按体积',
		a637: '取重量/体积重的较大者',
		a638: '请输入收货人',
		a639: '请输入省份',
		a640: '请输入电话',
		a641: '请填入城市',
		a642: '请输入地区',
		a643: '请输入收货人的详细地址',
		a644: '请选择国家地区',
		a645: '创建自建订单的商品必须默认为同一仓库的商品！',
		a646: '已存在重复的仓库产品！',
		a647: '请添加订单的产品！',
		a648: '自建单创建成功!正在返回待审核订单！',
		a649: '带红色星空的内容为必填项！',
		a650: '请选择货品类型',
		a651: '请选择发货仓',
		a652: '添加商品',
		a653: '选择仓库',
		a654: '可输入商品名,sku进行查找',
		a655: '当前审核的仓库',
		a656: '只会自动审核通过现货库存，没有导入在仓产品或在仓库存为0则不会自动通过',
		a657: '主图',
		a658: '当前没有sku可选',
		a659: '仓库母sku',
		a660: '子sku数量',
		a661: '选择SKU',
		a662: '请注意：产品若绑定为虚拟SKU 仓库将不再分拣此产品，此功能适用于虚拟赠品等设置。',
		a663: '绑定虚拟sku',
		a664: '绑定库存产品',
		a665: '修改成功！',
		a666: '请勾选产品',
		a667: '请选择商品的SKU',
		a668: '订单最少要包含一个商品！！！',
		a669: '确认删除?',
		a670: '仓库类型为测品仓,请选择货品类型！！！！',
		a671: '测品仓当前暂不支持开启自动审核功能，请重新选择仓库类型！',
		a672: '请选择审核的仓库',
		a673: '备注订单信息：',
		a674: '批量备注订单信息',
		a675: '订单备注由卖家添加，仅平台内仓库与卖家可见，不填默认为无卖家留言！',
		a676: '绑定失败提示',
		a677: '原因',
		a678: '批量创建自建单',
		a679: '下载导入模版',
		a680: '将excel文件拖到此处，或点击上传',
		a681: '正在加载数据，请稍等。。。',
		a682: '数据加载完成,请刷新页面！',
		a683: '您所选中的订单中，根据仓库实际库存数量和截至发货日期紧急程度筛选后',
		a684: '审核成功',
		a685: '审核详情',
		a686: '预扣积分',
		a687: '审核失败',
		a688: '失败原因',
		a689: '积分费用',
		a690: '截止发货时间',
		a691: '系统提示',
		a692: '实收(￥)-供货总价',
		a693: '供货价*购买数量',
		a694: '可审核通过的现货订单',
		a695: '建议不通过的缺货订单',
		a696: '批量审核订单',
		a697: '开启自动审核',
		a698: '同步订单状态',
		a699: '批量导出',
		a700: '批量备注订单',
		a701: '自建手工订单',
		a702: '创建单个手工单',
		a703: '批量创建手工单',
		a704: '卖家端APP',
		a705: '卖家端手机APP可实现审核订单/退货管理以及Shopee多店聊，包括自动翻译、自动回复、多店切换等',
		a706: '反选',
		a707: '条纪录',
		a708: '预计毛利',
		a709: '供货总价',
		a710: '分销订单',
		a711: '供货商',
		a712: '退审理由',
		a713: '修改订单',
		a714: '备注订单',
		a715: '删除自建单',
		a716: '请选择订单！',
		a717: '成功提交备注信息！',
		a718: '提交异常，稍生重试！',
		a719: '提交成功！',
		a720: '当前没有可审核通过的现货订单！',
		a721: '成功关闭自动审核！',
		a722: '成功开启自动审核！',
		a723: '勾选订单后，再审核！',
		a724: '本次审核',
		a725: '个订单数量里，有',
		a726: '个订单未绑定或审核仓库不一致而无法进行审核， 是否继续审核剩下的',
		a727: '订单？',
		a728: '继续审核剩余订单',
		a729: '好的',
		a730: '待审核',
		a731: 'COD(货到付款)',
		a732: '成功绑定为虚拟sku',
		a733: '绑定成功！',
		a734: '当前已绑定的库存产品：',
		a735: '母SKU',
		a736: '子sku',
		a737: '当前暂无绑定库存产品消息！',
		a738: '请绑定仓库产品后再进行该操作！',
		a739: '确认要还原订单？',
		a740: '确认设置空包？',
		a741: '设置成功！',
		a742: '显示订单 将恢复对对仓库产品线上库存的占用，是否确定取消隐藏？',
		a743: '隐藏订单 将取消对仓库产品线上库存的占用，是否确定隐藏该订单？（显示可恢复）',
		a744: '订单已显示',
		a745: '订单已隐藏',
		a746: '请选择要导出的订单！',
		a747: '本次将导出',
		a748: '个订单的详细信息，是否继续执行导出？',
		a749: '立即导出excel',
		a750: '所有店铺',
		a751: '本次将同步：“',
		a752: '”最近',
		a753: '天的订单,预计花费30-59秒进行订单数据同步，数据同步后，请刷新当页，是否继续进行同步？',
		a754: '订单同步',
		a755: '立即同步',
		a756: '正在同步订单数据，请稍等！',
		a757: '订单数据已同步完成，请刷新！',
		a758: '只能上传excel类型的文件!',
		a759: '当前限制选择 1 个文件，请删除后继续上传',
		a760: '该店铺已解绑',
		a761: '待审核订单',
		a762: '付款2小时内订单不通过审核',
		a763: '开启',
		a764: '订单号查询',
		a765: '订单排序',
		a766: '下单时间由晚到早',
		a767: '下单时间由早到晚',
		a768: '剩余发货时间由多到少',
		a769: '剩余发货时间由少到多',
		a770: '确认要关闭吗？',
		a771: '确认要开启吗？',
		a772: '已开启2小时内订单不通过审核！',
		a773: '已关闭2小时内订单不通过审核！',
		a774: '店铺选项',
		a775: '货物类型',
		a776: '国家地区',
		a777: '订单类型',
		a778: '仓库退审',
		a779: '绑定状态',
		a780: '显示隐藏',
		a781: '普通订单',
		a782: '含有分销产品',
		a783: '自建单',
		a784: '普货',
		a785: '敏感货',
		a786: '平台自建单',
		a787: '未绑定订单',
		a788: '不同仓订单',
		a789: '隐藏',
		a790: '显示',
		a791: '创建手工单',
		a792: '请选择店铺！',
		a793: '已重置订单信息！请刷新！',
		a794: '请选择需要审核的订单！',
		a795: '请选择审核仓库',
		a796: '审核仓库类型为测品仓，请选择货物类型！',
		a797: '当前没有可以审核的现货订单',
		a798: '正在同步订单数据,请稍等！',
		a799: '所属卖家',
		a800: '订单删除成功！',
		a801: '已向卖家提交收到包裹的信息，请耐心等待卖家确认！',
		a802: '请耐心等待卖家确认！！',
		a803: '选择卖家：',
		a804: '该订单已存在！',
		a805: '丢弃包裹',
		a806: '重新上架',
		a807: '其它',
		a808: '填写收到退货信息',
		a809: '选择收货仓',
		a810: '给卖家留言',
		a811: '退货包裹',
		a812: '操作类型',
		a813: '上架数量',
		a814: '退货详情',
		a815: '请选择发货仓',
		a816: '卖家确认退货操作类型:',
		a817: '产品名称',
		a818: '请输入上架的数量',
		a819: '给仓库留言(非必填)',
		a820: '给卖家留言(非必填)',
		a821: '收到退货的仓库',
		a822: '将图片拖到此处，或',
		a823: '暂无图片',
		a824: '当时状态',
		a825: '退货金额',
		a826: '退货',
		a827: '买家昵称',
		a828: '买家eamil',
		a829: '买家发货截止日期',
		a830: '卖家处理退货到期',
		a831: '价格',
		a832: '退货单',
		a833: '取消单',
		a834: '总金额',
		a835: '取消理由',
		a836: '发货类型',
		a837: '发货仓',
		a838: '店铺',
		a839: '全部订单',
		a840: '已取消',
		a841: '退货订单',
		a842: '申请取消',
		a843: '全部店铺',
		a844: '请选择收货仓库',
		a845: '请输入上架数量',
		a846: '卖家正在确认中，请耐心等待！',
		a847: '仓库正在确认中，请耐心等待！',
		a848: '未审核',
		a849: '买家',
		a850: '系统',
		a851: '卖家未能及时回答我的问题',
		a852: '买家未付款，系统自动取消',
		a853: '买家不想要了',
		a854: '包裹已丢失',
		a855: '卖家没有发货',
		a856: '物流无法送达买家区域',
		a857: '包裹已损坏',
		a858: '商品功能损坏',
		a859: '卖家发错货物！',
		a860: '买家没有收到货物',
		a861: '时间段',
		a862: '分销订单总数量',
		a863: '积分收入',
		a864: '导出excel表格',
		a865: '扫描出库(仅海外仓使用)',
		a866: '选择日期',
		a867: '订单编号',
		a868: '查找订单号',
		a869: '打包日期',
		a870: '出库订单数量',
		a871: '出库后取消数',
		a872: '快递揽收数',
		a873: '扣减积分',
		a874: '收入积分',
		a875: '查看订单',
		a876: '导出订单',
		a877: '打印快递签单',
		a878: '物流类型：',
		a879: '卖家类型',
		a880: '敏感货模式',
		a881: '普货模式',
		a882: '已开启敏感货出库模式',
		a883: '已开启普货出库模式',
		a884: '我知道了',
		a885: '扫描出库',
		a886: '暂无卖家留言',
		a887: '暂无条形码',
		a888: '暂无信息',
		a889: '拣货数量异常！',
		a890: '请先扫描订单号！',
		a891: '亲，您还没有绑定shopee的商店哦！',
		a892: '前往绑定shopee商店！',
		a893: '已揽收',
		a894: '未揽收',
		a895: '订单号码',
		a896: '配送方式',
		a897: '卖家备注',
		a898: '推送时间',
		a899: '联系方式',
		a900: '出库积分',
		a901: '生成运单号',
		a902: '初始化面单PDF',
		a903: '重新打印面单',
		a904: '运单已生成完毕，请手动刷新页面!',
		a905: '请生成运单号再打印!',
		a906: '卖家实际出库量',
		a907: '无物流名称',
		a908: '已处理订单',
		a909: '输入订单号查询',
		a910: '出库费',
		a911: '分销订单利润',
		a912: '分销单',
		a913: '店铺筛选：',
		a914: '仓库类型',
		a915: '退 货 订 单',
		a916: '查询',
		a917: '重新绑定',
		a918: '未绑定仓库产品',
		a919: '去绑定',
		a920: '未检测到发货仓',
		a921: '卖家要求处理方式',
		a922: '仓库实际处理方式',
		a923: '退货状态：',
		a924: '卖家核实退货',
		a925: '卖家已确认',
		a926: '已处理',
		a927: '请选择处理方式',
		a928: '卖家确认成功，待仓库处理',
		a929: '该订单处于待审核状态，订单审核后再操作！',
		a930: '测 试',
		a931: '打印方式',
		a932: '面单&拣货单',
		a933: '仅面单',
		a934: '仅拣货单',
		a935: '面单缩放',
		a936: '描述文字',
		a937: '请先填写发货信息',
		a938: '导出xlsx文件',
		a939: '备货单',
		a940: '历史打印纪录',
		a941: '打印时间段',
		a942: '打印类型',
		a943: '打印订单数量',
		a944: '重新打印',
		a945: '测试',
		a946: '面 单 打 印',
		a947: '打印名称',
		a948: '打印时间（第一次）',
		a949: '未打印',
		a950: '已打印',
		a951: '打印订单',
		a952: '打印默认拣货单',
		a953: '已打印了，重新加载当前页',
		a954: '退 回 审 核 失 败',
		a955: '好的，我知道了',
		a956: '订单处理进度',
		a957: '快递已揽收！',
		a958: '仓库已完成扫描出库，等待快递揽收上网！',
		a959: '仓库已完成验货，待仓库扫描出库！',
		a960: '仓库已打印面单分拣，待仓库验货！',
		a961: '仓库已完成配货，待仓库打印面单并分拣！',
		a962: '已审核，待仓库分拣配货！',
		a963: '正在生成运单号,请不要离开当前页！',
		a964: '共',
		a965: '个订单/已完成',
		a966: '订单查询',
		a967: '包含查询',
		a968: '搜索商品名称，商品sku',
		a969: '推送时间排序（由早到晚）',
		a970: '推送时间排序（由晚到早）',
		a971: '填写快递发货人基本信息',
		a972: '发货人姓名',
		a973: '发货人电话',
		a974: '发货人详细地址',
		a975: '批量标记/备注',
		a976: '同步单个订单号',
		a977: '批量导出订单信息',
		a978: '用户修改过的订单',
		a979: '添加标记',
		a980: '货到付款',
		a981: '核对时间',
		a982: '未核对',
		a983: '未出库',
		a984: '物流',
		a985: '未生成',
		a986: '订单进度',
		a987: '催单加急',
		a988: '加急处理中',
		a989: '正在加载待处理的订单,请稍等!!!',
		a990: '成功提交备注信息！',
		a991: '提交异常，稍生重试！',
		a992: '系统检测到您未填写发货基本信息，请先进行填写，以便方便您批量快速打印！',
		a993: '保存成功！',
		a994: '您已加急该订单，每个订单每天只能催单加急一次！',
		a995: '当前订单审核时间未超过24小时，无法催单加急，如审核24小时后仍未打印 可催单，谢谢。',
		a996: '知道了',
		a997: '同一个单每天只能催单一次，确认要加急催单此订单号吗？',
		a998: '催单提醒',
		a999: '已通知仓库人员优先加急处理该订单！',
		a1000: '确认要退审',
		a1001: '个订单吗？',
		a1002: '成功退回审核！',
		a1003: '正在同步，过程大约需要50-60秒！！！',
		a1004: '自建手工单',
		a1005: '卖家已备注',
		a1006: '无标记',
		a1007: '运单已生成完毕，正在刷新当前页面！',
		a1008: '请选择需要进行打印的订单！',
		a1009: '亲爱的用户，如果你已完成订单的打印操作，请刷新当前页，以获取最新的订单状态',
		a1010: '刷新',
		a1011: '刷新页面',
		a1012: '继续全部打印',
		a1013: '剔除重复，继续打印',
		a1014: '地址管理',
		a1015: '收货人',
		a1016: '运单生成失败详情',
		a1017: '生成失败原因',
		a1018: '选择发货物流',
		a1019: '选择物流',
		a1020: '体积/cm',
		a1021: '实际运费',
		a1022: '运单号',
		a1023: '长/cm',
		a1024: '宽/cm',
		a1025: '高/cm',
		a1026: '纯数字',
		a1027: '币种',
		a1028: '运单号',
		a1029: '设置默认发货地址',
		a1030: '设置默认收货地址',
		a1031: '自建物流面单',
		a1032: '批量生成面单&拣货单',
		a1033: '批量打印面单&拣货单',
		a1034: '填写和修改发货人详细信息',
		a1035: '查看历史打印纪录',
		a1036: '一键打印默认面单',
		a1037: '线上库存',
		a1038: '待发数量',
		a1039: '填写自建单的发货物流',
		a1040: '填写测品仓的收费',
		a1041: '请输入高度',
		a1042: '请输入物品的长宽高',
		a1043: '请输入宽度',
		a1044: '请选择物流',
		a1045: '请输入重量',
		a1046: '已成功提交物流发货信息！',
		a1047: '红色星号为必填项，请填入！',
		a1048: '暂无卖家备注',
		a1049: '请填写退回审核的理由',
		a1050: '正常订单',
		a1051: '当前含有未生成运单号,或者正在生成中的订单,确认全部生成运单号后再打印!',
		a1052: '使用此模式打印面单，会导致浏览器弹出多个面单窗口，请尽量选择同一卖家，同一物流的订单进行打印',
		a1053: '我知道了，继续打印',
		a1054: '后台面单数据出错，请重新生成运单号，再确认打印面单！',
		a1055: '含有未生成运单号的订单，请确认生成运单号后再打印！',
		a1056: '请确认订单全部生成了运单号后，再进行打印！',
		a1057: '请设置默认的发货地址再打印',
		a1058: '请设置默认的收货地址再打印',
		a1059: '当前选中的',
		a1060: '订单中，有',
		a1061: '个订单还未生成运单号或正在生成中,请确认选中的订单全部生成运单号后，再进行打印',
		a1062: '订单中，将会有',
		a1063: '个订单会进行重复打印,确认是否继续进行打印？',
		a1064: '待卖家确认',
		a1065: '仓 库 管 理',
		a1066: '仓库单品',
		a1067: '仓库套餐',
		a1068: '仓库赠品',
		a1069: '入 库 在 途',
		a1070: '采 购 管 理',
		a1071: '立即充值',
		a1072: '入驻本土店',
		a1073: '海外仓报价',
		a1074: '纯ERP报价',
		a1075: '二维码转化',
		a1076: '询盘单',
		a1077: '保存绑定',
		a1078: '将左边的商品添加到右边绑定',
		a1079: '选择商品',
		a1080: '将绑定商品',
		a1081: '添加',
		a1082: '正常',
		a1083: '已下架',
		a1084: '首问语设置',
		a1085: '知识库设置',
		a1086: '关键词设置',
		a1087: '当前与',
		a1088: '游客',
		a1089: '超时发货剩余时间',
		a1090: '催单提醒',
		a1091: '泰国',
		a1092: '马来',
		a1093: '支付尾款提示',
		a1094: '填写信息',
		a1095: '修改备注',
		a1096: '修改网采购单号',
		a1097: '多个采购单用逗号(,)隔开',
		a1098: '自定义属性',
		a1099: '修改中转仓',
		a1100: '修改供应商',
		a1101: '修改采购备注',
		a1102: '修改运单号',
		a1103: '状态变更历史',
		a1104: '添加评论',
		a1105: '详情',
		a1106: '更新采购单状态',
		a1107: '修改数量',
		a1108: '预收款比例/%',
		a1109: '到仓结款周期/天',
		a1110: '属性名',
		a1111: '属性值',
		a1112: '中转仓库',
		a1113: '供应商',
		a1114: '审核时间',
		a1115: '审核者ID',
		a1116: '审核状态',
		a1117: '审核备注',
		a1118: '图片预览',
		a1119: '产品图片',
		a1120: '产品信息',
		a1121: '采购仓库存',
		a1122: '所有绑定的线上链接开启自动更新后，将同步此数量，线上库存=在仓库存-锁定库存-待处理库存',
		a1123: '在仓单品库存是当前在仓库 且 未出库的实际剩余数量',
		a1124: '采购产品分类ID',
		a1125: '采购数量',
		a1126: '采购单价',
		a1127: '采购备注',
		a1128: '请输入备注(选填)',
		a1129: '新增中转仓',
		a1130: '请输入仓库名',
		a1131: '中转仓',
		a1132: '仓库ID',
		a1133: '供应商地址',
		a1134: '结算方式',
		a1135: '支付周期/天',
		a1136: '添加供应商',
		a1137: '支付方式:',
		a1138: '运输方式',
		a1139: '更新供应商信息',
		a1140: '支付周期',
		a1141: '供应商名称',
		a1142: '请输入产品名称关键词,采购单号或是国内运单号',
		a1143: '采购仓库',
		a1144: '公共采购员',
		a1145: '采购单号',
		a1146: '已支付首款',
		a1147: '已支付尾款',
		a1148: '分销平台产品',
		a1149: '采购产品',
		a1150: '采购需求发起人',
		a1151: '采购员',
		a1152: '采购组长',
		a1153: '是否中转',
		a1154: '状态最新更新时间',
		a1155: '采购状态',
		a1156: '备注',
		a1157: '直发',
		a1158: '需要中转',
		a1159: '等待',
		a1160: '一级审核',
		a1161: '二级审核',
		a1162: '需支付尾款',
		a1163: '此采购单应支付总积分',
		a1164: '预付比例',
		a1165: '首期应付',
		a1166: '仓库所在',
		a1167: '产品尺寸',
		a1168: '产品重量',
		a1169: '仓位',
		a1170: '商品采购价',
		a1171: '在仓库存',
		a1172: '修改采购数量',
		a1173: '供应商基本信息',
		a1174: '采购单基本信息',
		a1175: '网采购单',
		a1176: '国内运单号',
		a1177: '采购单备注',
		a1178: '预估到货时间',
		a1179: '自定义属性值',
		a1180: '暂无自定义属性值',
		a1181: '采购单评论',
		a1182: '暂无采购单评论',
		a1183: '添加新的评论',
		a1184: '评论者',
		a1185: '评论内容',
		a1186: '不通过',
		a1187: '通过',
		a1188: '更 新',
		a1189: '创建仓库',
		a1190: '采购单',
		a1191: '采购单搜索',
		a1192: '手工创建采购单',
		a1193: '创建供应商',
		a1194: '供应商列表',
		a1195: '我的中转仓库',
		a1196: '暂无产品信息',
		a1197: '查 看 更 多',
		a1198: '隐 藏 产 品',
		a1199: '剩余',
		a1200: '总共',
		a1201: '个产品',
		a1202: '查看状态变更历史',
		a1203: '审核',
		a1204: '结算尾款',
		a1205: '按采购单号',
		a1206: '产品sku',
		a1207: '全部状态',
		a1208: '审核被拒绝',
		a1209: '等待一级审核',
		a1210: '等待二级审核',
		a1211: '采购中',
		a1212: '运往中转仓途中',
		a1213: '到达中转仓',
		a1214: '运往终点仓库途中',
		a1215: '已到达终点仓库',
		a1216: '已入库',
		a1217: '陆运',
		a1218: '海运',
		a1219: '空运',
		a1220: '现金',
		a1221: '在线',
		a1222: '银行卡',
		a1223: '结算尾款成功',
		a1224: '需求发起：',
		a1225: '采购人员：',
		a1226: '采购状态：',
		a1227: '添加成功',
		a1228: '刷新成功',
		a1229: '请填写商品采购单价',
		a1230: '已拒绝',
		a1231: '更新成功',
		a1232: '删除成功',
		a1233: '请选择要更新成的状态',
		a1234: '更新状态成功',
		a1235: '该订单还未通过审核，无法修改状态',
		a1236: '采购单商品已入库，无法修改状态',
		a1237: '供应商创建成功！',
		a1238: '亲爱的用户，如果您已经提交采购单，请刷新当前页，以获取最新的所有采购单',
		a1239: '基 本 信 息',
		a1240: '商品链接:',
		a1241: '描述',
		a1242: '商品图片',
		a1243: '属性名称',
		a1244: '属性类型',
		a1245: '商品规格',
		a1246: '请输入母SKU',
		a1247: '填写属性',
		a1248: '统一设置',
		a1249: '填入库存',
		a1250: '填入sku',
		a1251: '规格sku',
		a1252: '零售价',
		a1253: '商品重量',
		a1254: '商品尺寸',
		a1255: '长',
		a1256: '宽',
		a1257: '高',
		a1258: '预期利润',
		a1259: '是否质检',
		a1260: '产品关键词',
		a1261: '销售状态',
		a1262: '采购成本',
		a1263: '产品供应商',
		a1264: '产品仓库',
		a1265: '图 片 信 息',
		a1266: '封面图',
		a1267: '产 品 属 性',
		a1268: '添加新属性',
		a1269: '普通属性',
		a1270: '规格属性',
		a1271: '规 格 库 存',
		a1272: '多规格',
		a1273: '类型',
		a1274: '规格类型',
		a1275: '零售原价',
		a1276: '物 流 信 息',
		a1277: '其 他 信 息',
		a1278: '更新产品信息',
		a1279: '返回',
		a1280: '需要质检',
		a1281: '免检',
		a1282: '请输入商品名称',
		a1283: '不大于255个字符',
		a1284: '请填写商品的描述',
		a1285: '请选择类目',
		a1286: '请选择规格',
		a1287: '请填写重量',
		a1288: '请填写商品规格',
		a1289: '请填写商品属性',
		a1290: '请输入商品母sku',
		a1291: '上架',
		a1292: '下架',
		a1293: '蓝色',
		a1294: '源数据',
		a1295: '店小生零售商城',
		a1296: '添加到产品库',
		a1297: '请根据站点选择需要发布的商店！',
		a1298: '请选择商店！',
		a1299: '属性为必填项，请填写属性！',
		a1300: '请填写价格，库存，且两者都不能为0',
		a1301: '商品重量为必填项,而且不能为0，请填写！',
		a1302: '物流为必填项,请选择物流',
		a1303: '产品已上架到店小生的零售商城！',
		a1304: '物流信息已同步到最新！',
		a1305: '泰国站',
		a1306: '菲律宾站',
		a1307: '印尼站',
		a1308: '马来站',
		a1309: '台湾站',
		a1310: '越南站',
		a1311: '确认删除吗',
		a1312: '目前商品的规格最多设置两级！',
		a1313: '确认上架产品？',
		a1314: '商品已上架！',
		a1315: '模版创建成功！',
		a1316: '请根据站点选择店铺发布产品！',
		a1317: '请填写价格，库存',
		a1318: '更改值不能为空',
		a1319: '无法匹配',
		a1320: '当前共有',
		a1321: '个产品无法进行自动匹配绑定仓库产品，你可以修改产品sku与仓库sku保持一致后再次绑定或者进行手动绑定',
		a1322: '暂无仓库sku',
		a1323: '供货价：',
		a1324: ',请填写零售原价',
		a1325: '请选择需要采购入库的产品',
		a1326: '个纪录',
		a1327: '搜索仓库编码，sku，产品名称',
		a1328: '生成入库单',
		a1329: '产品入库',
		a1330: '采购单产品入库',
		a1331: '取消当前产品全部入库',
		a1332: '全选当前产品全部入库',
		a1333: '取消选中',
		a1334: '选中入库',
		a1335: '展 开 查 看 更 多',
		a1336: '向 上 隐 藏',
		a1337: '个',
		a1338: '采购单状态筛选',
		a1339: '独立套餐',
		a1340: '全部单品和套餐',
		a1341: '单品库',
		a1342: '套餐库',
		a1343: '填入价格',
		a1344: '请选择绑定的仓库产品',
		a1345: '采集成功',
		a1346: '产品状态',
		a1347: '暂 无 模 版 信 息',
		a1348: '是否预售',
		a1349: '总库存',
		a1350: '总销量',
		a1351: '商品状态',
		a1352: '零售商城',
		a1353: '已发布',
		a1354: '未发布',
		a1355: '发布',
		a1356: '复制',
		a1357: '属性',
		a1358: '隐 藏',
		a1359: '请选择店铺',
		a1360: '上架状态',
		a1361: '属性选择',
		a1362: '请选择单位',
		a1363: '是否二手：',
		a1364: '国家地区:',
		a1365: '产品链接:',
		a1366: '其它规格',
		a1367: '添加新规格',
		a1368: '产品详情',
		a1369: '属性ID',
		a1370: '产品ID',
		a1371: '时间类型',
		a1372: '预期售价',
		a1373: '搜索条件',
		a1374: '产品',
		a1375: '点击修改信息进行填写',
		a1376: '是否单品',
		a1377: '店 铺 类 目',
		a1378: '四级类目',
		a1379: '五级类目',
		a1380: '全 新',
		a1381: '二 手',
		a1382: '添加属性',
		a1383: '全 选',
		a1384: '同步物流方式',
		a1385: '保 存 并 发 布',
		a1386: '保 存 模 版',
		a1387: '仅 保 存 模 版',
		a1388: '立即发布',
		a1389: '产品基本信息',
		a1390: '产品描述',
		a1391: '产品sku名称',
		a1392: '产品采购成本',
		a1393: '产品销售状态',
		a1394: '产品地址',
		a1395: '产品负责人',
		a1396: '产品属性信息',
		a1397: '修改时间',
		a1398: '产品物流信息',
		a1399: '产品长度',
		a1400: '产品宽度',
		a1401: '产品高度',
		a1402: '子sku属性信息',
		a1403: '展开全部',
		a1404: '产品筛选',
		a1405: '修改信息',
		a1406: '审核通过',
		a1407: '已通过审核',
		a1408: '全部站点',
		a1409: '选择仓库：',
		a1410: '供应商：',
		a1411: '模版保存成功！',
		a1412: '审核成功,发布上架产品请前往产品管理',
		a1413: '审核成功,进入产品管理进行发布',
		a1414: '已保存修改',
		a1415: '确认发布到店小生零售商城吗？',
		a1416: '请选择商品！',
		a1417: '产品已下架！',
		a1418: '复制成功！',
		a1419: '确认要删除该母模版吗？',
		a1420: '草稿箱',
		a1421: '站点',
		a1422: '重新编辑',
		a1423: '更新图片',
		a1424: '选择需要绑定的母sku',
		a1425: '搜索cusCode /母sku /子sku',
		a1426: '子sku信息',
		a1427: '模版水印（上传尺寸800*800px/500*500px的PNG水印图片）',
		a1428: '选择站点',
		a1429: '商品母SKU',
		a1430: '正在加载图片水印，请稍候！',
		a1431: '应用全部图片',
		a1432: '仅应用首图',
		a1433: '添加产品图片',
		a1434: '自动绑定',
		a1435: '手动绑定',
		a1436: '已绑定',
		a1437: '设置零售价计算公式',
		a1438: '当地零售原价',
		a1439: '已删除！',
		a1440: '当前纪录已存入草稿箱',
		a1441: '产品的描述信息字数只能是2-3000个字符',
		a1442: '产品sku不能含有非法字符,如:中文/特殊字符',
		a1443: '产品sku,标题，描述不能含有非法字符,如:中文/特殊字符',
		a1444: '第一级规格属性无法删除',
		a1445: ',请填写',
		a1446: '当地的零售原价',
		a1447: '不能为空',
		a1448: '新增',
		a1449: '重置',
		a1450: '采购员帐号详情（最多只能创建5个采购员帐号）',
		a1451: '采购员帐号',
		a1452: '采购员昵称',
		a1453: '新建采购员帐号',
		a1454: '组长',
		a1455: '设为组长',
		a1456: '新增采购员帐号(最多注册5个采购帐号)',
		a1457: '输入采购员昵称',
		a1458: '输入登录密码',
		a1459: '确认登录密码',
		a1460: '采购员昵称是必填项',
		a1461: '密码是必填项',
		a1462: '选择采购产品',
		a1463: '添加选择产品',
		a1464: '中国批发价',
		a1465: '采购详情',
		a1466: '提交',
		a1467: '采购仓库:',
		a1468: '方式:',
		a1469: '中转仓库:',
		a1470: '采购方式:',
		a1471: '普通采购员',
		a1472: '采购员:',
		a1473: '公共采购员:',
		a1474: '不选择默认为自己',
		a1475: '请选择公共采购',
		a1476: '采购组长:',
		a1477: '设定组长',
		a1478: '选择供应商后自动填入',
		a1479: '添加多个网采购单',
		a1480: '添加您需要采购单的自定义属性',
		a1481: '清空已选产品',
		a1482: '添加产品',
		a1483: '网采购单号:',
		a1484: '采购单备注:',
		a1485: '中国运单号:',
		a1486: '需求发起人',
		a1487: '设定成功',
		a1488: '未选择采购组长',
		a1489: '两次输入密码不一致',
		a1490: '您的采购员帐号：',
		a1491: '，密码：',
		a1492: '请添加商品后再提交',
		a1493: '采购单创建成功,去往采购单页面查看',
		a1494: '请先选择采购仓库',
		a1495: '采购成本价',
		a1496: '提交采购单',
		a1497: '需消耗积分',
		a1498: '返回分销平台',
		a1499: '去往采购单管理页',
		a1500: '采购金额',
		a1501: '生成仓库产品',
		a1502: '商品创建成功!',
		a1503: '本次卖家采购总数量',
		a1504: '与仓库实际到货总数量',
		a1505: '一致',
		a1506: '相差',
		a1507: '警告',
		a1508: '已确认的入库单详情',
		a1509: '卖家采购数量',
		a1510: '实际到货数量',
		a1511: '待卖家支付',
		a1512: '已支付',
		a1513: '立方米',
		a1514: '计价标准',
		a1515: '货物总体积',
		a1516: '重量',
		a1517: '应付积分',
		a1518: '确认支付',
		a1519: '打印产品SKU条形码',
		a1520: '打印入库单条形码',
		a1521: '条形码打印',
		a1522: '打印数量',
		a1523: '卖家确认入库信息',
		a1524: '出现差异，请联系仓库核实详情！',
		a1525: '采购价',
		a1526: '仓库实际到货数量',
		a1527: '暂无留言',
		a1528: '退回重核',
		a1529: '确认入库',
		a1530: '入 库 管 理',
		a1531: '正在获取入库单数据，请稍候！',
		a1532: '预计到货',
		a1533: '实际到货',
		a1534: '头程费用',
		a1535: '查看&修改',
		a1536: '打印条形码',
		a1537: '支付成功！',
		a1538: '待店小生确认',
		a1539: '已支付头程单',
		a1540: '店小生正在核对头程单的信息，请耐心等候！',
		a1541: '请勾选产品！',
		a1542: '当前订单状态不允许删除！',
		a1543: '此操作将永久删除当前入库单, 是否继续?',
		a1544: '已退回给仓库重新核对！',
		a1545: '卖家的采购数量与仓库实际收货数量有差异，是否继续执行确认入库操作？',
		a1546: '是 的',
		a1547: '本次确认入库需要支付',
		a1548: '个积分,且需要额外扣除',
		a1549: '个积分的仓库杂费',
		a1550: '本次入库需要额外扣除',
		a1551: '个积分',
		a1552: '好 的',
		a1553: '卖家入库数量与仓库实际核对数量上有差异！',
		a1554: '入库状态',
		a1555: '入库单创建时间',
		a1556: '扫描入库',
		a1557: '入库仓库',
		a1558: '卖家',
		a1559: '仓库额外附加费用',
		a1560: '填入纯数字',
		a1561: '确 认 收 货',
		a1562: '长/cm(必填)',
		a1563: '宽/cm(必填)',
		a1564: '高/cm(必填)',
		a1565: '重量/kg(必填)',
		a1566: '输入给卖家留言',
		a1567: '请填写产品的长，宽，高，重量！',
		a1568: '卖家采购数量与仓库实际到货数量一致，是否确认收货？',
		a1569: '卖家采购数量与仓库实际到货数量不一致，是否继续确认收货？',
		a1570: '已成功提交给卖家确认！',
		a1571: '全部卖家',
		a1572: '已确认采购单',
		a1573: '查询类型',
		a1574: '查询值',
		a1575: '查看监控定价规则',
		a1576: '线上产品',
		a1577: '国家货币',
		a1578: '售价',
		a1579: '绑定对手商品',
		a1580: '已监控产品',
		a1581: '活动ID',
		a1582: '活动价',
		a1583: '到期时间',
		a1584: '解除绑定',
		a1585: '监控价格走向',
		a1586: '修改监控规则',
		a1587: '修改折扣商品信息',
		a1588: '默认',
		a1589: '活动名称',
		a1590: '活动区域',
		a1591: '请选择活动区域',
		a1592: '区域一',
		a1593: '区域二',
		a1594: '活动时间',
		a1595: '即时配送',
		a1596: '活动性质',
		a1597: '美食/餐厅线上活动',
		a1598: '地推活动',
		a1599: '线下主题活动',
		a1600: '单纯品牌曝光',
		a1601: '特殊资源',
		a1602: '线上品牌商赞助',
		a1603: '线下场地免费',
		a1604: '活动形式',
		a1605: '增加折扣商品信息',
		a1606: '活动结束时间',
		a1607: '活动商品',
		a1608: '活动前价格',
		a1609: '活动价格',
		a1610: '限购个数',
		a1611: '绑定用户商品与对手商品',
		a1612: '获取页面商品',
		a1613: '监控底价:',
		a1614: '降价策略:',
		a1615: '下调值：',
		a1616: '绑定选中商品',
		a1617: '规则一',
		a1618: '规则二',
		a1619: '所有的价格都以被监控的最低价为基准',
		a1620: '您确定要解除该产品的绑定吗？',
		a1621: '该功能尚未上线。',
		a1622: '下调0.01%',
		a1623: '默认下调0.01%',
		a1624: '不调整',
		a1625: '下调固定值',
		a1626: '自定义下调百分比',
		a1627: '请输入备注',
		a1628: '产品图',
		a1629: '产品子SKU',
		a1630: '定价规则',
		a1631: '价格监控图',
		a1632: '最后监控价格',
		a1633: '根据商品名查询',
		a1634: '根据母sku查询',
		a1635: '所有商品',
		a1636: '已上架',
		a1637: '商品被禁',
		a1638: '已删商品',
		a1639: '请设置开始区间小于结束区间。',
		a1640: '请输入小于15天的时间区间。',
		a1641: '确认关闭？',
		a1642: '已过期',
		a1643: '进行中',
		a1644: '解除商品绑定成功！',
		a1645: '修改规则成功！',
		a1646: '负责店铺',
		a1647: '选择绑定的店铺，可多选！',
		a1648: '选择绑定的店铺(可多选)',
		a1649: '创建小组',
		a1650: '小组名称',
		a1651: '费用周期',
		a1652: '季度',
		a1653: '月',
		a1654: '自定义项目总费用',
		a1655: '新增费用项',
		a1656: '获取历史费用',
		a1657: '费用名称',
		a1658: '费用名称,如:人工费',
		a1659: '费用金额',
		a1660: '年',
		a1661: '年份',
		a1662: '月份',
		a1663: '店铺自定义费用细项',
		a1664: '小组自定义费用细项',
		a1665: '成功增加费用项！',
		a1666: '修改费用成功！',
		a1667: '请确认是否要删除该费用项?',
		a1668: '请按要求填写内容！',
		a1669: '周期',
		a1670: '选择月',
		a1671: '选择年分',
		a1672: '选择季度',
		a1673: '重新加载当前页面',
		a1674: '商店',
		a1675: '已付款订单金额(销售额)',
		a1676: '销售额环比增长率',
		a1677: '广告费',
		a1678: '货物采购成本',
		a1679: '索赔成功金额',
		a1680: '退货退款金额',
		a1681: '头程运输成本',
		a1682: '暂未绑定店铺',
		a1683: '广告费用',
		a1684: '利润',
		a1685: '利润率',
		a1686: '综合得分',
		a1687: '其他自定义费用项目',
		a1688: '查看自定义费用',
		a1689: '删除小组',
		a1690: '第1季度',
		a1691: '第2季度',
		a1692: '第3季度',
		a1693: '第4季度',
		a1694: '头程运输成本：只需要头程入库单每批次填写准确，便可自动计算每批次应占运费成本，例如不同批次 空运海运费，所占用成本不同，先进先出原则',
		a1695: '当前仅支持自动获取Shopee广告费，其他平台广告费需自己添加自定义费用项目',
		a1696: '利润=销售额-货物采购成本-头程运输成本-广告费用-其他自定义费用项目+索赔成功金额',
		a1697: '货物采购成本：即商品实际采购成本，自动从库存产品采购成本获取计算',
		a1698: '确认要解绑商店?',
		a1699: '成功解绑',
		a1700: '成功绑定！',
		a1701: '删除小组成功！',
		a1702: '创建小组成功！',
		a1703: '分销商不允许代理分销自己的产品！',
		a1704: '我要样品',
		a1705: '扫描联系分销客服获取样品',
		a1706: '微信号',
		a1707: '加载中...',
		a1708: '分销成功！',
		a1709: '分销失败',
		a1710: '帐号或密码不能为空！',
		a1711: '登录成功！',
		a1712: '现货分销产品',
		a1713: '1件代发价',
		a1714: '现货数量',
		a1715: '立 即 分 销',
		a1716: '现货库存',
		a1717: '商品详情',
		a1718: '请登录店小生帐号，再分销产品！',
		a1719: '是否要继续分销该产品吗？',
		a1720: '分销成功！后续上架产品到shopee平台，请前往店小生分销平台“我已代理”进行上架！',
		a1721: '去店小生上架产品',
		a1722: '继续分销产品',
		a1723: '联系客服',
		a1724: '如需获取分销样品，请扫码联系分销平台客服！',
		a1725: '免费使用Shopee数据分析工具',
		a1726: '虾皮贝分析插件',
		a1727: '点击下载',
		a1728: 'shopee主图',
		a1729: 'shopee飙升指数',
		a1730: 'shopee月销量',
		a1731: 'shopee月销售额',
		a1732: 'shopee上架天数',
		a1733: 'shopee最低售价',
		a1734: 'shopee转化指数',
		a1735: '查看源链接',
		a1736: '立即下载店小生APP',
		a1737: '东南亚现货货源 分销热榜',
		a1738: '热荐榜单',
		a1739: '搜索产品名称',
		a1740: '现货库存量',
		a1741: '市场分析',
		a1742: '我要分销',
		a1743: '暂无关联数据',
		a1744: '东南亚的现货分销平台',
		a1745: '分销产品详情',
		a1746: '请输入留言',
		a1747: 'sku规格',
		a1748: '现货库存：',
		a1749: '该产品成功分销到您的店小生帐号上，后续要发布产品至shopee平台，请前往PC端的分销平台：我已代理，继续进行操作！',
		a1750: '发送验证码',
		a1751: '注 册',
		a1752: '已注册，点击登录',
		a1753: '请输入手机号',
		a1754: '请输入用户密码',
		a1755: '请输入用户昵称',
		a1756: '选填',
		a1757: '邮箱帐号',
		a1758: '请填写注册的信息，不能为空！',
		a1759: '注册成功，请前往登录！',
		a1760: '验证码已发送,留意查收！',
		a1761: '请填入手机号码！',
		a1762: '分销首页',
		a1763: '我可供货',
		a1764: '客服联系',
		a1765: '立即登录',
		a1766: '退出当前登录',
		a1767: '东南亚/台湾 现货分销平台',
		a1768: '东南亚本土现货，一件代发',
		a1769: '库存精准，关联绑定，防止超卖',
		a1770: '支持Shopee/Lazade/Shopify本土卖家',
		a1771: '诚邀分销',
		a1772: '推 荐 分 销 产 品',
		a1773: '查看shopee相关情况',
		a1774: '所在地',
		a1775: '当前尚未登录，请登录店小生帐号后，再进行分销操作！',
		a1776: '已退出当前登录！',
		a1777: '请先登录店小生帐号，再分销！',
		a1778: '分销成功，后续发布产品请点击我已代理进行操作！',
		a1779: '店小生用户:',
		a1780: '诚邀您分销他的现货产品，一件代发，提高卖家的净利润！',
		a1781: '我 已 代 理',
		a1782: '当前状态未登录，请前往登录！',
		a1783: '暂无代理的产品！',
		a1784: '已退出当前登录帐号！',
		a1785: '帐号',
		a1786: '绑定店铺数量',
		a1787: '关联仓库数量',
		a1788: '剩余积分数量',
		a1789: '专注东南亚跨境卖家的erp系统',
		a1790: '贝分析免费选品插件',
		a1791: '手机端',
		a1792: '系统指导文档',
		a1793: '技术支持',
		a1794: '条新消息',
		a1795: '退出登录',
		a1796: '暂 无 消 息!',
		a1797: '条最新消息',
		a1798: '条未读消息',
		a1799: '回复',
		a1800: '来自',
		a1801: '个来自系统重要提醒',
		a1802: '查看全部消息',
		a1803: '暂无会话消息',
		a1804: '开启二次密码',
		a1805: '设置后，涉及毛利、采购价等敏感财务数据，需要输入二次密码才可显示',
		a1806: '已付款订单数',
		a1807: '注意：开启二次密码后，将会无法关闭，涉及毛利、采购价等敏感财务数据，需要输入二次密码才可显示！',
		a1808: '请输入二次密码',
		a1809: '修改二次密码',
		a1810: '概览',
		a1811: '商品采购预付款支出',
		a1812: '商品采购预付款收入',
		a1813: '商品采购尾款支出',
		a1814: '商品采购预付款采购员支付给平台的费用',
		a1815: '商品采购预付款系统获得的抽成',
		a1816: '汇率修改成功',
		a1817: '二次密码设置成功！',
		a1818: 'sku销售概览',
		a1819: '货值',
		a1820: '在仓数量',
		a1821: '平均销量/天(近7天)',
		a1822: '最近入库时间',
		a1823: '近30天',
		a1824: '近7天',
		a1825: '近3天',
		a1826: '当前时间段的总销量',
		a1827: '仓库选择',
		a1828: '导出excel文件',
		a1829: '补货周期(天)',
		a1830: '仓库产品查询',
		a1831: '查找仓库编码/sku名称',
		a1832: '创建入库',
		a1833: '查看sku销售情况',
		a1834: '缺货提醒',
		a1835: '扣费明细',
		a1836: '明细',
		a1837: '积分扣费',
		a1838: '扣费描述',
		a1839: '支出明细',
		a1840: '条积分纪录',
		a1841: '订单号查询',
		a1842: '费用类型',
		a1843: '积分变化',
		a1844: '支付来源',
		a1845: '查看扣减明细',
		a1846: '全部仓库',
		a1847: ' 积分更新',
		a1848: '确认继续操作，当前的积分费用将变更为 ：',
		a1849: ' 积分，是否继续执行更新操作！',
		a1850: '是的,立即更新',
		a1851: '积分更新成功！',
		a1852: '积分更新失败，新的收费规则与当前一致！',
		a1853: '收取卖家“',
		a1854: '”的仓库杂费',
		a1855: '收取杂费的仓库',
		a1856: '扣减卖家的积分',
		a1857: '扣减杂费备注内容',
		a1858: '的卖家优惠',
		a1859: '新增优惠',
		a1860: '优惠折扣(0~1之间取值): 0:免费，1:无折扣，0.95:95折',
		a1861: '仓库',
		a1862: '优惠折扣',
		a1863: '关联的卖家用户数量',
		a1864: '积分充裕',
		a1865: '积分欠费',
		a1866: '卖家帐号',
		a1867: '剩余积分状态',
		a1868: '当前小于30积分，请提醒用户及时允值！',
		a1869: '设置优惠',
		a1870: '收取杂费',
		a1871: '隐藏卖家',
		a1872: '显示卖家',
		a1873: '取值范围0~1之间',
		a1874: '材料费',
		a1875: '上架费',
		a1876: '仓储费',
		a1877: '默认SKU超量收费',
		a1878: '相同sku超量收费',
		a1879: '设置成功!',
		a1880: '扣减的积分不能为0！',
		a1881: '备注不能为空！',
		a1882: '成功收取杂费！',
		a1883: '取值范围0.6~1之间',
		a1884: '服务费的优惠取值须在0.6~1之间取值，不能小于0.6',
		a1885: '仓库总概览',
		a1886: '待处理订单',
		a1887: '今日处理订单',
		a1888: '今日积分收入',
		a1889: '当前仓库帐号的子仓',
		a1890: '子仓昵称',
		a1891: '子仓Id',
		a1892: '子仓类型',
		a1893: '测品仓',
		a1894: '海外云仓',
		a1895: '私有仓',
		a1896: '联盟仓',
		a1897: '分销仓',
		a1898: '采购商手机号',
		a1899: '询盘时间',
		a1900: '商品清单',
		a1901: '商品名',
		a1902: '成本价(仅可输入有效的整数或小数)',
		a1903: '选择仓库...',
		a1904: '商品绑定情况',
		a1905: '收货仓库',
		a1906: '清 空',
		a1907: '提 交',
		a1908: '成功绑定商品',
		a1909: '已被绑定',
		a1910: '绑定失败',
		a1911: '被禁',
		a1912: '已删除',
		a1913: '生成仓库商品',
		a1914: '条纪录成功加入',
		a1915: '全部商店',
		a1916: '请输入在仓产品的仓库编码，或在仓库商品中进行操作添加！',
		a1917: '请选择商店再同步商品',
		a1918: '商品已同步完成',
		a1919: '当前没有商品信息，请选择您需要加入仓库的商品',
		a1920: '请选择一个收货仓库',
		a1921: '成功加入',
		a1922: '恭喜你，这是一条成功消息',
		a1923: '绑定商品',
		a1924: '仓库产品至少需要绑定1个线上产品，如不需该产品可直接删除该在仓产品!',
		a1925: '导入类型',
		a1926: '入库类型',
		a1927: '可搜索商品名称，sku',
		a1928: '一键全部导入',
		a1929: '同步lazada产品',
		a1930: '导入仓库商品',
		a1931: '导入在仓单品库',
		a1932: '导入组合套餐库',
		a1933: '在仓单品库',
		a1934: '组合套餐库',
		a1935: '正在同步更新shopee数据，请一段时间后刷新！',
		a1936: '按当前选择商店生成',
		a1937: '按当前选择类目生成',
		a1938: '按当前勾选商品生成',
		a1939: '当前没有勾选商品！',
		a1940: '是否确认删除当前商品?',
		a1941: '正在同步更新lazada数据，请一段时间后刷新！',
		a1942: '同步SHOPEE产品',
		a1943: '类目',
		a1944: '当前数量',
		a1945: '当前还没有选中的类目',
		a1946: '批量导入在仓产品',
		a1947: '按当前选择商店导入在仓单品库',
		a1948: '按当前选择商店导入组合套餐库',
		a1949: '按当前勾选商品导入在仓单品库',
		a1950: '按当前勾选商品导入组合套餐库',
		a1951: '上架中',
		a1952: '按当前选择商店生成在仓单品库',
		a1953: '按当前选择商店生成组合套餐库',
		a1954: '按当前选择类目生成在仓单品库',
		a1955: '按当前选择类目生成组合套餐库',
		a1956: '按当前勾选商品生成在仓单品库',
		a1957: '按当前勾选商品生成组合套餐库',
		a1958: '帐号管理',
		a1959: '手机',
		a1960: '请输入手机验证码',
		a1961: '新的登录密码',
		a1962: '邮箱',
		a1963: '请输入邮箱验证码',
		a1964: '新密码',
		a1965: '当前手机',
		a1966: '修改登录密码',
		a1967: '输入新密码',
		a1968: '手机验证码',
		a1969: '当前邮箱',
		a1970: '二次密码',
		a1971: '请输入手机号！',
		a1972: '密码修改成功，正在退出登录，请重新登录！',
		a1973: '新增地址',
		a1974: '填写收货人',
		a1975: '填写收货人电话',
		a1976: '填写详细地址',
		a1977: '填写邮编',
		a1978: '手机/电话',
		a1979: '收货人不能为空！',
		a1980: '收货人方式不能为空！',
		a1981: '地址不能为空！',
		a1982: '增加成功！',
		a1983: '个人信息页面',
		a1984: '信息管理中心',
		a1985: '帐 号 管 理',
		a1986: '地 址 管 理',
		a1987: '买家画像CRM智能分析',
		a1988: '客户管理理论中：开发一个新客户成本是留住一个老客户费用的',
		a1989: '倍！！老客户的维系和服务尤其重要！！！',
		a1990: '为此，店小生大数据团队 历经1年调整训练模型和算法，正式推出针对卖家的客户分析功能，我们结合了东南亚跨境电商交易特点，采用机器学习算法模型，根据您',
		a1991: '买家历史交易的购买频率/购买金额/纠纷退款概率/最近一次购买时间',
		a1992: '等进行分析。',
		a1993: '智能分类为：',
		a1994: '高价值/高忠诚  低价值/低忠诚 和即将流失高价值',
		a1995: '客户等，此分类算法将有助于您客服在跟进客户时进一步提升客户服务以及挽留可能流失的客户。',
		a1996: '马上去试试',
		a1997: '平均消费时间间隔',
		a1998: '订单数（消费次数）',
		a1999: '最近一次消费至今间隔',
		a2000: '相对类目均价平均消费溢价比',
		a2001: '总消费金额',
		a2002: '订单拒收数',
		a2003: '买家量化分析',
		a2004: '数据筛选条件',
		a2005: '买家名',
		a2006: '忠诚度',
		a2007: '消费能力',
		a2008: '价格敏感度',
		a2009: '购买次数',
		a2010: '购买总金额',
		a2011: '最近购买距今',
		a2012: '买家名：',
		a2013: '最近消费至今间隔',
		a2014: '总价',
		a2015: '货币',
		a2016: '自定义买家分组',
		a2017: '分组名称',
		a2018: '分组描述',
		a2019: '共享描述',
		a2020: '移出描述',
		a2021: '获取历史交易数据',
		a2022: '量化模型指标训练',
		a2023: '买家画像最终分类',
		a2024: '数据计算中...',
		a2025: '黑名单',
		a2026: '云黑名单',
		a2027: '移入云黑名单',
		a2028: '移出云黑名单',
		a2029: '修改名称',
		a2030: '确定修改',
		a2031: '添加自定义分组',
		a2032: '立即添加',
		a2033: '当前阶段',
		a2034: '当前进度',
		a2035: '已训练数据量',
		a2036: '实际总数据量',
		a2037: '您未授权店铺，请先授权',
		a2038: '去往授权',
		a2039: '预计买家训练量',
		a2040: '已授权店铺',
		a2041: '添加授权',
		a2042: '开始训练',
		a2043: '当前您的可用积分',
		a2044: '训练预计消费积分',
		a2045: '*预计计算量与实际计算量可能有稍许出入(误差1%以内)',
		a2046: '订单拒收数量',
		a2047: '购买时间间隔',
		a2048: '平均溢价百分比',
		a2049: '训练已完成',
		a2050: '准备发货',
		a2051: '重新发货',
		a2052: '已发货',
		a2053: '等待确认收货',
		a2054: '正在取消',
		a2055: '正在退货',
		a2056: '高价值',
		a2057: '中价值',
		a2058: '低价值',
		a2059: '已流失',
		a2060: '正在流失',
		a2061: '普通',
		a2062: '忠诚',
		a2063: '低消费',
		a2064: '高消费',
		a2065: '价格不敏感',
		a2066: '价格敏感',
		a2067: '较高消费力',
		a2068: '当前积分不足，请先充值',
		a2069: '当前买家训练量为0，无法进行训练',
		a2070: '当前未授权店铺，无法进行训练',
		a2071: '共享成功',
		a2072: '新增智能客服翻译收费规则',
		a2073: '修改智能客服翻译收费规则',
		a2074: '收费地区',
		a2075: '请选择收费地区',
		a2076: '请选择收费类型',
		a2077: '收费类型',
		a2078: '收费区间设置:',
		a2079: '收费区间',
		a2080: '收取费用',
		a2081: '次',
		a2082: '智能客服及短信收费标准',
		a2083: '智能客服翻译收费标准',
		a2084: '请选择地区',
		a2085: '筛选',
		a2086: '一百亿以内',
		a2087: '永久免费',
		a2088: '万字符数',
		a2089: '字符数',
		a2090: '短信提醒功能报价标准',
		a2091: '* 开启智能提醒功能将会按自动发送的短信量进行扣费，短信价格根据不同国家进行计费。以下为国际短信报价：',
		a2092: '收费',
		a2093: '件',
		a2094: '上海市普陀区金沙江路 1518 弄',
		a2095: '上海市普陀区金沙江路 1517 弄',
		a2096: '回复买家数',
		a2097: '翻译字符数',
		a2098: '确认是否删除?',
		a2099: '添加规则成功',
		a2100: '分类',
		a2101: '查看买家所有订单',
		a2102: '修改采购成本',
		a2103: '运输费用',
		a2104: '当地货币',
		a2105: '提 交 修 改',
		a2106: '运费会直接影响货值的计算,建议输入',
		a2107: '体积/立方米',
		a2108: '采购数量(整数)',
		a2109: '已存在！',
		a2110: '不是同一仓库下的产品,请选择同一仓库的产品！',
		a2111: '预计到货时间必须要与当前日期大于3天以上，当天不计入!',
		a2112: '无商品信息，不能创建采购单',
		a2113: '请填入预计到货日期',
		a2114: '商品数量不能为0',
		a2115: '请选择同一仓库下的商品进行采购',
		a2116: '成功创建入库单：',
		a2117: '无法创建入库单，当前可用积分不足，请充值！',
		a2118: '修改成功，正在返回入库单页面！',
		a2119: '我知道',
		a2120: '到货时间',
		a2121: '请输入当地货币',
		a2122: '当前采购总数',
		a2123: '预计到货日时间',
		a2124: '创 建 入 库',
		a2125: '新增入库产品',
		a2126: '确 认 修 改',
		a2127: '头程运费',
		a2128: '自有渠道',
		a2129: '平台头程',
		a2130: '计费标准',
		a2131: '预计总体积',
		a2132: '预占积分',
		a2133: '每立方米',
		a2134: '每公斤',
		a2135: '实际重或体积重 取大值',
		a2136: '入库产品详情',
		a2137: '成本价',
		a2138: '赠 品',
		a2139: '仓库子sku',
		a2140: '增加单品或套餐',
		a2141: '产品类型',
		a2142: '购买1个以下单品或套餐，将加赠配所设置数量',
		a2143: '赠配件数',
		a2144: '已选',
		a2145: '仓 库 母 Sku',
		a2146: '展 开',
		a2147: '收 起',
		a2148: '入库所有子SKU',
		a2149: '仓库子sku数量',
		a2150: '剩余在仓总库存',
		a2151: '请输入新的仓库子SKU',
		a2152: '输入新的skuName',
		a2153: '体积',
		a2154: '请确认要删除选中的 ',
		a2155: ' 个产品？',
		a2156: '个订单删除失败！',
		a2157: '是否确认删除该商品?',
		a2158: '个订单删除失败',
		a2159: '保存成功',
		a2160: '成功创建在仓单品！',
		a2161: '手动创建赠品耗材',
		a2162: '扫描产品条形',
		a2163: '生成二维码',
		a2164: '前往打印',
		a2165: '二维码',
		a2166: '店铺类型',
		a2167: '目前支持Shopee\Lazade\TikTok小店\Tiki本土店，具体站点 请和客服确认后点击支付以下套餐内容',
		a2168: '个人独享店',
		a2169: '5人内共享企业店',
		a2170: '个人独享企业店',
		a2171: '附',
		a2172: '含本土店1个,分销平台返现1000积分。',
		a2173: '相关报价及服务如下',
		a2174: '1、什么是纯ERP?',
		a2175: '本土卖家在东南亚国家自建仓库，不需要采用我们海外云仓，也可以纯粹只使用ERP、WMS系统，在店铺授权页面 新建私有仓账号(即仓库账号），即可立即使用我们整个高效ERP和仓库WMS处理流程，仅需要支付低至0.05元/订单的系统服务费即可。',
		a2176: '2、为什么使用店小生ERP/WMS系统？',
		a2177: '专为本土卖家设计 永久免费索赔助手一键跟踪物流丢包订单，防止店铺超卖扣分，99.99%库存准确率，绑定多平台多店铺线上库存，1分钟内自动更新线上库存，杜绝店铺超卖&发货超时！',
		a2178: '3、ERP现货分销平台？',
		a2179: '独家东南亚现货分销平台，卖家可随时借助店小生分销平台建立海外分销体系，更多线上代理，支持设置线上最低零售价，实时监控代理售价及控价。',
		a2180: '4、专业的服务团队',
		a2181: '店小生ERP系统专门为东南亚本土卖家量身打造，目前已在马来、泰国、印尼、菲律宾等东南亚多国建立本土服务团队！',
		a2182: '1、为何要入驻本土店？',
		a2183: '入局东南亚的卖家 应该都知道，东南亚国家要求所有电商平台必须倾斜保护本地账户，同时，疫情之下只有Local当地云仓发货才能让买家体验更好 从而转化率更高，利润率也更高，而今年3月份新开的泰马越TIKTOK shop直播冲动消费退换货也只有本地仓才能实现，因此本土店成为东南亚卖家的必选项。',
		a2184: '2、服务对象',
		a2185: '因为安全又合规的高质量账号并不多，数量有限，我们目前仅针对在仓客户或使用店小生分销平台提供，并且严禁仿牌假货等商家，只针对长期布局东南亚的卖家服务。',
		a2186: '3、更多信息',
		a2187: '可入驻国家和平台，我们将不断更新相关信息,详情请点击查看：',
		a2188: '共享文档',
		a2189: '海外仓价格表',
		a2190: '1、什么是海外云仓？',
		a2191: '云仓，俗称海外仓。即根据店铺产品运营效果，将货物提前备货到本土，一旦出单后，24小时内发出货物。可免费使用店小生ERP 并且备货到店小生海外云仓，可以方便您及时管控到货物，自动监控买家COD拒收/纠纷退货订单，高效为卖家提高整体净利润！',
		a2192: '2、海外云仓主要有哪些国家？',
		a2193: '目前店小生的海外云仓服务已经覆盖：越南/泰国/马来/菲律宾/印尼/台湾/等东南亚各国',
		a2194: '3、为什么使用海外云仓？',
		a2195: '①、降低头程运输成本，压缩物流成本;②、24小时内快速发货，提高买家体验;③、退换货及时处理，提高整体净利润',
		a2196: '积分变化明细',
		a2197: '当前时间段的积分变化',
		a2198: '正数:增加积分，负数:扣减积分',
		a2199: '积分扣减类型（默认全部）',
		a2200: '支付类型',
		a2201: '扣费',
		a2202: '费用项',
		a2203: '积分变化前',
		a2204: '积分变化后',
		a2205: '查 找',
		a2206: '预占积分明细',
		a2207: '支出方（店铺）',
		a2208: '收入方（仓库）',
		a2209: '总积分',
		a2210: '可用积分',
		a2211: '查看积分明细',
		a2212: '查看预占积分明细',
		a2213: '充值后，可立即使用海外云仓、测品仓、私有仓等功能',
		a2214: '会员充值说明：1元1积分，充值越多，赠送积分会越多',
		a2215: '暂无此订单号的扣费信息!',
		a2216: '催付提醒',
		a2217: '发货提醒',
		a2218: '签收催评',
		a2219: '不设限',
		a2220: '签收提醒',
		a2221: '确定要提交表单吗？',
		a2222: '正在获取入库纪录！',
		a2223: '暂无入库纪录！',
		a2224: '运输成本',
		a2225: '待平台确认',
		a2226: '待卖家支付头程...',
		a2227: '修改成本价',
		a2228: '新建头程路线',
		a2229: '请选择货物类型',
		a2230: '选择国家',
		a2231: '请选择区域',
		a2232: '新加坡',
		a2233: '扣费方式',
		a2234: '体积或重量最大值',
		a2235: '请选择扣费方式',
		a2236: '计价费用',
		a2237: '中转仓联系人',
		a2238: '中转仓地址',
		a2239: '自有渠道头程',
		a2240: '新增头程',
		a2241: '取最大值',
		a2242: '收货人电话',
		a2243: '海运普货',
		a2244: '空运普货',
		a2245: '陆运普货',
		a2246: '海运敏感货',
		a2247: '空运敏感货',
		a2248: '陆运敏感货',
		a2249: '创建成功!',
		a2250: '删除成功！',
		a2251: '选择以下平台进行店铺授权',
		a2252: '点击授权',
		a2253: '请翻墙后',
		a2254: '再',
		a2255: '即将授权！若该店铺已在其他账号授权，将在原账号自动解绑，无法恢复，请谨慎操作，如不清楚请联系平台客服',
		a2256: '立即授权',
		a2257: '索 赔 助 手',
		a2258: '索赔时效',
		a2259: '赔偿到账',
		a2260: '是系统专为东南亚本土卖家设计的特色功能，能帮助卖家及时发现因COD拒收或快递派送丢包的订单，方便卖家导出表格，可用于向平台索赔的功能。',
		a2261: '一般为30天内，超过30天还未向平台客服索赔 那么将视为放弃索赔资格，最终卖家白白损失一笔赔偿款(如泰国最高2000泰铢)！如果能及时向平台索赔，将马上帮您挽回损失，立即提升您净利润！',
		a2262: '提交平台客服索赔的表格后，系统将自动判断您所索赔的订单是否成功获得赔偿，节省您去查看的时间，一目了然。',
		a2263: '点击下方对应菜单栏《待确认索赔-订单》《索赔中-订单》《已索赔成功-订单》',
		a2264: '待确认索赔',
		a2265: '本土店铺COD货到付款订单 一旦买家拒收，丢包概率提升，系统自动监控丢包包裹、派送失败包裹。',
		a2266: '需要卖家手动点击开始索赔按钮，进入此状态，避免与新到的待确认索赔订单混淆！',
		a2267: '一旦提交平台客服后，系统会自动检察订单已索赔成功以及实际到账金额，并且自动显示在此状态。',
		a2268: '需要您主动联系SHOPEE客服进行索赔，一般告诉她们丢包索赔 并提交Excel表格清单即可。',
		a2269: '索赔中',
		a2270: '收到包裹',
		a2271: '待确认索赔订单',
		a2272: '待联系平台客服订单',
		a2273: '已索赔成功订单',
		a2274: '确认要索赔该订单: ',
		a2275: '确认放弃订单: ',
		a2276: ' 的索赔吗?',
		a2277: '订单已放弃索赔!',
		a2278: '点击全部索赔时,会将当前共',
		a2279: '个订单全部进行索赔,请确认是否要继续执行此操作 ?',
		a2280: '全部索赔成功!',
		a2281: '待卖家联系平台客服',
		a2282: '成功索赔',
		a2283: '输入备注名称',
		a2284: '请填入店铺的备注',
		a2285: '导出当前状态扣费明细',
		a2286: '收入方',
		a2287: '支付方',
		a2288: '私有仓帐号详情（最多只能创建3个私有仓的帐号）',
		a2289: '新建私有仓帐号',
		a2290: '私有仓帐号',
		a2291: '创建分销仓子仓',
		a2292: '创建私有仓子仓',
		a2293: '优惠设置',
		a2294: '当前卖家',
		a2295: '请选择仓库',
		a2296: '请选择优惠类型',
		a2297: '优惠类型',
		a2298: '服务费',
		a2299: '卖家优惠',
		a2300: '取值范围0-1，0.95=95折，1=无折扣，0=免费',
		a2301: '当前没有绑定仓库',
		a2302: '当前没有绑定卖家的帐号',
		a2303: '扣取卖家杂费',
		a2304: '取值范围0.7-1，0.7=7折，1=无折扣',
		a2305: '申请开通分销仓的原因必填',
		a2306: '请填写详细地址',
		a2307: '请填写收货人',
		a2308: '请填写收人联系方式',
		a2309: '请填写分销仓名称',
		a2310: '成功扣取卖家的积分！',
		a2311: '已更新店铺的备注,正在刷新当前页',
		a2312: '绑定成功',
		a2313: '成功创建私有仓子仓！',
		a2314: '已向平台提交创建分销仓的申请，请等候平台处理！',
		a2315: '请填写红色星空的内容！',
		a2316: '新建子仓',
		a2317: '新建联盟仓',
		a2318: '请输入0~1之间的小数！最多只能保留两位小数',
		a2319: '服务费的优惠取值须在0.7~1之间取值，不能小于0.7',
		a2320: '请选择仓库类型！！！',
		a2321: '扣取卖家',
		a2322: '的仓库杂费',
		a2323: '帐号已存在！请重新输入！',
		a2324: '选择国家地区',
		a2325: '请填写私有仓子仓的名称！',
		a2326: '请填写私有仓帐号的密码！',
		a2327: '你已成功创建了私有仓帐号：',
		a2328: ',登录密码：',
		a2329: '创建成功',
		a2330: '成功绑定店铺！',
		a2331: '！ 是否重新授权并解绑原账号？',
		a2332: '注意：解绑后原账号关于此店铺的订单数据将自动清空。',
		a2333: '是否继续授权？',
		a2334: '确认授权',
		a2335: '中国',
		a2336: '已启用',
		a2337: '已禁用',
		a2338: '请填写仓库信息',
		a2339: '成功创建联盟仓！',
		a2340: '即将解绑！解绑后将自动删除该店铺与仓库产品的关联绑定关系，且无法获取店铺订单，无法恢复！请谨慎操作，如不清楚请联系平台客服',
		a2341: '立即解绑',
		a2342: '卖家地址',
		a2343: '输入卖家备注名称',
		a2344: '添加Shopify授权',
		a2345: '商店名',
		a2346: '店铺网址',
		a2347: '私有仓帐号详情（最多只能创建5个私有仓的帐号）',
		a2348: '新建分销子仓',
		a2349: '分销仓名称',
		a2350: '子仓名称',
		a2351: '请输入详细地址',
		a2352: '请输入申请分销仓的描述！',
		a2353: '申请描述',
		a2354: '创建私有仓帐号请微信扫码联系客服人员',
		a2355: '填写子仓的名称',
		a2356: '输入私有仓密码',
		a2357: '仓库收费规则',
		a2358: '启用',
		a2359: '禁用',
		a2360: '暂无类型',
		a2361: '商店名是必填项',
		a2362: '店铺网址是必填项',
		a2363: '申请开通私有仓帐号',
		a2364: '提示：用户创建私有仓帐号时，系统会随机生成一个私有仓帐号，同时系统将给该帐号自动创建一个私有的子仓，请卖家填写子仓的名称！',
		a2365: '每个订单费用',
		a2366: '每月订单数量上限',
		a2367: '退回处理费',
		a2368: '单包裹默认扣费SKU件数',
		a2369: 'sku数量超出默认收费',
		a2370: '单包裹相同sku默认扣费件数',
		a2371: 'SKU超量收费',
		a2372: '打单费',
		a2373: '操作费',
		a2374: '新赠采购员',
		a2375: '创建私有仓和分销仓',
		a2376: '本土卖家在东南亚国家自建仓库，可纯粹只使用ERP系统，在店铺授权页面 新建私有仓账号，即可立即使用我们整个高效ERP处理流程。',
		a2377: '官方网站授权',
		a2378: '店铺本土IP隔离',
		a2379: '授权状态',
		a2380: '当前没有授权的商店',
		a2381: '地址详情',
		a2382: '收费规则',
		a2383: '开启禁用时，用户在触发选择仓库行为时，会隐藏当前仓库',
		a2384: '查看收费规则',
		a2385: '请填写红色星号的内容！',
		a2386: '成功创建子仓！',
		a2387: '导入excel表格',
		a2388: '将文件拖到此处，或',
		a2389: '只能导入后缀为.xlsx/.xls的excel表格',
		a2390: '正在校验文件，请稍等',
		a2391: '确认导入',
		a2392: '产品已在仓库',
		a2393: '绑 定 线 上 产 品',
		a2394: '同步线上产品',
		a2395: '绑定产品',
		a2396: '可查找名称，sku，商品Id',
		a2397: '绑定该产品',
		a2398: '数据校验成功，共',
		a2399: '个sku的产品，请继续操作！',
		a2400: '下架中',
		a2401: '请导入excel表格',
		a2402: '正在同步店铺:',
		a2403: '的线上产品',
		a2404: '同步线上产品预计需要花费15-30S，系统提示成功同步后，请自行刷新页面！',
		a2405: '同步完成，请刷新页面！',
		a2406: '获取数据出错，请稍后再试！',
		a2407: '请选择产品！',
		a2408: '只能选择',
		a2409: '个文件，当前共选择了',
		a2410: '附件格式错误，请删除后重新上传！',
		a2411: '请上传附件！',
		a2412: '超出最大上传文件数量的限制！',
		a2413: '历史采购纪录',
		a2414: '额外费用',
		a2415: '物流费用',
		a2416: '采购时间',
		a2417: '代理商详情',
		a2418: '昵称',
		a2419: '代理的cusCode',
		a2420: '手动创建SKU',
		a2421: '重量(选填)',
		a2422: '体积(选填)',
		a2423: '请输入仓库子SKU',
		a2424: '请输入仓库子SKU的名称',
		a2425: '请输入商品重量（单位/KG',
		a2426: '长（cm）',
		a2427: '宽（cm）',
		a2428: '高（cm）',
		a2429: '绑定线上产品',
		a2430: '新增绑定产品',
		a2431: '折后价',
		a2432: '当前选择要绑定的库存产品',
		a2433: '以下是将要关联绑定的线上产品',
		a2434: '立即绑定',
		a2435: '删除失败提示',
		a2436: '的产品删除失败！',
		a2437: '绑定情况',
		a2438: '个sku成功绑定仓库产品',
		a2439: '个sku绑定失败',
		a2440: '产品已绑定',
		a2441: '关闭，返回仓库产品',
		a2442: '一键导入线上产品并绑定对应关系',
		a2443: '重要!!请特别注意!!!!',
		a2444: '该功能仅适用于 SKU已规划好的店铺，每次使用将首先自动关联绑定已创建仓库产品的线上同款母SKU，',
		a2445: '其次 再自动创建未创建仓库产品的母SKU并合并关联绑定同款母SKU，因此如果线上产品的母SKU 未填写，将创建失败！',
		a2446: '该功能不适合于原SKU未在线上规划的店铺，否则可能造成已创建成功仓库SKU绑定紊乱，',
		a2447: '如不清楚操作，可咨询店小生客服人员，谢谢！！（重要!!请特别注意!!!!）',
		a2448: '请选择导入的商店',
		a2449: '正在加载数据，请稍候...',
		a2450: '配置该套餐的单品',
		a2451: '增加在仓单品',
		a2452: '套餐组合件数',
		a2453: '配件列表',
		a2454: '可搜索仓库编码,仓库子sku',
		a2455: '保存当前的配置选项',
		a2456: '套餐件数',
		a2457: '图片不能为空！',
		a2458: '仓库子SKU不能为空！',
		a2459: 'skuName不能为空！',
		a2460: '仓库产品',
		a2461: '已存在，请勿重复配置！',
		a2462: '模版水印',
		a2463: '更换属性图片',
		a2464: '上架仓库产品至分销平台',
		a2465: '填写分销产品信息',
		a2466: '分销上架',
		a2467: '更新至分销平台',
		a2468: '商品类目',
		a2469: '产品主图',
		a2470: '新增产品图片',
		a2471: '图片随机排序',
		a2472: '添加图片',
		a2473: '规格信息',
		a2474: '以固定供货价上架分销',
		a2475: '以固定毛利率上架分销',
		a2476: '以产品成本价上架分销',
		a2477: '设置默认计算公式',
		a2478: '默认公式',
		a2479: '本土现货价',
		a2480: '从本土现货一件代发的价格（已包含跨境物流费）',
		a2481: '5-99之间',
		a2482: '实收(平台抽成5%)',
		a2483: '平台抽成后实收',
		a2484: '海外本土现货库存',
		a2485: '从中国采购的批发价（不含运输费用）',
		a2486: '平台产业带货源全部支持三七开账期模式，即卖家仅需支付30%定金，供应商按采购单发货到平台集货仓，并运输到平台海外仓，卖家可一个月后才需支付剩余70%尾款',
		a2487: '是否支持3/7帐期',
		a2488: '线上最低零售折后价',
		a2489: '重量体积',
		a2490: '开启固定供货价后，成交后的订单产品费用会按供货价，经平台抽成后结算给供货商，请填写产品的供货价',
		a2491: '开启固定毛利率后，系统会根据绑定的线上产品的最低折后人民币价格自动计算每个sku的分销供货价，请填写固定毛利率（即给每个代理的毛利率空间！）！',
		a2492: '开启产品成本价上架，供货商请自行计算毛利后，再填入供货价',
		a2493: '关闭固定毛利率后，系统将不再根据绑定的线上产品自动计算每个sku的分销供货价，请填写产品的供货价',
		a2494: '最多只能上传9张主图',
		a2495: '产品成本价:',
		a2496: '设置的毛利率不能小于5%的',
		a2497: '商品标题字符数量必须在2-120之间！',
		a2498: '所有sku的字符长度不能大于20！',
		a2500: '供货价不能为0',
		a2501: '已更新至分销平台',
		a2502: '模版绑定成功！',
		a2503: '产品已发布到分销平台',
		a2504: '个sku',
		a2505: '录入失败',
		a2506: '母sku(必填)',
		a2507: '是否敏感货',
		a2508: '线 上 产 品',
		a2509: 'Excel导入仓库产品',
		a2510: '导出产品',
		a2511: '导入仓库产品',
		a2512: '已导入仓库',
		a2513: '取消导入',
		a2514: '导入仓库',
		a2515: '母sku是必填项，当前还有产品的母sku未填写，请填入相应的母sku信息',
		a2516: '选择赠品所配置的单品/套餐',
		a2517: '录入产品条形码',
		a2518: '请输入产品条形码信息',
		a2519: '库存产品详情',
		a2520: '全选当前页',
		a2521: '批 量 操 作',
		a2522: '批量移入套餐库',
		a2523: '批量删除选中产品',
		a2524: '新增子sku',
		a2525: '线上导入',
		a2526: '手动创建',
		a2527: '上架到分销平台',
		a2528: '更新分销平台的产品信息',
		a2529: '上架到TikTok Shop',
		a2530: '仓库母sku信息',
		a2531: '120个以内的字符',
		a2532: '未绑定',
		a2533: '货源',
		a2534: '修改货源',
		a2535: '查看历史采购纪录',
		a2536: '已审核到此仓库的待发货总数量',
		a2537: '产品成本价',
		a2538: '已审核待发货',
		a2539: '全部待发货数量',
		a2540: '锁定库存',
		a2541: '自动是指自动从Shopee获取参加Flash等活动被锁定的库存，手动是指卖家根据实际设定需锁定库存数,默认锁定为0,即不锁定。且卖家无法修改被配置套餐的锁定库存数量，被配套餐锁定值需在组合套餐库中修改。',
		a2542: '包括已审核和未审核的所有待发货的数量',
		a2543: '自动',
		a2544: '手动',
		a2545: '卖家用户',
		a2546: '自动更新线上库存',
		a2547: '开启自动更新在仓库存时，会将该仓库产品所绑定的所有产品的shopee库存，自动同步为该仓库产品的仓实际剩余库存',
		a2548: '是否设置独立包装',
		a2549: '独立库存',
		a2550: '条形码',
		a2551: '录入条形码',
		a2552: '分销供货价',
		a2553: '必填',
		a2554: '移入套餐',
		a2555: '配入单品/套餐',
		a2556: '移入单品',
		a2557: '配置套餐',
		a2558: '查看库存日志',
		a2559: '查看代理商',
		a2560: '所配置套餐',
		a2561: '所配置赠品',
		a2562: '是否继续将该商品设置为敏感货',
		a2563: '是否继续将该商品设置为普货',
		a2564: '批量填写分销供货价(￥)',
		a2565: '填写毛利率(0~1之间的小数)：',
		a2566: '成功新增子SKU！',
		a2567: '只能输入大于0的数字！',
		a2568: '上架至分销平台的产品，毛利率不能小于5%',
		a2569: '分销商品的供货价是必填的,请填写！',
		a2570: '该产品无法进行分销，请联系客服处理！',
		a2571: '图片更换成功！',
		a2572: '已从分销平台下架sku:',
		a2573: ',已从上架到分销平台',
		a2574: '已开启该套餐为独立包装的套装',
		a2575: '已关闭该套餐为独立包装的套装',
		a2576: '所属套餐仓库编码：',
		a2577: '最大字符不能超过35个',
		a2578: '请输入数字',
		a2579: '最大字条不能超过32个',
		a2580: '成功修改属性',
		a2581: '确认要移入套餐库吗？',
		a2582: '确认要移入单品库吗？',
		a2583: '已移入套餐库',
		a2584: '已移入单品库',
		a2585: '个产品将要被称入组合库，请确认？',
		a2586: '成功移入套餐库！',
		a2587: '当前删除选中的 ',
		a2588: ' 个sku产品，请确认是否继续执行此操作？',
		a2589: '成功修改成本价',
		a2590: '输入120个以内的字符！',
		a2591: '成功更新数据！',
		a2592: '上传头像图片只能是 JPG 格式!',
		a2593: '请输入条形码信息！',
		a2594: '产品条形码成功录入！',
		a2595: '开启自动将自动从Shopee获取参加Flash等活动被锁定的库存',
		a2596: '已开启自动锁定库存！',
		a2597: '设置为手动后，将根据卖家实际设定需锁定库存数,默认锁定为0,即不锁定。',
		a2598: '已关闭自动锁定库存！！',
		a2599: '开启自动更新在仓库存时，会将该仓库产品所绑定的所有产品平台库存，自动同步为该仓库产品的仓实际剩余库存，请确认是否要开启？',
		a2600: '已开启自动更新线上库存！',
		a2601: '关闭自动更新在仓库存时，该仓库产品的库存将不会影响所绑定的所有产品的平台库存，请确认是否要继续关闭？',
		a2602: '已关闭自动更新线上库存！',
		a2603: '删除失败！',
		a2604: '选择线上数据源',
		a2605: '商品Id：',
		a2606: '产品分销详情',
		a2607: '从所绑定的线上链接选择数据源',
		a2608: '填入供货价',
		a2609: '预计毛利率需要大于80%，供货价小于当前的50%，才允许设置为清仓产品',
		a2610: '组 合 套 餐',
		a2611: '批量移入单品',
		a2612: '创建仓库套餐',
		a2613: '导出库存产品',
		a2614: '剩余库存总数',
		a2615: '个子sku',
		a2616: '本次成功导入20个仓库产品，共521个子sku,成功绑定58554个子sku,绑定失败5201个子sku',
		a2617: '成功移入单品库！',
		a2618: '请选择产品复制到的目标仓库',
		a2619: '请选择目标仓库',
		a2620: '赠品耗材',
		a2621: '整仓复制产品',
		a2622: '创建赠品耗材',
		a2623: '操作成功！',
		a2624: '仓 库 单 品',
		a2625: '创建仓库单品',
		a2626: '一键从线上导入并绑定',
		a2627: '缺货提醒',
		a2628: '本次成功导入',
		a2629: '个sku,成功绑定',
		a2630: '个子sku,绑定失败',
		a2631: '个子sku,关闭弹窗后，请刷新获取最新仓库产品数据！',
		a2632: '个产品将要被移入组合库，请确认？',
		a2633: '任务留言',
		a2634: '任务进度',
		a2635: '选择任务进度：',
		a2636: '创建新任务',
		a2637: '任务名称',
		a2638: '任务描述',
		a2639: '收费详情',
		a2640: '卖家描述',
		a2641: '仓库未接单',
		a2642: '仓库已接单',
		a2643: '任务已完成',
		a2644: '任务单号',
		a2645: '当前任务进度',
		a2646: '请输入留言内容',
		a2647: '留 言',
		a2648: '选择任务进度',
		a2649: '全部完成费用',
		a2650: '部份完成费用',
		a2651: '增值服务 是平台推行的本土仓特色服务，如找本土主播直播、小语种客服电话沟通、中差评修改等，',
		a2652: '不一定所有海外仓库都开通所有增值服务，如有需求，具体请咨询仓库客服人员，增值服务目前属于内测期间，',
		a2653: '还需各位卖家朋友们携手共同完善，希望能帮到卖家朋友们',
		a2654: '地区选择',
		a2655: '费用详情',
		a2656: '全部完成任务费用',
		a2657: '已出力未完成',
		a2658: '费用',
		a2659: '全部完成任务',
		a2660: '确认完成',
		a2661: '退回',
		a2662: '确认额外费',
		a2663: '删除任务',
		a2664: '仓库接单',
		a2665: '仓库拒接',
		a2666: '确认进度',
		a2667: '仓库已确认',
		a2668: '全部完成',
		a2669: '部分完成',
		a2670: '卖家任务描述',
		a2671: '系统消息',
		a2672: '未完成',
		a2673: '暂无任务类型',
		a2674: '请输入数字！',
		a2675: '创建成功！',
		a2676: '订单状态已退回！',
		a2677: '本次确认完成后，将从卖家积分帐户扣取',
		a2678: '个积分，以及',
		a2679: '个额外积分，共',
		a2680: '个积分，是否继续执行操作？',
		a2681: '结算完成！',
		a2682: '卖家尚未确认本次额外的收费费用，是否继续操作？',
		a2683: '本次确认，卖家将同意仓库提出',
		a2684: '积分的额外费用支出，是否继续执行？',
		a2685: '确认成功！',
		a2686: '继续接受该任务订单吗？',
		a2687: '成功接单',
		a2688: '已向卖家提交额外费用的收费，待卖家确认！',
		a2689: '消息不能为空！',
		a2690: '全 部 展 开',
		a2691: '全 部 收 起',
		a2692: '修改图片',
		a2693: '卖家名称',
		a2694: '独立库存数量',
		a2695: '配置的套餐',
		a2696: '保 存',
		a2697: '编 辑',
		a2698: '草稿箱',
		a2699: '产品条形码/仓库编码 扫描区',
		a2700: '合计',
		a2701: '个母SKU',
		a2702: '原在仓总数',
		a2703: '盘点总数',
		a2704: '保存当前盘点纪录',
		a2705: '盘点完成',
		a2706: 'CUSCODE（条形码）',
		a2707: '原在仓库存',
		a2708: '实际盘点库存',
		a2709: '退回审核理由为必填项！',
		a2710: '没有订单数据！',
		a2711: '恢复',
		a2712: '的盘点纪录',
		a2713: '仓库盘点',
		a2714: '本次盘点总数：',
		a2715: '，是否要继续完成盘点入库的操作？确认后，库存会作出相应的修改，详细请查看库存日志！',
		a2716: '是的，立即入库',
		a2717: '成功入库！',
		a2718: '当前仓库没有此产品！',
		a2719: '打印产品条形码',
		a2720: '批量打印条形码',
		a2721: '材料费倍数',
		a2722: '虚拟仓',
		a2723: '云仓',
		a2724: '自建仓',
		a2725: '已向卖家发起转仓申请，待卖家确认！',
		a2726: '请选择卖家！',
		a2727: '请选择转移的仓库！',
		a2728: '成功转移！',
		a2729: '倍数不能小于1',
		a2730: '成功修改！',
		a2731: '请填写修改库存的理由！',
		a2732: '已成功绑定这些物品',
		a2733: '库存管理',
		a2734: '组合库',
		a2735: '赠品耗材库',
		a2736: '筛选卖家',
		a2737: '在仓产品按出库频类和占用资金等多维数据采用智能算法分析：分为重要(A类)、一般重要(B类)、不重要(C类)',
		a2738: 'ABC智能分类',
		a2739: '尺寸',
		a2740: '绑定商品必需要大于0',
		a2741: '创建采购单成功，采购单号为：',
		a2742: '提交新仓确认',
		a2743: '保存当前纪录后，会覆盖上一次的盘点纪录，请确认是否要继续执行保存当前盘点的操作',
		a2744: '执行此操作后会将转仓数据提交给新仓确认，后续将不能再修改此转仓单的数据，请确认是否继续执行？',
		a2745: '确认成功，待新仓核对入库！',
		a2746: '执行此操作系统会依照当前盘点的产品数量进行实际入库，请确认是否已完成全部了盘点？',
		a2747: '确认成功，已完成入库！',
		a2748: '本次旧仓盘点数量',
		a2749: '与新仓实际盘点数量',
		a2750: '旧仓盘点库存',
		a2751: '新仓盘点库存',
		a2752: '选择转移仓库',
		a2753: '选择转移的仓库',
		a2754: '卖家留言（选填）',
		a2755: '转仓单号',
		a2756: '发起仓库',
		a2757: '留言提醒',
		a2758: '转移仓库',
		a2759: '确认提交',
		a2760: '转仓调拔单',
		a2761: '已完成转仓',
		a2762: '正在转仓中',
		a2763: '发起申请',
		a2764: '卖家确认',
		a2765: '旧仓盘点',
		a2766: '新仓盘点',
		a2767: '接收仓库',
		a2768: '转仓仓库不能与原来的仓库相同！',
		a2769: '仓库，卖家属性不能为空！',
		a2770: '创建转仓单',
		a2771: '选择卖家',
		a2772: '仓库留言（选填）',
		a2773: '创 建',
		a2774: '盘点旧库存',
		a2775: '当前仓库无智能分类数据',
		a2776: '当前仓库无ABC只能分类数据',
		a2777: 'A类:数量5%~10%；出入库频类占比：60%~70%',
		a2778: 'B类:数量10~20%；出入库频类占比：20%~30%',
		a2779: 'C类:数量70%~80%；出入库频类占比：5%~10%',
		a2780: '建议出库摆放：',
		a2781: 'A类：方便拣货位置（如门口、首行货架）',
		a2782: 'B类：普通位置（如中间位置）',
		a2783: 'C类：角落位置（不经常走动，或者考虑合并摆放）',
		a2784: '创 建 赠 品 或 耗 材',
		a2785: '新增仓库子SKU',
		a2786: '一键发布',
		a2787: '所配置分销选品',
		a2788: '当前产品暂无绑定的模版，请绑定模版后，再继续发布？',
		a2789: '好的，新建模版',
		a2790: '绑定模版',
		a2791: '查看当前绑定的模版',
		a2792: '分销该产品',
		a2793: '当前分销的选品联盟仓的发起者还没有绑定产品的发布模版，您可以提醒发起者为该商品绑定模版，或者可以继续分销该产品，然后再绑定自己的新建模版，再进行发布！',
		a2794: '继续分销当前产品',
		a2795: '成功分销该产品！',
		a2796: '是否确认要分销当前产品？',
		a2797: '联 盟 仓 产 品',
		a2798: '分销选品库',
		a2799: '分销成品库',
		a2800: '分销产品概览',
		a2801: '剩余总库存',
		a2802: '代理数量',
		a2803: '您当前并未限制代理数量',
		a2804: 'sku数量',
		a2805: '产品管理',
		a2806: '代理控价',
		a2807: '添加必需待审信息',
		a2808: '商品采集',
		a2809: '一键采集',
		a2810: '链接采集',
		a2811: '当前仅支持shopee平台的商品进行采集，请输入商品详情页面的链接！',
		a2812: '添加到产品模板中心',
		a2813: '仓 库 母SKU',
		a2814: '母商品名',
		a2815: '仓库子商品名(选填)',
		a2816: '填入仓库子sku',
		a2817: '仓库子商品名',
		a2818: '长度(选填)',
		a2819: '宽度(选填)',
		a2820: '高度(选填)',
		a2821: '请输入仓库母sku',
		a2822: '不大于80个字符',
		a2823: '不大于120个字符',
		a2824: '下载原图',
		a2825: '更换属性图',
		a2826: '是否支持3/7分期',
		a2827: '商品体积',
		a2828: '请上传图片！',
		a2829: '请在编辑状态下上传图片',
		a2830: '更新成功！',
		a2831: '保存图片',
		a2832: '是否支持一件定制POD',
		a2833: '参与',
		a2834: '不参与',
		a2835: '免费样品申请',
		a2836: '提交申请',
		a2837: '成功提交免费样品申请，查看申请进度，请往前：我已代理——样品申请模块',
		a2838: '样品申请',
		a2839: '时间范围',
		a2840: '申请状态',
		a2841: '待发货',
		a2842: '待退回',
		a2843: '申请时间',
		a2844: '申请人',
		a2845: '收件人',
		a2846: '退回意见',
		a2847: '退回备注',
		a2848: '审核意见',
		a2849: '审核备注',
		a2850: '当前快递信息暂未更新，请耐心等待，如有疑问请联系供应商',
		a2851: '快递信息',
		a2852: '样品反馈视频/照片',
		a2853: '供应商正在处理，稍后会退回积分',
		a2854: '分销平台APP: 可实现APP选货分销，发布到Shopee、 Lazada、TikTok等平台，包括订单审核退换货管理、同声翻译等',
		a2855: '选择导入分销仓的产品',
		a2856: '完善产品信息',
		a2857: '上一步',
		a2858: '下一步',
		a2859: '可搜索产品cusCode，母/子SKU，商品名称',
		a2860: '供货价(单位:人民币)',
		a2861: '供货价即提供给卖家的一件代发价，卖家每出库一件需要支付的采购成本',
		a2862: '实收即扣减掉系统佣金后，供应商实际收入',
		a2863: '实收',
		a2864: '可供销库存',
		a2865: '代表海外仓或私有仓实际在仓可供分拨的最大库存量',
		a2866: '分拨库存只能从实际在仓库存中调拨，因此不超过实际在仓库存量',
		a2867: '分拔库存',
		a2868: '请输入商品名称！',
		a2869: '请输入商品的母sku',
		a2870: '供货价是必填项！',
		a2871: '调拔的库存不能大于产品的在仓库存！',
		a2872: '确认提交？',
		a2873: '成功创建分销产品，正在执行分拔库存，绑定模版操作,暂不要离开当前页面',
		a2874: '成功分拔库存！',
		a2875: '添加到待审',
		a2876: '添加成功并已保存原模版',
		a2877: '默认零售价计算公式',
		a2878: '暂存草稿箱',
		a2879: '上架的规格名称字符最多不能超过20个！',
		a2880: '商品标题的字符数须大于20少于100',
		a2881: '选择发布店铺后, 系统自动获取类目信息',
		a2882: '选择类目',
		a2883: '已选分类',
		a2884: '确认类目，继续发布产品',
		a2885: '请选择类目！',
		a2886: '确认类目，继续发布shopee产品',
		a2887: '发布TikTok产品',
		a2888: '确认类目，继续发布TikTok产品',
		a2889: '待审核订单数量',
		a2890: '待审订单数量',
		a2891: '固定毛利率',
		a2892: '查看绑定链接',
		a2893: '关闭固定毛利率后，系统将不再根据绑定的线上产品自动计算每个sku的分销供货价，确认继续关闭？',
		a2894: '仓库产品还没有绑定线上链接！',
		a2895: '仓库产品没有子SKU信息！',
		a2896: '商品已从分销平台下架！',
		a2897: '固定毛利率的产品无法更改分销供货价格！',
		a2898: '成功修改供货价',
		a2899: '商品名:',
		a2900: '母sku:',
		a2901: '调拔库存',
		a2902: '保存修改',
		a2903: '基本信息',
		a2904: '商品名称:',
		a2905: '商品描述:',
		a2906: '一件代发价(本土)',
		a2907: '加入到采购意向单',
		a2908: '尾程物流：',
		a2909: '商品体积：',
		a2910: '商品重量：',
		a2911: '采购意向清单',
		a2912: '该规格暂无图片',
		a2913: '清空“采购意向单”',
		a2914: '去生成采购单',
		a2915: '该产品已存在采购意向清单中，无法再次加入',
		a2916: '已更新绑定的模版',
		a2917: '商品绑定详情',
		a2918: '可自动绑定',
		a2919: '预售状态',
		a2920: '预售天数',
		a2921: '开启全部售罄转预售',
		a2922: '关闭全部售罄转预售',
		a2923: '剩余库存',
		a2924: '是否已绑定',
		a2925: '解绑',
		a2926: '绑定',
		a2927: '新增仓库商品信息',
		a2928: '库存数量',
		a2929: '请选择需更换的仓库母SKU（原绑定和配置关系不变）',
		a2930: '可搜索母sku',
		a2931: '商品转为预售时，如该商品有参加shopee的Bundle Deal，My shop`s Flash Sale，Top Picks的商品促销活动，请自行退出以上活动！',
		a2932: '应用',
		a2933: '还原',
		a2934: '类目属性',
		a2935: '基本属性',
		a2936: '确认发布',
		a2937: '库存价格',
		a2938: '新建模版信息',
		a2939: '选择国地家区',
		a2940: '填入模版名',
		a2941: '站点选择',
		a2942: '绑 定 模 版',
		a2943: '退回审核',
		a2944: '产品创建时间',
		a2945: '发布至',
		a2946: '产品异常，请重新代理！',
		a2947: '退回成功！',
		a2948: '请选择一个模版进行绑定！',
		a2949: '东南亚海外仓系统解决方案',
		a2950: '自建海外仓系统同时支持ERP/WMS，支持Shopee/Lazade等平台,库存同步/一键分销/索赔助手/多店聊等',
		a2951: '提供一站式店铺管理解决方案',
		a2952: '免费使用',
		a2953: '0成本入行',
		a2954: '无需初装费/无需服务器/一键创建',
		a2955: '专业团队支持',
		a2956: '一整套海外仓管理体系培训与技术支持协助让您海外仓业务快速起飞。',
		a2957: '快速上手',
		a2958: '极简版傻瓜式操作，多语言系统(中英泰越）方便东南亚本地人快速学习上手。',
		a2959: '更多收益来源',
		a2960: '审核通过优质货代可享受同行价，支持更多庄家头程/多国海外仓同行价。',
		a2961: '卖家及时发现因COD拒收或快递派送丢包的订单，方便卖家及时向平台索赔，挽回损失，提升您净利润',
		a2962: '微信识别二维码',
		a2963: '添加客服微信',
		a2964: '我们的优势',
		a2965: '提供优质海外仓储服务',
		a2966: '7*12小时贴心客服',
		a2967: '服务器集群分布式',
		a2968: '海外服务器',
		a2969: '微信扫码',
		a2970: '扫码下载',
		a2971: '仓库端App',
		a2972: '专注服务东南亚本土卖家的海外仓系统',
		a2973: 'WMS系统入口',
		a2974: '合作商加盟',
		a2975: 'App下载',
		a2976: '本土卖家',
		a2977: '防超卖',
		a2978: '多平台多店铺自动同步库存',
		a2979: '海外仓管',
		a2980: '易上手',
		a2981: '播种式WMS',
		a2982: '多语言',
		a2983: '极简化',
		a2984: '数据安全',
		a2985: '系统稳',
		a2986: '极致高效',
		a2987: '东南亚',
		a2988: '多年专注东南亚本土化服务',
		a2989: '马上体验',
		a2990: '支持',
		a2991: '请使用 IE10以上版本、 Chrome 、 Firefox 浏览 最佳分辨率1440×900以上',
		a2992: '专业东南亚海外仓系统解决方案',
		a2993: '东南亚货代',
		a2994: '0成本创建海外仓',
		a2995: '支持加盟仓入驻，轻松管控海外仓客户',
		a2996: '免费创建东南亚WMS线上海外仓',
		a2997: '极简版傻瓜式操作，多语言系统(中英泰越）',
		a2998: '方便东南亚本地人快速学习上手。',
		a2999: '一整套海外仓管理体系培训与技术支持协助',
		a3000: '让您海外仓业务快速起飞。',
		a3001: '自建海外仓系统',
		a3002: '同时支持ERP/WMS，支持Shopee/Lazade等平台',
		a3003: '库存同步/一键分销/索赔助手/多店聊等',
		a3004: '东南亚/台湾的现货分销平台',
		a3005: '联系我们，马上0成本创建 东南亚海外仓系统！',
		a3006: '全部售罄转预售',
		a3007: '可选',
		a3008: '绑定产品配件库存',
		a3009: `仅当该成品是由多个配件组合成为一个产品SKU时，例如：一个闹钟由1个钟表体+2个5号电池组合而成<br/>
		一个闹钟成品SKU对外销售，一旦售出1件闹钟成品，则扣减1个钟表体配件库存和2个5号电池配件库存，<br/>
		且该闹钟成品库存数量取决于配件组合数。`,
		a3010: '增加',
		a3011: '选用店小生头程路线',
		a3012: '预计重量',
		a3013: '预计体积',
		a3014: '创建提交入库单',
		a3015: '已选所有子SKU',
		a3016: '仅当该成品是由多个配件组合成为一个产品SKU时，例如：一个闹钟由1个钟表体+2个5号电池组合而成一个闹钟成品SKU对外销售，一旦售出1件闹钟成品，则扣减1个钟表体配件库存和2个5号电池配件库存，且该闹钟成品库存数量取决于配件组合数。',
		a3017: '成功删除该商品！',
		a3018: '当前商品删除失败！',
		a3019: '请选择需要删除的仓库产品！',
		a3020: '输入的件数至少等于或大于1',
		a3021: '只能上传Excel（即后缀是.xlsx）的文件',
		a3022: '文件大小不得超过10M',
		a3023: '文件上传成功',
		a3024: '请选择需要创建入库的商品',
		a3025: '仓库编码为',
		a3026: '更新在仓图片',
		a3027: '只能上传jpg/png文件',
		a3028: '增 加 在 仓 单 品',
		a3029: '关闭自动更新在仓库存',
		a3030: '开启自动更新在仓库存',
		a3031: '预计到货时间',
		a3032: '到货日时间',
		a3033: '输入运费(运费会直接影响货值的计算,建议输入)',
		a3034: '组合套餐库配置简介',
		a3035: `<p style="color:red;font-weight:bold;font-size:16px">如果您线上店铺有销售组合套餐类产品，则需要配置好组合套餐库（如没有组合套餐情况 则可忽略）</p>
		<br />
		<p>第一步. 建立【组合套餐库】：通过【手动创建】或【导入产品】导入线上产品；</p>
		<p>注意，仅需要导入1条链接，剩余其他线上同款产品链接需绑定到刚导入生成的仓库产品，建议采用最全子SKU的链接导入作为创建在仓产品。</p>
		<router-link :to="{path:'/userStoreItems/products'}">
			<p style="color:#409EFF;padding:10px 0;cursor:pointer">如果您线上销售产品是在仓的单品，请看在仓单品库的配置简介。</p>
		</router-link>
		
		<br />
		<p>第二步. 配置【组合套餐】：点击子SKU的【配置套餐】，从已生成的【在仓单品库】进行选择配置；</p>
		<br />
		<p>①必须要先创建好【在仓单品库】才能配置组合套餐，详看"在仓单品库设置简介"）</p>
		<p>②单品和套餐必须处于同个仓库中（不可以单品创建在马来海外仓，套餐却泰国海外仓进行配置）</p>
		<p>③以下情况套餐无法删除：已配置单品时（需先解配），已入库在途时（需先完成或删除入库单）</p>
		<br />
		<p>第三步. 绑定线上链接：将【组合套餐库】里的产品与各线上店铺的商品进行关联绑定；</p>
		<br />
		<p>①可自动关联绑定（前提是各线上店铺母SKU需要完全一致）</p>
		<p>②可手动关联绑定（一个个子SKU去绑定对应店铺线上产品）</p>
		<p>③可直观编辑所有店铺的自动关联绑定情况。</p>
		<br />
		<p>第四步. 开启同步线上库存：批量操作或单独点击子sku的【自动更新线上库存】，会开始同步线上套餐实际库存；</p>
		<br />
		<p>1、套餐实际剩余库存 取决于在仓单品配比库存数。例如卖套餐是红色笔2件套，单品库剩余红色笔10件，那么按配比，套餐仅剩余5件库存。</p>
		<br />
		<p>2、套餐库存无法直接修改，仓库只需要盘点【在仓单品库】实际数量。套餐库是虚拟配置的，因此库存取决于实际在仓单品。出入库都在【在仓单品库】中进行。</p>`,
		a3036: '以 后 不 再 提 醒',
		a3037: '开关更新线上库存',
		a3038: '批量移入单品库',
		a3039: '批量更换所属母SKU',
		a3040: '创 建 套 餐',
		a3041: '手 动 创 建',
		a3042: '线 上 导 入',
		a3043: '绑定所有子SKU',
		a3044: '手动关联绑定',
		a3045: '自动关联绑定',
		a3046: '删除母sku',
		a3047: '手动新增仓库子SKU',
		a3048: '线上导入仓库子SKU',
		a3049: '编辑绑定线上情况',
		a3050: '取决于该套餐所配置实际在仓单品所能组合而成的最大库存数量',
		a3051: '绑定的产品的在线库存将始终更新为在仓库的实际线上库存（预售产品除外)',
		a3052: '独立包装商品',
		a3053: '独立包装库存',
		a3054: '移入单品库',
		a3055: '取消独立包装',
		a3056: '设置独立包装',
		a3057: '本次共 ',
		a3058: ' 个产品已关闭自动更新在仓库存！',
		a3059: '已关闭自动更新在仓库存！',
		a3060: ' 个产品已开启自动更新在仓库存！',
		a3061: '已开启自动更新在仓库存！',
		a3062: '个产品将要被称入单品库，请确认？',
		a3063: '确认要移入单品库吗?',
		a3064: '已移入单品库！',
		a3065: '设置为自动后，将根据卖家实际设定需锁定库存数,默认锁定为0,即不锁定。',
		a3066: '请确认是否设置为独立包装商品?',
		a3067: '请确认是否取消独立包装商品?',
		a3068: '取消成功！',
		a3069: '录入产品条形',
		a3070: '请输入条形码信息',
		a3071: '待发货套餐消耗单品的总库存',
		a3072: '配置该单品的套餐',
		a3073: '套装仓库编码',
		a3074: '套餐配置件数',
		a3075: '销定库存',
		a3076: '待发货套餐数',
		a3077: '在仓单品库设置简介',
		a3078: `			<p style="color:red;font-weight:bold;font-size:16px">注意！仓库产品有且只有一个，所有线上同款子SKU 都必须绑定同一个在仓产品，才能有效同步更新库存。</p>
		<br />
		<p>第一步. 建立【在仓单品库】：通过【手动创建】或【导入产品】导入线上产品；</p>
		<p>注意，仅需要导入1条链接，剩余其他线上同款产品链接需绑定到刚导入生成的仓库产品，建议采用最全子SKU的链接导入作为创建在仓产品。</p>
		<router-link :to="{path:'/userStoreItems/accessories'}">
			<p style="color:#409EFF;padding:10px 0;cursor:pointer">如果您线上销售产品有组合套餐，请看组合套餐配置简介，如果没有套餐，则进入第二步。</p>
		</router-link>
		<br />
		<p>第二步. 将【在仓单品库】里的产品与各线上店铺的商品进行关联绑定；</p>
		<br />
		<p>①可自动关联绑定（前提是各线上店铺母SKU需要完全一致）</p>
		<p>②可手动关联绑定（一个个子SKU去绑定对应店铺线上产品）</p>
		<p>③可直观编辑所有店铺的自动关联绑定情况。</p>
		<br />
		<p>第三步. 开启同步库存，批量操作或单独点击子sku的【自动更新线上库存】，会开始同步线上库存。</p>
		<br />
		<p>1. 出库：平台任何一个商品售出1件库存，店小生所有关联的商品也会同时减去1件库存</p>
		<p>2. 入库：新到货商品，经卖家与仓库双方确认后，库存将自动增加对应商品的到货数量。</p>
		<p>3. 预占：平台任何一个商品参加Flash闪购活动，可自动预占该仓库库存，待活动开始后再释放销售</p>
		<br />
		<p>注意！同款多个线上产品链接 不可 直接导入生成多个仓库产品，因为实物就一个，要库存同步精准，就必须先建立【在仓单品】或【组合套餐】，通过【在仓产品】或【组合套餐】 去绑定多个同款线上链接（例如Shopee或Lazade不同店铺同款的线上链接），即多个线上同款子SKU绑定同一个在仓产品。</p>`,
		a3079: '根据备货周期自动预测即将缺货产品，默认备货周期是7日（可修改）',
		a3080: '创 建 单 品',
		a3081: '整仓产品复制',
		a3082: '整仓导出',
		a3083: '请勾选！',
		a3084: '驳回备注：',
		a3085: '已驳回',
		a3086: '是否要对该样品申请自建订单?',
		a3087: '批量上传情况',
		a3088: '正在上传产品，请稍等。。。',
		a3089: '上传情况',
		a3090: '批量发布TikTok Shop产品',
		a3091: '重新选择类目',
		a3092: '产品列表',
		a3093: '根据设定的公式计算零售价',
		a3094: '暂无公式',
		a3095: '点击设定！',
		a3096: '立即设置',
		a3097: `设置零售价的计价公式，从左到右依次为出库费、汇率、折扣、利润率：
		<p>1.出库费：目前马来仓库出库费为3元，可填3</p>
		<p>2.汇率：人民币兑换当地货币的汇率,如1rmb=1.5马币，即：0.667汇率</p>
		<p>3.利润率：即您想赚的毛利率，如30%则设置30</p>
		<p>4.折扣：如准备设置销售价为原价的6折，即：40 off </p>`,
		a3098: '马上发布',
		a3099: '成功发布',
		a3100: '全部产业带',
		a3101: '暂无产业带',
		a3102: '清仓',
		a3103: '支持3/7分期',
		a3104: '品牌方视频素材',
		a3105: '类别：',
		a3106: '筛选一件定制POD产品',
		a3107: '卖家如何分销货源？',
		a3108: '查找母sku',
		a3109: '查找产品名称',
		a3110: '查找仓库编码',
		a3111: '部分产品免出库费，其他根据海外仓标准按包裹收费',
		a3112: '预计毛利率',
		a3113: '一件代发价',
		a3114: '出库操作费',
		a3115: '免费',
		a3116: '本土现货库存',
		a3117: '联系分销商',
		a3118: '帐期采购',
		a3119: '请确认是否分销该产品？',
		a3120: '已成功代理分销该产品，您可以继续分销商品，可以在“我已代理”查看所有已分销的产品。',
		a3121: '搜索仓库编码',
		a3122: '搜索产品母sku',
		a3123: '所有产业带',
		a3124: '代理商家',
		a3125: '代理商帐号',
		a3126: '代理商名称',
		a3127: '分销活动',
		a3128: '清仓提示',
		a3129: '当前供货价',
		a3130: '线上最低零售折后价（RMB）',
		a3131: 'h5分享页链接',
		a3132: '个卖家已代理该产品',
		a3133: '活动描述',
		a3134: '一级返佣比例',
		a3135: '二级返佣比例',
		a3136: '商品最低库存',
		a3137: '活动商品类目',
		a3138: '立即报名',
		a3139: '三级返佣比例',
		a3140: '清仓商品：毛利率需大于等于80%，且供货价小于当前供货价的50%以',
		a3141: '未符合条件',
		a3142: '清仓供货价',
		a3143: '多级返佣，分销扩客，活动火热招募中',
		a3144: '供货商操作指引',
		a3145: '生成 “我的分销分享页”',
		a3146: '上架日期',
		a3147: '我要清仓',
		a3148: '清仓商品',
		a3149: '下架分销',
		a3150: '分销产品更新成功！',
		a3151: '清仓商品的毛利率需大于80%以上',
		a3152: '清仓供货价要小于当前供货价的50%以上',
		a3153: '已提交！',
		a3154: '该产品当前共有',
		a3155: '个卖家正在线上销售,暂不支持用户从分销平台上下架该商品，如需强制下架请联系平台客服?客服微信号：shopsbu001',
		a3156: '确认继续下架?',
		a3157: '供货商:',
		a3158: '已从分销平台上下架了产品:',
		a3159: ',如代理商已成功代理上架该产品的请自行变更该商品的状态!',
		a3160: '成功',
		a3161: '确定参加分销扩客活动吗？',
		a3162: '订单/仓库编码查询',
		a3163: '无订单纪录',
		a3164: '总供货价',
		a3165: '供货商实收',
		a3166: '供货单价',
		a3167: '订单状态：',
		a3168: '待处理',
		a3169: '条订单纪录,是否继续执行该操作？',
		a3170: '退回积分',
		a3171: '拒绝积分',
		a3172: '批量同意',
		a3173: '批量驳回',
		a3174: '批量自建订单',
		a3175: '积分已退回',
		a3176: '照片/视频',
		a3177: '以下是品牌方视频素材，可用于TIKTOK等视频，注意二次剪辑，去重!',
		a3178: '链接',
		a3179: '提取码',
		a3180: '填写完成，立即下单',
		a3181: '选择购买数量',
		a3182: '立即下单',
		a3183: '立即购买',
		a3184: '成功提交订单！',
		a3185: '密码',
		a3186: '请输入用户Id或者手机号',
		a3187: '登 录',
		a3188: '没有帐号？点击注册',
		a3189: '现货分销',
		a3190: '分销操作指引',
		a3191: '中国测品仓上架分销操作指引',
		a3192: '供货商上架分销操作指引',
		a3193: '代理商代理上架操作指引',
		a3194: '从中国深圳测品仓快速空运直发东南亚本土(3天达),不含空运费',
		a3195: '去中国采购',
		a3196: '中国批发货源充足，支持一件免费拿样，在首次批量订货后 即可退回样品费，点击可以直接采购，或联系店小生客服人员。',
		a3197: '全部地区',
		a3198: '指南',
		a3199: '全部国家',
		a3200: '上传图片失败',
		a3201: '确认要删除该会话吗?',
		a3202: '会话删除成功',
		a3203: '请选择会话对象！',
		a3204: '刷新会话',
		a3205: '分销商',
		a3206: '历史发布纪录',
		a3207: '发布的店铺',
		a3208: '发布时间',
		a3209: '发布状态',
		a3210: '发布失败',
		a3211: '重新编辑发布',
		a3212: '批量上架到TIKTOK',
		a3213: '生成 零售商城页',
		a3214: '代理商操作指引',
		a3215: '部分下架',
		a3216: '产 品 发 布',
		a3217: '成功删除纪录！',
		a3218: '勾选产品后再操作',
		a3219: '本次操作将删除',
		a3220: '个纪录，请确认是否继续？',
		a3221: '加入购物车',
		a3222: '商务咨询',
		a3223: '请输入内容...',
		a3224: '我的供货',
		a3225: '代单商出单',
		a3226: '货源所在地',
		a3227: '拒绝退回备注:',
		a3228: '拒绝退回',
		a3229: '移入套餐库',
		a3230: '所属套餐',
		a3231: '所配赠品',
		a3232: '手动创建在仓单品子sku',
		a3233: '确认要移入套餐库吗?',
		a3234: '已移入套餐库！',
		a3235: '零售原价-(当地货币)',
		a3236: '供货价-(单位/¥)',
		a3237: '关联cusCode',
		a3238: '已同意申请',
		a3239: '上传照片/视频',
		a3240: '已驳回申请',
		a3241: '成功自建订单，请往前:我的订单模块进行查看',
		a3242: '充值&报价',
		a3243: '请上传图片/视频',
		a3244: '我 的 申 请',
		a3245: '代理商样品申请',
		a3246: '仓租费',
		a3247: '打包费',
		a3248: '未选择商品的品牌属性',
		a3249: '重复的sku销售属性',
		a3250: '成功发布！',
		a3251: '红色星号的商品属性为必填项',
		a3252: '系统异常',
		a3253: 'sku名称长度不超过20个字符',
		a3254: '红色星空属性为必填',
		a3255: '商品标题字符长度应在20~100个字符之间',
		a3256: '当前店铺已存在商品标题相同的产品！',
		a3257: 'sku零售价，最大除最小的超值不能大于7',
		a3258: '海外仓',
		a3259: '默认打印面单&拣货单',
		a3260: '暂无绑定仓库',
		a3261: '暂无绑定商店',
		a3262: '订单出库费支出',
		a3263: '订单出库费收入',
		a3264: '入库单上架费支出',
		a3265: '入库单上架费收入',
		a3266: '退货处理费支出',
		a3267: '退货处理费收入',
		a3268: '平台划扣',
		a3269: '订单出库费支出(P)',
		a3270: '订单出库费收入(P)',
		a3271: '入库单上架费支出(P)',
		a3272: '入库单上架费收入(P)',
		a3273: '样品申请费支出',
		a3274: '样品申请费收入',
		a3275: '产品的描述信息在2-3000个字符之间',
		a3276: '出库费收入',
		a3277: '上架费收入',
		a3278: '退换货收入',
		a3279: '仓库杂费收入',
		a3280: '仓租费收入(P)',
		a3281: '平台划扣收入',
		a3282: '平台划扣支出',
		a3283: '上架费收入(P)',
		a3284: '出库费收入(P)',
		a3285: '采购订单',
		a3286: '全款采购',
		a3287: '定金采购',
		a3288: '定金：',
		a3289: '尾款：',
		a3290: '尾款支付：',
		a3291: '提醒支付尾款',
		a3292: '已成功发送消息提供采购商支付尾款',
		a3293: '产品采购费收入',
		a3294: '请上传尺码表',
		a3295: '尺码表',
		a3296: '产品采购费支出',
		a3297: '已拒绝退回积分',
		a3298: '分销平台代理费支出',
		a3299: '分销平台代理费收入',
		a3300: '当前积分不足，请充值后再试',
		a3301: 'Payssion充值收入',
		a3302: 'Payssion充值支出',
		a3303: '分销成功，请到“我已代理”进行查看',
		a3304: '请确认是否要分销此产品？',
		a3305: '扫描下载APP',
		a3306: '分销平台APP(安卓)',
		a3307: '多级分销产品',
		a3308: '分销一级返佣支出',
		a3309: '分销一级返佣收入',
		a3310: '分销二级返佣支出',
		a3311: '分销二级返佣收入',
		a3312: '分销三级返佣支出',
		a3313: '分销三级返佣收入',
		a3314: '多级分销统计',
		a3315: '总代理数量',
		a3316: '总代理采购额',
		a3317: '总收入佣金',
		a3318: '搜索代理帐号',
		a3319: '代理等级',
		a3320: '代理帐号',
		a3321: '一级推广人',
		a3322: '二级推广人',
		a3323: '三级推广人',
		a3324: '总采购额',
		a3325: '总佣金',
		a3326: '代理分析',
		a3327: '采购额',
		a3328: '佣金',
		a3329: '修改店铺',
		a3330: '产品库存Token',
		a3331: '美区订单发货Token',
		a3332: '欧区订单发货token',
		a3333: '店铺币种',
		a3334: '请填写店铺ID',
		a3335: '请填写店铺名',
		a3336: '请选择店铺类型',
		a3337: '美国',
		a3338: '英国',
		a3339: '德国',
		a3340: '意大利',
		a3341: '法国',
		a3342: '西班牙',
		a3343: '半托管',
		a3344: '全托管',
		a3345: '本土店铺',
		a3346: '香港主题店铺',
		a3347: '非香港主体店铺',
		a3348: '物流状态',
		a3349: '已在线下单',
		a3350: '未在线下单',
		a3351: '图 库 管 理',
		a3352: '定制图库',
		a3353: '创建图版',
		a3354: '暂无图版',
		a3355: '创建母版型',
		a3356: '版面名称',
		a3357: '版面类型',
		a3358: '版面型号',
		a3359: '尺寸型号',
		a3360: '颜色名称',
		a3361: '尺寸',
		a3362: '颜色',
		a3363: '请输入版面名称',
		a3364: '请选择版面类型',
		a3365: '请输入版本型号',
		a3366: '请上传图片',
		a3367: '请输入尺寸型号',
		a3368: '请输入颜色名称',
		a3369: '1、店小生-提供跨境出海本地化的海外仓及分销解决方案',
		a3370: '2、店小生-专注于中小件美区/东南亚的本地化服务',
		a3371: '请填写邀请码，暂仅限内邀用户，可联系客服微信号:shopsbu001',
		a3372: '同步商品链接',
		a3373: '平台处理中',
		a3374: '批量查询不能超过200个！',
		a3375: '批量上架至TEMU',
		a3376: '批量上架产品至TEMU',
		a3377: '下载导入模板',
		a3378: '点击 下载批量上架产品 到TEMU后台的模板',
		a3379: '导入上架产品文件',
		a3380: `1、本模板只适用于非服装类目，目前只开放 浴室防滑垫；沙滩毛巾；小盖毯、午休毯；以上三个类目。<br>
                            2、货品类目与属性模板存在对应关系，需按照对应的模板规则填写。<br>
                            3、产品标题长度校验：{ A.长度限制100[cat1Id=1(CD和黑胶唱片)] B.长度限制200[cat1Id=653(办公用品)，cat1Id=25439(玩具与游戏)]
                            C.长度限制500[cat1Id=2542(电子)] D.除去以上4个分类,其他长度限制250}。<br>
                            4、产品分类：A.浴室防滑垫[11802] B.沙滩毛巾[11809] C小盖毯、午休毯[11901] 请复制以上分类填写。`,
		a3381: '[重要提示!!!]请确保您上传的表格数据准确无误。',
		a3382: '批量上架表格提交后，系统将自动处理且无法中断或撤销。',
		a3383: '请务必仔细检查表格内容,确认无误后再提交，以避免因数据错误导致的损失。',
		a3384: '平台对因数据不准确或操作失误造成的后果不承担责任。',
		a3385: '开始导入',
		a3386: '导入记录',
		a3387: '文件名',
		a3388: '文件总数',
		a3389: '待执行',
		a3390: '执行中',
		a3391: '已执行',
		a3392: '已停止',
		a3393: '执行进度',
		a3394: '上架成功数',
		a3395: '上架失败记录',
		a3396: '开始时间',
		a3397: '结束时间',
		a3398: '停止',
		a3399: '标品图库',
		a3400: '平台热图',
		a3401: '选择分组',
		a3402: '批量发布到平台图库',
		a3403: '图库分组',
		a3404: '创建分组',
		a3405: '请输入分组名称',
		a3406: '定制内容',
		a3407: '大写',
		a3408: '小写',
		a3409: '请上传后缀.xlsx的文件!',
		a3410: '文件正在上传之中，请勿关闭页面，等待系统提示成功！',
		a3411: '是否停止上架？停止后无法继续上架，需要重新提交表格?',
		a3412: '是否停止上架并删除此表格？',
		a3413: '该表格已上架完成，是否删除此记录？',
		a3414: '是否删除此表格？',
		a3415: '出库后异常数',
		a3416: '分销价',
		a3417: '请输入分销价！',
		a3418: '下载此单打印图',
		a3419: '批量下载打印图',
		a3420: '图片生成中',
		a3421: '暂无需要下载的图片',
		a3422: '打印图需要分辨率150DPI，经校验目前打印图是',
		a3423: 'DPI，请重新提交！',
		a3424: '批量下载面单',
		a3425: '请稍后，系统正在自动审核打印图分辨率、物流信息等，请稍安勿躁！',
		a3426: 'POD产品如涉及同款同码同图购买多件的情况，需要添加多个仓库产品，提供多个打印图，例如采购2件同款同码产品，需要分别添加1件仓库单品提交2个相同打印图。',
		a3427: 'xxxxx',
		a3428: 'xxxxx',
		a3429: 'xxxxx',
		a3430: 'xxxxx',
		a3431: 'xxxxx',
		a3432: 'xxxxx',
		a3433: 'xxxxx',
		a3434: 'xxxxx',
		a3435: 'xxxxx',
		a3436: 'xxxxx',
		a3437: 'xxxxx',
		a3438: 'xxxxx',
		a3439: 'xxxxx',
		a3440: 'xxxxx',
		a3441: 'xxxxx',
		a3442: 'xxxxx',
		a3443: 'xxxxx',
		a3444: 'xxxxx',
		a3445: 'xxxxx',
		a3446: 'xxxxx',
		a3447: 'xxxxx',
		a3448: 'xxxxx',
		a3449: 'xxxxx',
		a3450: 'xxxxx',
		a3451: 'xxxxx',
		a3452: 'xxxxx',
		a3453: 'xxxxx',
		a3454: 'xxxxx',
		a3455: 'xxxxx',
		a3456: 'xxxxx',
		a3457: 'xxxxx',
		a3458: 'xxxxx',
		a3459: 'xxxxx',
		a3460: 'xxxxx',
		a3461: 'xxxxx',
		a3462: 'xxxxx',
		a3463: 'xxxxx',
		a3464: 'xxxxx',
		a3465: 'xxxxx',
		a3466: 'xxxxx',
		a3467: 'xxxxx',
		a3468: 'xxxxx',
		a3469: 'xxxxx',
		a3470: 'xxxxx',
		a3471: 'xxxxx',
		a3472: 'xxxxx',
		a3473: 'xxxxx',
		a3474: 'xxxxx',
		a3475: 'xxxxx',
		a3476: 'xxxxx',
		a3477: 'xxxxx',
		a3478: 'xxxxx',
		a3479: 'xxxxx',
		a3480: 'xxxxx',
		a3481: 'xxxxx',
		a3482: 'xxxxx',
		a3483: 'xxxxx',
		a3484: 'xxxxx',
		a3485: 'xxxxx',
		a3486: 'xxxxx',
		a3487: 'xxxxx',
		a3488: 'xxxxx',
		a3489: 'xxxxx',
		a3490: 'xxxxx',
		a3491: 'xxxxx',
		a3492: 'xxxxx',
		a3493: 'xxxxx',
		a3494: 'xxxxx',
		a3495: 'xxxxx',
		a3496: 'xxxxx',
		a3497: 'xxxxx',
		a3498: 'xxxxx',
		a3499: 'xxxxx',
		a3500: 'xxxxx',
	}



}


export default zh

